export const kz: { [key: string]: string } = {
  subscribe_with_click: 'Басу арқылы жазылыңыз',
  form_title: 'Біз сізбен жақын арада хабарласамыз',
  form_required: '* Белгіленген жолдар толтыруға міндетті',
  form_name_placeholder: 'Аты',
  form_email_placeholder: 'Электрондық пошта',
  form_phone_placeholder: 'Телефон нөмірі',
  form_company_placeholder: 'Компания',
  form_submit: 'Жіберу',
  form_1: 'Жеке деректерді өңдеуге келісімімді беремін',
  form_2: 'Құпиялылық саясаты',
  validation_privacy_policy: 'Құпиялылық саясатын қабылдауыңызды сұраймын',
  validation_phone: 'Телефон нөмірі жарамсыз',
  validation_email: 'Дұрыс емес электрондық пошта форматы',
  validation_required: 'Міндетті жолдар толтырылмаған',
  submit_error: 'Форматты сақтау кезінде қате болды',
  footer_1: 'Біздің серіктестер:',
  footer_2: 'Әдістер',
  footer_3: 'Өнімдер',
  footer_4: 'Байланыстар:',
  footer_5: 'Шығыс деректер',
  footer_6: 'Құпиялылық саясаты',
  about_us_1: '4Service корпоративтік әлеуметтік жауапкершілігі',
  about_us_2:
    'Командамыздың әрбір мүшесінің шын жүрегінен. Біз әрбір қызметкеріміздің бойында мейірімділік ұшқынын қолдап, айналамыздағы әлемді жақсартуға тырысамыз.',
  about_us_3: '4Service корпоративтік әлеуметтік жауапкершілігі',
  about_us_4:
    'Командамыздың әрбір мүшесінің шын жүрегінен. Біз әрбір қызметкеріміздің бойында мейірімділік ұшқынын қолдап, айналамыздағы әлемді жақсартуға тырысамыз.',
  about_us_5: 'Service Mania іскерлік ойыны',
  about_us_6: 'Балалар мен студенттерге арналған ақпараттық бастамаларымыз',
  about_us_7: 'Қайырымдылық/еріктілік',
  about_us_8:
    'Балалар үйлері, қарттар үйлері және Украина армиясындағы еріктілер. Біздің қызметіміздің ең әсерлі бөлігі',
  about_us_9: 'Жануарлардың амандығы',
  about_us_10:
    'Асыранды жануарлары бар кез келген адам біздің кеңсеге келе алады. Біз паналарға көмектесеміз, азық-түлікке қаражат жинаймыз, кейде үйсіз жануарларға үй табуға тырысамыз ',
  about_us_11: '4Service тобы',
  about_us_12:
    'Клиенттік тәжірибені басқарумен айналысатын халықаралық зерттеу компаниясы.',
  about_us_13:
    'Біз сатылымдарды арттыру және тұтынушыға бағытталған компаниялардың бизнесін дамыту үшін кешенді жобаларды жүзеге асырамыз.',
  about_us_14:
    '4Service - штаб-пәтері Венада (Австрия) орналасқан халықаралық зерттеу холдингі. Компания 2001 жылы өз тұтынушыларының және бизнеспен өзара әрекеттесетін, оның қызметтерін пайдаланатын және оның өнімдерін тұтынатын адамдардың өмір сүру сапасын жақсарту мақсатында құрылған. `Forservice` атауының таңдалуы кездейсоқ емес - компания жоғары стандарттар мен тұтынушыларға қызмет көрсетуді жүзеге асырады',
  about_us_15:
    '4Service тарихы Киевте (Украина) басталды, онда компания жасырын сатып алу қызметтерінің жетекші жеткізушісі болды. Зерттеу холдингі ретінде біз 52 елде табысты жұмыс істейміз, клиенттік тәжірибенің бүкіл тізбегін талдауға және жақсартуға кешенді көзқарастың жаңа мүмкіндіктерін ашамыз.',
  about_us_16: 'қызмет көрсету негізі',
  about_us_17: 'Украинадан тыс бірінші кеңсе',
  about_us_18: 'Штаб-пәтерді Венаға көшіру',
  about_us_19: 'MSPA элиталық мүшесі, Еуропадағы үздік 10 агенттік',
  about_us_20: '9 елде кеңселер ашу',
  about_us_21: 'алғашқы цифрлық жобалар, Voicer',
  about_us_22: 'DesignThinkers Academy серіктестері',
  about_us_23: 'алғашқы жаһандық CX жобалары',
  about_us_24: 'Миссия',
  about_us_25:
    'Біздің миссиямыз - бүкіл әлем бойынша тұтынушыларға қызмет көрсетуді жақсарту! Біз жұмыс істейтін адамдар мен компаниялардағы сапалы өзгерістерден шабыттанамыз.',
  about_us_26: 'Клиенттермен жұмыс істеу тәжірибесі 20 жылдан астам',
  about_us_27: '95 ел',
  about_us_28:
    'Біз дүние жүзіндегі ең жақсы салалық тәжірибелерді жинап, бөлісеміз',
  about_us_29: 'Бас кеңсе Венада',
  about_us_30:
    'елдер. Біз әлемнің түкпір-түкпірінен ең жақсы салалық тәжірибені жинап, бөлісеміз',
  about_us_31: 'қызмет көрсету сапасын бағалау',
  about_us_32:
    'біз клиенттердің тәжірибесін басқару жөніндегі Еуропалық 10 агенттіктің қатарына кіреміз',
  about_us_33: 'Австриядағы өкілдіктер/бас кеңселер',
  about_us_34: 'белсенді жобалар',
  about_us_35: 'Сіздің болашақ жұмыс орныңыз',
  about_us_36: 'Біздің кеңселер',
  about_us_37:
    '4Service™ өз қызметкерлері үшін ыңғайлы жұмыс кеңістігін құру бойынша жұмыс істейді. Ыңғайлы және максималды өнімділік үшін әр қызметкер жұмыс форматын өзі таңдай алады: кеңседе, қашықтан немесе гибридті. Сонымен қатар, компания демалыс бөлмелері, тегін психологиялық қолдау және мейірімді атмосфера туралы қамқорлық жасады. Біз адамдарға ғана емес, үй жануарларына да ашықпыз.',
  about_us_38: 'Керемет команда',
  about_us_39:
    'Біздің клиенттеріміздің пікірлері және өзара даму — біздің көпұлтты команда үшін басымдық. Біздің клиенттің ынтымақтастық кезіндегі жолы біздің бизнесіміз үшін жаңа өнімдерді шығару немесе қаржылық мақсаттарға жету сияқты маңызды. Біз қауымдастықтарға оң әсер ету және тұтынушыларымызға адамдарға бағытталған инновациялық шешімдерді ұсыну үшін жұмыс істейміз',
  about_us_40: 'Барлығы',
  about_us_41: 'Басқару',
  about_us_42: 'Әлем командасы',
  about_us_43: 'Өнім иелері',
  about_us_44: 'Біздің серіктестер',
  about_us_45:
    'Біз сатылымдарды арттыру және тұтынушыға бағытталған компаниялардың бизнесін дамыту бойынша кешенді жобаларды жүзеге асырамыз',
  about_us_46:
    'дизайнға бағытталған жетекші кәсіптік оқыту институттарының бірі. Ол 25 елде ұсынылған. Мұнда шығармашылық көпсалалы командалар мен қауымдастықтар оқиды, дамиды және қолдау көрсетеді. Дизайнды ойлау инновациялық идеяларды дамытуға, өзгерістер ұсынуға және күрделі мәселелерді шешуге мүмкіндік береді.',
  about_us_47:
    'Олардың миссиясы командалар мен жеке тұлғаларды шабыттандырып, сынау үшін кеңістік пен уақытты қамтамасыз ету, осылайша олар `істеп үйрену` және проблемаларды шығармашылықпен шешу қабілеттерін күшейту және ұйымдарға батыл инновацияларды енгізу үшін қажетті орта мен сананы құруға көмектесу.',
  about_us_48:
    'Mystery Shopping индустриясымен айналысатын компаниялардың сауда қауымдастығының өкілі болып табылады. Қауымдастық бүкіл әлем бойынша аймақтық негізде жұмыс істейді, оның филиалдары Америкада, Еуропада, Африкада, Азияда және Тынық мұхиты аймағында орналасқан. Мүше компаниялар Mystery Shopping индустриясын бірлесіп нығайту үшін бірігеді',
  about_us_49:
    'Бұл коммерциялық емес мүшелік ұйым. Мүшелері қоғамды, ұйымдарды және әрбір адамның өмірін жақсартуға көмектесетін деректерді талдау, зерттеулер мен идеялар әлеуетіне сенімді қауымдастық құрады.',
  about_us_50:
    'ESOMAR штаб-пәтері Амстердамда, Нидерландыда орналасқан. ESOMAR 1947 жылдан бері мүшелері арқылы 130-дан астам елде бар.',
  about_us_51:
    '(UCCA) — байланыс орталығы мен тұтынушыларға қызмет көрсету саласындағы даму және өзара әрекеттесу мақсатымен біріктірілген жеке мамандар мен компаниялардың кәсіби қоғамдастығы. UCCA философиясы заманауи технологиялар мен жоғары стандарттар негізінде байланыс орталығы индустриясының мәдениетін арттыру болып табылады.',
  about_us_52:
    'Украина нарығында оны бейімдеу және пайдалану үшін білім берудегі ең жақсы әлемдік тәжірибені зерттейді. Сондықтан ДТЭК академиясы INSEAD, IE Business School және Stanford University сияқты жетекші халықаралық бизнес-мектептермен ынтымақтасады.',
  about_us_53:
    'Украина нарығында бейімделу және пайдалану үшін білім беру саласындағы үздік әлемдік тәжірибені зерттейді. Сондықтан DTEK академиясы жетекші халықаралық бизнес мектептерімен ынтымақтасады: INSEAD, IE Business School және Stanford University.',
  about_us_54:
    'DTEK академиясы D.Client School, ID School, Executive Education: Innovation Energy, Communications Power, DX School цифрлық бағдарламасы, Тиімді көшбасшы: Pre-MBA, Change Energy-де тұтынушыға бағытталған және инновациялық мәдениетті дамытуға бағытталған. .',
  about_us_55: 'Сергей Пашковский',
  about_us_56: 'Виктория Скорбота',
  about_us_57: 'Артем Фомин',
  about_us_58: 'Макс Папка',
  about_us_59: 'Халықаралық сатылымдар жөніндегі менеджер',
  bht_1: 'Қадағалау',
  bht_2: 'Брендтің саулығы',
  bht_3: 'Брендтердің керемет күші бар',
  bht_4: 'Брендіңіздің жалпы өнімділігі қаншалықты жақсы екенін біліңіз',
  bht_5: 'Бағдарлама туралы',
  bht_6: 'Брендтің саулығын қадағалау дегеніміз не?',
  bht_7:
    'Бұл ақпарат алу үшін белгілі бір жиілікте (әр екі апта сайын, ай сайын және т.б.) жүзеге асырылатын нарықты зерттеудің бір түрі',
  bht_8:
    'даңқ, сұраныс, имидж, оның тұтынушыларының сипаттамалары, бренд денсаулығы және т.б. сияқты көрсеткіштерге негізделген нарықтағы бренд мәртебесі',
  bht_9: 'Олар брендті жиі сатып алады',
  bht_10: 'Шын',
  bht_11: 'Брендті 3 айда бер рет сатып алады',
  bht_12: 'Тұрақты тұтынушылар',
  bht_13: '6 айға бренд сатып алады',
  bht_14: 'Қысқа мерзімдегі клиенттер',
  bht_15: 'Брендті бір жылға сатып алады',
  bht_16: 'Ұзақ мерзімді перспективадағы тұтынушылар',
  bht_17: 'Брендпен таныс, бірақ ешқашан пайдаланылмаған/сатып алынбаған',
  bht_18: 'Біледі, бірақ клиент емес',
  bht_19: 'Мен білмеймін: бренд туралы ешқашан естіген емеспін',
  bht_20: 'Таныстырылмаған',
  bht_21: 'Бренд сатып алушылар профилі',
  bht_22: 'Бренд құру үшін ұзақ мерзімді күш-жігердің реттілігін бағалау',
  bht_23: 'Тұтынушылардың бренд туралы білім деңгейін өлшеу',
  bht_24: 'Жарнамалық және ақпараттық науқандардың тиімділігін көрсету',
  bht_25:
    'Белсенді жарнама кезеңінің бәсекелестердің сатылымына / маркетингтік қызметіне әсерін анықтау',
  bht_26:
    'Үздіксіз нарықтық өзгерістер кезеңінде бизнес иесінің тұрақты бақылауын қамтамасыз ету',
  bht_27: 'BHT қандай мәселелерді шеше алады:',
  bht_28: 'Зерттеуді сұрау',
  bht_29: 'Шешілетін міндет',
  bht_30: 'мысалы,',
  bht_31:
    'егер компанияға нарық үлесін өлшеу кезінде тоқсанына бір ғана BЗБ сеансы қажет болса, респонденттерге сауалнама клиенттер арасында жарнамалық бренд туралы хабардарлықты өлшеу арқылы жиі жүргізілуі керек.',
  bht_32: 'CATI',
  bht_33: 'Сұхбат',
  bht_53: ' Бірге-бір',
  bht_34: 'CAWI',
  bht_35: 'Шешілетін міндет',
  bht_36: 'Ақпарат жинау',
  bht_37:
    'әр түрлі әдістер арқылы брендтің саулығын бақылау әдетте мақсатты аудиторияға және оның қолжетімділігінің күрделілігіне байланысты үш кезеңге бөлінеді:',
  bht_38:
    'Біз деректерді жинаудың дәстүрлі және инновациялық әдістерін қолданамыз.',
  bht_39:
    'Біз екі модельмен жұмыс істейміз: біреуі қарапайым көрсеткіштер жиынтығымен, ал екіншісі тамақ және қызмет көрсету саласы сияқты күрделі салаларға бағытталған. Неғұрлым күрделі модель 10 есептік көрсеткішті қамтитын терең зерттеуді қамтиды.',
  bht_40: 'Біз ұсынамыз',
  bht_41: 'бастапқы деректерді бақылау',
  bht_42: 'Біз қамтимыз',
  bht_43: 'бүкіл елді',
  bht_44: 'Біз шешімді ұсынамыз',
  bht_45:
    'Динамикалық емес нарықтар/шектеулі ойыншылар нарықтары үшін (Brand Point Analyze)',
  bht_46: 'Неге біз?',
  bht_47: 'Бізді неге таңдайды?',
  bht_50: 'Нашар нәтиже',
  bht_51: 'Жақсы нәтиже',
  bht_52: 'Орташа нәтиже',
  cases_1:
    'Тапсырма: Hyundai автосалондарында электромобильдерді сатып алу кезінде тұтынушыларға қызмет көрсету сапасын қалай жақсартуға болады?',
  cases_2: 'Клиенттің жол картасы',
  cases_3: 'Идея',
  cases_4: 'Сапалы зерттеу',
  cases_5:
    'Шақыру: Сатып алушылардың Oppo брендіне деген қызығушылығын ояту үшін дүкендерде (қызмет көрсету процесінде де, интерьерде де, брендті қабылдауда) нені өзгерту керек?',
  cases_6: 'Онлайн CJM',
  cases_7: 'Пайдаланушы интерфейсін тексеру',
  cases_8: 'Сұхбат',
  cases_9:
    'Шақыру: Сатып алушылардың Oppo брендіне деген қызығушылығын ояту үшін дүкендерде нені өзгерту керек?',
  cases_10: 'Сапа бөлігі',
  cases_11: 'Идея',
  cases_12: 'Сандық бөлік',
  cases_13: 'Клиенттің жол картасы',
  cases_14: 'Кейстер',
  cases_15: 'Барлығы',
  cases_16: 'Сіздің керемет кейсіңізді бірге жасайық',
  csi_1: 'Индекс',
  csi_2: 'Клиенттің қанағаттануы',
  csi_3: 'Тұтынушылардың қанағаттануын',
  csi_4: 'және қанағаттанбауының себептерін анықтаймыз',
  csi_5: 'Тұтынушылардың қанағаттануын зерттеу',
  csi_6:
    'сатып алушының сатып алу туралы шешіміне, сондай-ақ мақсатты аудиторияның мінез-құлқына әсер ететін факторларды, себептерді және уәждерді анықтау.',
  csi_7: 'Тұтынушылардың қанағаттануы туралы сауалнама',
  csi_8:
    'клиенттің қызметтің белгілі бір аспектісіне немесе жалпы өнімге қаншалықты қанағаттанғанын немесе қанағаттанбағанын көрсетеді.',
  csi_9: 'Қанағаттанушылық сауалнамасы',
  csi_10:
    'компанияның қолданыстағы клиенттері мен белгілі бір өнімдер/қызметтерді пайдаланушылар арасында жүзеге асырылады.',
  csi_11: 'CSI дегеніміз не?',
  csi_12:
    'Тұтынушылардың қанағаттануы Сіздің компанияңыз ұсынатын өнімді немесе қызметті сатып алуға қатысты тұтынушылардың үміттерін қанағаттандыру дәрежесін өлшейді.',
  csi_13: 'Бақытты адам',
  csi_14: 'Бағдарлама туралы',
  csi_15: 'Клиенттердің қанағаттануына әсер ететін',
  csi_16: 'кез келген жасырын факторларды анықтаңыз',
  csi_17: 'тауарлар мен қызметтерге сұраныстың өсуі/төмендеуінің',
  csi_18: 'себептерін анықтау',
  csi_19: 'Компанияның бизнес-процестерін',
  csi_20: 'оңтайландыру',
  csi_21: 'Қазіргі тұтынушының қажеттіліктері үшін',
  csi_22: 'оларды бейімдеу',
  csi_23: 'Тиімді жарнамалық хабарлама қалыптастыру',
  csi_24: 'және клиенттің сұранысы бойынша өнімді орналастыру',
  csi_25: 'Шешуге арналған тапсырмалар',
  csi_26:
    'Клиенттердің қанағаттануы туралы сауалнамалар қандай тапсырмаларды шеше алады',
  csi_27: 'Телефоны бар адам',
  csi_28:
    'Біз клиенттердің қанағаттануына/адалдығына әсер етуі мүмкін факторлардың',
  csi_29: ' математикалық моделін құрамыз (регрессиялық талдау)',
  csi_30: 'Компанияның бизнес-процестерін',
  csi_31: 'оңтайландыру',
  csi_32: 'Біз клиенттердің қанағаттану индексін құрамыз',
  csi_33: '(CSI) және оны декларативтімен салыстырамыз',
  csi_34: 'Біз B2B және B2C сегменттері үшін',
  csi_35: 'зерттеу жүргіземіз',
  csi_36: 'Біздің сауалнамаларымызды',
  csi_37:
    'біздің клиенттердің жеке жобалары үшін арнайы талдаушылар командасы әзірлейді',
  csi_38: 'Неге біз',
  csi_39: 'Неге бізді таңдайды?',
  csi_40: 'Ақпарат жинау әдістері:',
  main_1:
    'Бизнес өз клиенттерінің тәжірибесін зерттеу арқылы қаржылық көрсеткіштерін жақсартады',
  main_2:
    'Клиенттік тәжірибе бойынша кеңестер мен қызметтер, Сіздің бизнесіңізге 360° көзқарас',
  main_3:
    'Сіздің бизнес тапсырмаларыңызды орындауға көмектесетін шешімдеріміз бен құралдарымызды ашыңыз',
  main_4: 'Өнімдер',
  main_5:
    'Сапалы зерттеу дегеніміз ұғымдарды, пікірлерді немесе тәжірибелерді түсіну үшін сандық емес деректерді жинау және талдау',
  main_6:
    'Сандық зерттеу әдістері - ол сауалнамалар мен сұрақ-жауап арқылы жиналған деректерді объективті өлшеу және сандық талдау',
  main_7:
    'Құпия сатып алушы - бұл алдын-ала белгіленген сценарий бойынша сатып алушы мен компания немесе ұйым арасындағы өзара әрекеттесуді өлшеу және бақылау үшін нарықты зерттеу әдісі',
  main_8:
    'Кері байланысты басқару жүйесі. Клиентіңіздің дауысы бір Customer Feedback Management System жүйесінде',
  main_9:
    'Аудиториядан ақпарат беретін ИИ негізіндегі мазмұнды талдау платформасы',
  main_10:
    'Өнімділікті басқаруға арналған бағдарламалық жасақтамасы. Сатылымды арттыруға арналған геймификацияланған қолданбасы',
  main_11:
    'Баға мониторингі - бұл бәсекелестердің бағаларын жинау, өңдеу және талдау процесі',
  main_12:
    'Қызмет дизайны - бұл өнімді немесе қызметті пайдаланатын, олармен уақыт өткізетін адамдардың қажеттіліктері мен тілектерін түсіну',
  main_13:
    'Біздің аналитикалық команда тиімділігі көптеген клиенттердің тәжірибесімен расталған ең заманауи және іргелі тәсілдерді қолданады',
  main_14: 'Әдіснамалар',
  main_15: 'Клиенттің жол картасы',
  main_16:
    'Customer Journey Mapping (CJM) - мақсатты аудиторияны анықтау, олардың қажеттіліктері мен ортасын түсіну, содан кейін тартымды тәжірибені қамтамасыз ету үшін жоспар құру',
  main_17: 'CJM',
  main_18: 'Таза жылжыту бағасы',
  main_19:
    'Net Promoter Score (NPS) көрсеткіші - бұл бір сұраққа негізделген тұтынушыларға қызмет көрсету сапасының алтын стандарты: сіз ұйымды/өнімді/қызметті қаншалықты ұсынуыңыз қаншалықты ықтимал?',
  main_20: 'NPS',
  main_21: 'Бренд салауаттылығын бақылау',
  main_22:
    'Brand Health tracking (BHT) зерттеуі сіздің брендтің танылуы мен қолданылуы, брендтің орналасуы және брендтің тиімділігі тұрғысынан қалай жұмыс істейтінін өлшеу',
  main_23: 'ВНТ',
  main_24: 'Адам ресурстарын зерттеу',
  main_25:
    'Адам ресурстарын зерттеу персоналдың тәжірибесі мен тиімділігін бағалау үшін қолданылады және қазіргі даму мен басқарудың егжей-тегжейлі талдауын ұсынады',
  main_26: 'Кадрлық зерттеулер',
  main_27: 'Тұтынушылардың қанағаттану индексі',
  main_28:
    'Тұтынушылардың қанағаттану индексі (CSI) – бұл сіздің клиенттеріңіздің компанияның өнімдеріне/қызметтеріне қаншалықты қанағаттанғанын көрсететін көрсеткіш.',
  main_29: 'CSI.',
  main_30: 'UX тестілеу',
  main_31:
    'Юзабилити-тестілеу (UX) - бұл нақты адамдардың веб-сайтпен, қосымшамен немесе басқа өніммен өзара әрекеттесуін, олардың мінез-құлқын және оған реакциясын бақылау',
  main_32: 'Неге біз',
  main_33:
    'Біздің миссиямыз — компанияларға клиенттердің оң тәжірибесін құруға көмектесу',
  main_34: 'Сапа — ең алдымен',
  main_35: 'Біз сапаны басқарамыз',
  main_36:
    'зерттеу деректері. Барлық деректер жиынтығы клиенттер үшін қолжетімді',
  main_37: 'Экономикалық тиімділік',
  main_38: 'Біздің тәжірибеміз, ресурстарымыз және оңтайландыруымыз',
  main_39:
    'Бизнес-процестер - бұл сіздің ақшаңыз бен уақытыңызды үнемдейтін нәрсе',
  main_40: ' Ақылды шешімдер',
  main_41: 'Біз әртүрлі техникаларды',
  main_42: 'және нақты мәселелерді шешуге арналған құралдард қолданамыз',
  main_43: 'Сапаға баса назар аудару',
  main_44: 'Біз сапаны басқарамыз',
  main_45:
    'Зерттеу деректері туралы сөз болғанда. Біз барлық деректер жиынтығын клиенттерге қол жетімді етеміз',
  main_46: 'Ттиімді және үнемді',
  main_47: 'Біздің тәжірибеміз, ресурстарымыз және оңтайландыруымыз',
  main_48:
    'бизнес-процестер сіздің ақшаңыз бен уақытыңызды үнемдеуге мүмкіндік береді',
  main_49: ' Ақылды шешімдер',
  main_50: 'Біз әртүрлі техникаларды',
  main_51:
    'және сіздің нақты мәселелеріңізді шешуге арналған құралдарды қолданамыз',
  main_52: 'Cash & Carry',
  main_53: 'Электроника',
  main_54: 'Люкс/Премиум',
  main_55: 'Мейрамханалар мен қонақ үй бизнесі',
  main_56: 'Бөлшек сауда',
  main_57: 'Автомобиль құрылысы',
  main_58: 'Сән',
  main_59: 'Банктер',
  main_60: 'Саяхат және демалыс',
  main_61: 'Сағат және әшекейлер',
  main_62: 'Тұрмыстық техника',
  main_63: 'Блог',
  main_64: 'Қосымша қызықты бизнес оқиғаларын оқу үшін блогқа өтіңіз',
  main_65: 'Бөлшек сауда аудиті`',
  cjm_1: 'Карта',
  cjm_2: 'клиент жолдары',
  cjm_3: 'Клиенттер әлеміне еніп, олардың тәжірибесімен бөлісіңіз',
  cjm_4: 'Клиенттің жол картасы дегеніміз не?',
  cjm_5:
    'CJM (Customer Journey Map) тұтынушының өніммен, қызметпен, компаниямен немесе брендпен әр түрлі арналар арқылы және белгілі бір уақыт аралығында өзара әрекеттесуінің сыртқы шолу тарихын ұсынады.',
  cjm_6:
    'Бұл компанияларға тұтынушылардың тәжірибесін объективті түрде талдауға, пайда болған кедергілерді түзетуге және жоюға және өнімді жақсарту бойынша ұсыныстар беруге мүмкіндік береді.',
  cjm_7: 'ЦА анықтау, сегменттеу',
  cjm_8: 'Клиентен өзара әрекеттесу кезеңдерін анықтау',
  cjm_9: 'Клиенттермен өзара әрекеттесудің негізгі арналарын анықтау',
  cjm_10: 'Клиенттік тәжірибені зерттеу',
  cjm_11: 'Кедергілерді талдау және оңтайландыру гипотезасы',
  cjm_12: 'Гипотезаларды орындау және тексеру',
  cjm_13: 'Клиенттің жол картасын жасау келесі қадамдардан тұрады:',
  cjm_14: 'Клиенттің жол картасы көрсетеді:',
  cjm_15:
    'CJM тұтынушының өніммен, қызметпен, компаниямен немесе брендпен әр түрлі арналар арқылы және белгілі бір уақыт аралығында өзара әрекеттесуінің сыртқы шолу тарихын ұсынады.',
  cjm_16: 'Біз Талдаушылар мен дизайнерлер арасындағы',
  cjm_17: 'командалық жұмысты қамтамасыз етеміз',
  cjm_18: 'Әр клиентппен жеке',
  cjm_19: 'жеке жұмыс жасауды ұсынамыз',
  cjm_20:
    'Тұтынушылардың қызметке/өнімге қанағаттануын арттыру және сайып келгенде олардың компанияға деген адалдығын арттыру ',
  cjm_21: ' үшін бізде құралдар бар',
  cjm_22:
    'Біз тұтынушы жолын оңтайландыруға және компанияның бизнес-процестерін есепке алуға',
  cjm_23: 'кепіл береміз',
  cjm_24:
    'Біз біріктірілген тәсілдерді қолдану мүмкіндігі: CATI, CAWI, фокус-топтар, терең сұхбат, сараптамалық сұхбат, этнография және т. б.',
  cjm_25: 'өз клиенттерімізге ұсынамыз.',
  cjm_26: 'Ннеге бізді таңдайды?',
  methodss_hr_1: 'ерсоналды басқаруды зерттеу',
  methodss_hr_2:
    'Командаңыз туралы объективті ақпарат алыңыз және кадрлар бөлімін қалай жақсартуға болатындығын біліңіз',
  methodss_hr_3: 'Сізге HR зерттеуі қажет болуы мүмкін бірнеше себептер',
  methodss_hr_4: 'Сауалнамаға қатысқан қызметкерлер',
  methodss_hr_5: ' іске асырылған HR-жобалар',
  methodss_hr_6: 'қызметкерлерді оқыту',
  methodss_hr_7:
    'Клиенттердің тәжірибесі мен қызметкерлерді зерттеу саласындағы жетекші еуропалық холдинг',
  methodss_hr_8: 'Сандардағы 4service кадрлық зерттеулері',
  methodss_hr_9:
    'Сіздің компанияңыздың қызметкерлерінің өмірінің әр кезеңінде проблемалар мен әлсіз жақтарын анықтау: іздеу/іріктеу/бейімдеу/мансаптық өсу/қайта аттестаттау',
  methodss_hr_10: 'Қандай жағдайлар өсім мен бонустарға лайық екенін білу үшін',
  methodss_hr_11:
    'Сізге қызметкерлердің қанағаттанбауының шешімдерін болжау немесе ұсыну қажет',
  methodss_hr_12:
    'HR зерттеулерінің арқасында кадр саясатын бағалаудың жаңа әдістерін, заманауи бағдарламалар мен тәжірибелерді енгізуге болады',
  methodss_hr_13:
    'Компания қызметкерлерінің психикалық денсаулығын жақсарту үшін',
  methodss_hr_14: 'Егер сіз мақсатты тәсілмен өнімділікті арттырғыңыз келсе',
  methodss_hr_15:
    'Егер сізде халықаралық және/немесе қашықтағы команда болса және оны басқару қажет болса',
  methodss_hr_16:
    'Сіздің жұмыс беруші брендіңіз әлеуетті қызметкерлер үшін қаншалықты тартымды екенін түсіну үшін',
  methodss_hr_17: 'Қызметкерлердің қанағаттануы',
  ethodss_hr_18: 'HR-брендингті зерттеу',
  methodss_hr_19: 'Мәдени әртүрлілік',
  methodss_hr_20: 'Өтемақы және жалақы жоспарлары',
  methodss_hr_21: 'Команданың қатысуы және адалдығы',
  methodss_hr_22: 'Қорғалған кластағы қызметкерлер',
  methodss_hr_23: 'Зерттеу облыстары',
  methodss_hr_24: 'Шешім 1',
  methodss_hr_25:
    'eNPS, қызметкерлердің қанағаттануы, қызметкерлердің адалдығы',
  methodss_hr_26: 'Біз нені өлшейміз:',
  methodss_hr_27: 'Адалдық:',
  methodss_hr_28:
    'қызметкерлердің адалдығы, болашақ мінез-құлықты болжау, адалдыққа әсер ететін факторлардың салмағын анықтау',
  methodss_hr_29: 'Қатысу:',
  methodss_hr_30:
    'қызметкерлерді жұмысқа тарту, нәтижелер мен жетістіктерге мүдделілік',
  methodss_hr_31: 'Қатыстыру:',
  methodss_hr_32:
    'қызметкерлердің құндылықтары мен компания құндылықтарын сәйкестендіру',
  methodss_hr_33: 'Сенім 360:',
  methodss_hr_34:
    'басшылыққа, әріптестерге, бағыныштыларға сенім, жұмыс берушінің стратегиялары мен саясатына сенім',
  methodss_hr_35: 'Қанағаттану:',
  methodss_hr_36:
    'Әр компания үшін бірегей факторларды анықтау, адалдыққа әсер ететін әрбір негізгі фактор бойынша қанағаттанушылықты бағалау',
  methodss_hr_37: 'Шешім 2',
  methodss_hr_38: 'Жұмыс берушінің бренді',
  methodss_hr_39: 'Жұмыс берушінің брендін',
  methodss_hr_40:
    'ішкі талдау (қызметкерлердің, стейкхолдерлердің, ішкі рекрутерлердің және HR мамандарының сауалнамасы)',
  methodss_hr_41: 'Жұмыс берушінің сыртқы талдауы',
  methodss_hr_42:
    '(EVP бәсекелестердің талдауы, сыртқы рекрутерлердің сауалнамасы, жұмыс іздеушілердің сауалнамасы)',
  methodss_hr_43: 'Брендтің танымалдылығы және беделі',
  methodss_hr_44: 'талдау',
  methodss_hr_45: 'Жұмыс берушінің қатысуы',
  methodss_hr_47: 'Жұмыс берушінің анықтамалығы',
  methodsshr_48: 'жинақ',
  methodss_hr_49: 'Негізгі факторлар бойынша',
  methodss_hr_50: 'бәсекелестік бенчмаркинг, мәселен мынадай',
  methodss_hr_51: 'Жалақы,',
  methodss_hr_52: 'жұмыс ортасы, атмосфера, жұмыс сипаты',
  methodss_hr_53: 'Қажеттіліктер мен күтулерді, ',
  methodss_hr_54: 'ізденушілерді талдау',
  methodss_hr_55: 'Толық сұхбат',
  methodss_hr_56: 'кабинеттік және сандық зерттеулер қолданылады',
  methodss_hr_57: 'Шешім 3',
  methodss_hr_58: 'қызметкердің жол картасы/құпия қызметкер',
  methodss_hr_59: 'Жұмыс іздеу жолын құру,',
  methodss_hr_60:
    'іздеудің негізгі кезеңдерін, байланыс арналарын, үміткерлерді таңдау және бағалау критерийлерін анықтау',
  methodss_hr_61: 'Барлық кезеңдер мен байланыс арналарын ',
  methodss_hr_62:
    'құпия ізденушілердің көмегімен бақылау (сұхбатқа жазылу, сұхбаттасу, компанияда тағылымдамадан өту)',
  methodss_hr_63: 'Жалдау және бейімделу процестеріндегі әлсіз жақтарды',
  methodss_hr_64: 'сәйкестендіру',
  methodss_hr_65: 'Жақсарту бойынша ұсыныстар,',
  methodss_hr_66: 'Аймақ көшбасшыларымен салыстырмалы талдау',
  mystery_shopping_1: 'Құпия',
  mystery_shopping_2: 'сатып алушы',
  mystery_shopping_3: 'Нақты клиенттермен қызметіңізді бағалаңыз',
  mystery_shopping_4:
    'Қызметкерлеріңізді клиентке жақындату үшін стандарттарды тексеріңіз',
  mystery_shopping_5:
    'Біз Mystery Shopping Providers MSPA Europe қызметтерін жеткізушілердің жетекші кәсіби қауымдастығының элиталық мүшесіміз',
  mystery_shopping_6: 'тәжірибе',
  mystery_shopping_7: 'бүкіл әлем бойынша құпия сатып алушылардың ',
  mystery_shopping_8: ' ай сайынғы келулері',
  mystery_shopping_9: 'белсенді жобалар',
  mystery_shopping_10: 'Австриядағы кеңселер, штаб-пәтерлер',
  mystery_shopping_11: 'Еуропадағы құпия сатып алушы қызметтерін жеткізушілер',
  mystery_shopping_12: 'қызмет көрсету сапасы рейтингтері',
  mystery_shopping_13: 'Сауалнама',
  mystery_shopping_14: 'Бағдарламалық жасақтама',
  mystery_shopping_15: 'Сатып алушы профилі',
  mystery_shopping_16: 'Растау және қарсылық',
  mystery_shopping_17: 'Аналитика',
  mystery_shopping_18:
    'Осы 5 қадаммен біздің 4Service компаниясы құпия сатып алушының қызмет сапасына кепілдік береді',
  mystery_shopping_19: 'Бағдарлама',
  mystery_shopping_20: '4Service Mystery Shopping бағдарламасының 5 элементі',
  mystery_shopping_21: 'Сауалнама',
  mystery_shopping_22: 'Бағдарламаңыздың негізі',
  mystery_shopping_23:
    'Бағдарламаның бұл бөлігін барлық мүдделі тараптар көре алады',
  mystery_shopping_24: 'Топ-менеджерлер үшін.',
  mystery_shopping_25:
    'Процестің барлық маңызды қадамдары мен мәліметтерін көрсету',
  mystery_shopping_26: 'Қызметкерлер үшін.',
  mystery_shopping_27: 'Жұмыс берушілердің үміттерін көрсету',
  mystery_shopping_28: 'Құпия сатып алушылар үшін.',
  mystery_shopping_29:
    'Шатасулар мен біржақтылықты болдырмау үшін анық және құрылымдалған',
  mystery_shopping_30: 'Shopmetrics бағдарламалық жасақтамасы:',
  mystery_shopping_31: 'ыңғайлы және инновациялық',
  mystery_shopping_32: 'Артықшылық:',
  mystery_shopping_33:
    'Сіздің бизнес процестеріңіз бен бағдарламалық жасақтамаңызға',
  mystery_shopping_34: 'біріктірілген',
  mystery_shopping_35: 'CDPR регламенті',
  mystery_shopping_36: 'Құпиялылықты басқару құралдары',
  mystery_shopping_37: 'Заңнамалық талаптарға толық',
  mystery_shopping_38: 'сәйкестік пакеті',
  mystery_shopping_39: 'Автоматтандырылған',
  mystery_shopping_40: 'есептерді құру',
  mystery_shopping_41: 'Қол жеткізу деңгейлерін',
  mystery_shopping_42: 'басқару',
  mystery_shopping_43: 'Бір сағат ішінде дайын болу',
  mystery_shopping_44: 'көптеген сауалнамалар үшін',
  mystery_shopping_45: 'Сатып алушы профилі:',
  mystery_shopping_46:
    'Бүкіл әлем бойынша 200 000-ден астам құпия сатып алушылар',
  mystery_shopping_47:
    'Негізгі критерийлер: мақсатты аудиторияға максималды жақындық, компанияңызбен немесе бәсекелестеріңізбен бұрынғы тәжірибеңіздің болуы',
  mystery_shopping_48: 'Сатып алушыларды оқыту:',
  mystery_shopping_49: 'Кіріспе оқыту тесті',
  mystery_shopping_50: 'Skype/телефон қоңырауы',
  mystery_shopping_51: 'Бағалау тесті (міндетті емес)',
  mystery_shopping_52: 'Растау және қарсылық',
  mystery_shopping_53: 'Растау',
  mystery_shopping_54: 'жүйелері',
  mystery_shopping_55: '100% есептер',
  mystery_shopping_56: 'валидаторлар тобымен тексеріледі',
  mystery_shopping_57: 'Қосымша қоңыраулар',
  mystery_shopping_58: 'түсіндіру үшін',
  mystery_shopping_59: 'Келуден кейін ең маңызды сәттерді белгілеу үшін',
  mystery_shopping_60: 'аудио жазбалар',
  mystery_shopping_61: 'Қызметкерлердің алаяқтықтарын ',
  mystery_shopping_62: 'алдын алу жүйесі',
  mystery_shopping_63: 'Қарсылықтар',
  mystery_shopping_64: 'жүйесі',
  mystery_shopping_65: 'Қызметкер саты алушының кез-келген бағалауына',
  mystery_shopping_66: 'тікелей сайтта қарсы тұра алады',
  mystery_shopping_67: 'Әр қарсылық',
  mystery_shopping_68: 'жергілікті валидаторлар тобы қарайды және жауап береді',
  mystery_shopping_69: 'Сіз қарсылықтар статистикасын ',
  mystery_shopping_70: 'көре аласыз',
  mystery_shopping_71: 'Аналитика.',
  mystery_shopping_72: 'Есеп жеке беріледі және мыналарды қамтиды:',
  mystery_shopping_73: 'Компаниның сезгіш нүктелері',
  mystery_shopping_74: 'және мәселелері',
  mystery_shopping_75: 'Бөлімшелер мен бөлімдер бойынша ',
  mystery_shopping_76: 'динамика',
  mystery_shopping_77:
    'Сстандарттарды сақтау мен тұтынушылардың қанағаттануы арасындағы',
  mystery_shopping_78: 'корреляция',
  mystery_shopping_79: 'Бәсекелестермен ',
  mystery_shopping_80: 'салыстыру',
  mystery_shopping_81: 'Қызметті жақсарту бойынша практикалық',
  mystery_shopping_82: 'ұсыныстар',
  mystery_shopping_83: 'Бізді не ерекшелендіреді?',
  mystery_shopping_84: 'Біз идеяларды әзірлеу сессияларын өткіземіз',
  mystery_shopping_85:
    'Біз не істеу керектігін ғана емес, сонымен бірге қызмет көрсету мәселелерін шешудің практикалық жолдарын іздейміз.',
  mystery_shopping_86: 'Идеялар сессиялары — бізге көмектесетін қуатты құрал:',
  mystery_shopping_87: 'Өнімді немесе қызметті жақсарту бағыттарын әзірлеу',
  mystery_shopping_88:
    'Кіріс ағыны мен бизнес стратегиясының жаңа мүмкіндіктерін зерттеу',
  mystery_shopping_89:
    'Клиенттерге бағытталған күрделі мәселелердің шешімін табу',
  mystery_shopping_90: 'Клиенттердің сезгіш нүктелерін тартымдылыққа айналдыру',
  mystery_shopping_91: 'Біз бейне сұхбат жүргіземіз',
  mystery_shopping_92:
    'Біз тек сауалнамалар жинамаймыз - біз сатып алушылардан тікелей түсініктемелер аламыз',
  mystery_shopping_93: 'Біз мұны жасаймыз:',
  mystery_shopping_94:
    'Біздің фасилитаторлар терең сұхбат жүргізеді және тиімді кері байланыс қамтамасыз етеді.',
  mystery_shopping_95: 'Қызметке клиенттің көзқарасы бойынша қараңыз',
  mystery_shopping_96: 'Контенттік-маркетингтік стратегияңызды жетілдіріңіз',
  mystery_shopping_97: 'Клиенттердің мінез-құлқын болжаңыз',
  mystery_shopping_98: 'Біз клиенттің жол картасын жасаймыз',
  mystery_shopping_99:
    'Customer Journey Mapping бізге олардың қажеттіліктері мен мәселелерін түсіну үшін клиенттердің орнына келуге көмектеседі.',
  mystery_shopping_100: 'Клиент жолын құру – ең жақсы әдіс:',
  mystery_shopping_101: 'Қызметке клиенттің көзқарасы бойынша қараңыз',
  mystery_shopping_102: 'Контенттік-маркетингтік стратегияңызды жетілдіріңіз',
  mystery_shopping_103: 'Клиенттердің мінез-құлқын болжау',
  mystery_shopping_104: 'Қызмет немесе байланыс кемшіліктерін анықтау',
  mystery_shopping_105: 'Біз жасырын сатып алудың әртүрлі түрлерін ұсынамыз',
  mystery_shopping_106: 'Құпия сатып алу түрлері',
  mystery_shopping_107: 'Жұмбақ қоңырау шалушы',
  mystery_shopping_108:
    'Менеджерлеріңізге және/немесе байланыс орталығына телефон арқылы көрсетілетін қызметтердің сапасын анықтау үшін қоңырау шалады',
  mystery_shopping_109: 'Сәнді құпия шоппинг',
  mystery_shopping_110:
    'Элиталық мекемелерде құпия сатып алушылардың арнайы санатымен тексеру қызметі',
  mystery_shopping_111: 'Бәсекелестерге бару',
  mystery_shopping_112:
    'Бәсекелесіңіздің қалай жұмыс істейтінін түсінудің ең оңай жолы',
  mystery_shopping_113: 'Жұмбақ қызметкер',
  mystery_shopping_114:
    'Қызметкердің бүкіл жолын түсінуге көмектеседі (жалдау, жұмысқа қабылдау, кеңсе процестері және т. б.)',
  mystery_shopping_115: 'Мотивациялық сапарлар',
  mystery_shopping_116:
    'Қосымша қызметтерді және/немесе тауарларды, белгілі бір тауарларды сатуды ұсынуды ынталандырудың пайдалы құралы',
  mystery_shopping_117: 'Онлайн құпия сатып алушы',
  mystery_shopping_118:
    'Интернет-дүкенде, веб-сайтта немесе қолданбада клиенттерге қызмет көрсету сапасын модельдейді және өлшейді',
  mystery_shopping_119: 'Сату мен жарнамалық акцияларды тексеру',
  mystery_shopping_120:
    'Акциялардың барлық жерлерде қалай көрсетілетінін және олардың қаншалықты тиімді жұмыс істейтінін анықтауға көмектеседі',
  mystery_shopping_121: 'Сатып алулар және қайта кіру',
  mystery_shopping_122:
    'Тұтынушыларға қызмет көрсету сапасын жақсарту үшін сатып алудан қайтаруға дейінгі барлық процесті көрсетуге көмектеседі',
  mystery_shopping_123: '20 + жас',
  nps_1: 'Тұтынушы индексі',
  nps_2: 'NPS адалдығы',
  nps_3: 'Тұтынушылардың адалдығын өлшеңіз, қадағалаңыз және арттырыңыз',
  nps_4: 'Олар 0-ден 6-ға дейінгі балмен жауап береді.',
  nps_5:
    'Олардың тәжірибесі нашар болуы мүмкін — олар сізден қайтадан сатып алуы екіталай, тіпті басқаларға сізден сатып алмауға кеңес беруі мүмкін.',
  nps_6: 'Бұл 7-ден 8-ге дейінгі баллды таңдаған респонденттер.',
  nps_7:
    'Олар сіздің қызметіңізге қанағаттанған, бірақ промоутер ретінде қарастырылатындай емес.',
  nps_8: 'Бұл сіздің бизнесіңізді 9 немесе 10 балға бағалайтын респонденттер.',
  nps_9:
    'Бұл олар сізді досыңызға немесе әріптесіңізге ұсынатынын және сіздің пайдаңызға сөйлейтінін білдіреді.',
  nps_10: 'NPS дегеніміз не?',
  nps_11: 'Ол тұтынушылардың қабылдауын бір қарапайым сұрақ негізінде өлшейді:',
  nps_12:
    'Досыңызға немесе әріптесіңізге [ұйымды/өнімді/қызметті] ұсынуыңыз қаншалықты ықтимал?',
  nps_13: 'Бұл менің компаниямға керек пе?',
  nps_14: 'NPS - сіздің тұрақты өсуіңіз',
  nps_15: 'Клиенттердің адалдық динамикасын түсіну',
  nps_16: 'Қызметкерлеріңізді ынталандыру',
  nps_17: 'Әр түрлі өнімдермен байланысты түсіну',
  nps_18:
    'Клиенттердің сізге және сіздің бәсекелестеріңізге қалай қарайтынын салыстыру',
  nps_19: 'NPS-пен не істей аламын?',
  nps_20: 'NPS қай бизнес үшін маңызды?',
  nps_21: 'Ақпарат жинау әдістері:',
  nps_22: 'Біздің NPS бойынша ұсыныстар',
  nps_23:
    'Бұл жаман ниеттілерді промоутерлерге айналдыруға көмектесетін нұсқаулар әзірлеп жатқанымызды білдіреді',
  nps_24: 'Тұйық цикл әдісімен жұмыс істейміз',
  nps_25:
    'NPS - бұл клиенттің адалдығындағы өзгерістерді бақылайтын бақылау зерттеуі',
  nps_26: 'Динамиканы қадағалаңыз',
  nps_27:
    'Біз тереңірек талдау үшін әрқашан сіздің тауашаңыздағы бәсекелестерді бағалауды ұсынамыз',
  nps_28: 'Бәсекелестерді бағалау',
  price_monitoring_1: 'Баға мониторингі',
  price_monitoring_1_1: 'Баға мониторингі',
  price_monitoring_2: 'және ритейл-мониторингі',
  price_monitoring_3:
    'Бәсекелестердің бағасын бақылау арқылы сату әлеуетін арттырыңыз және баға саясатын оңтайландырыңыз',
  price_monitoring_4:
    '4Service 20 жылдан астам уақыт бойы бүкіл әлем бойынша баға мониторингі қызметтерін ұсынып келеді',
  price_monitoring_5:
    'Біздің білікті мамандар командасы қысқа мерзімде бағаны бақылайды, бұл бізге бәсекелестердің бағасының өзгеруіне тез жауап беруге мүмкіндік береді',
  price_monitoring_6:
    'Біздің компания сізге баға мониторингі арқылы шешуге көмектесетін тапсырмалар',
  price_monitoring_7: 'Бәсекелестердің бағасын бағалау',
  price_monitoring_8: 'және өнім саясаты',
  price_monitoring_9: 'Жарнамалық акциялар және',
  price_monitoring_10: 'арнайы ұсыныстар мониторингі',
  price_monitoring_11: 'Нарық жағдайларын және',
  price_monitoring_12: 'нарықтық ортаны бақылау',
  price_monitoring_13: 'Сауда нүктелерін ',
  price_monitoring_14:
    'арнайы жабдықтар мен тауарлардың болуына тексеру және бақылау',
  price_monitoring_15: 'Өнім ағынын ',
  price_monitoring_16: 'басқару',
  price_monitoring_17:
    'Жеткізушілермен және дилерлермен жақсы ынтымақтастық үшін ',
  price_monitoring_18: 'шарттарды оңтайландыру',
  price_monitoring_19: 'Сөредегі кеңістікті өлшеу,',
  price_monitoring_20: 'тауарлардың орналасуын, қоймада болуын бағалау',
  price_monitoring_21: 'Негізгі индикаторлар және мониторинг критерийлері',
  price_monitoring_22:
    'Барлық деректер бір интерфейсте жиналады, соның ішінде:',
  price_monitoring_23: 'өнімнің атауы',
  price_monitoring_24: 'және бренд санаты',
  price_monitoring_25: 'жарнамалық материалдардың',
  price_monitoring_26: 'болуы',
  price_monitoring_27: 'баға',
  price_monitoring_28: 'және жарнамалық ұсыныстардың болуы',
  price_monitoring_29: 'өлшемі',
  price_monitoring_30: 'сөрелер',
  price_monitoring_31: 'өнімнің',
  price_monitoring_32: 'орналасуы',
  price_monitoring_33: 'артикульдің',
  price_monitoring_34: 'сыртқы түрі',
  price_monitoring_35: 'қаптама',
  price_monitoring_36: 'түрі',
  price_monitoring_37: 'кез келген басқа',
  price_monitoring_38: 'жалпы ақпарат',
  price_monitoring_39: 'Жобаға дейінгі талдау:',
  price_monitoring_40:
    'Сіздің компанияңыздың баға және өнім саясатын, іскерлік және салалық тәжірибесін',
  price_monitoring_41: 'үйренеміз',
  price_monitoring_42: 'Біз ',
  price_monitoring_43:
    'аудиторларды жедел оқыту, тестілеу және сертификаттау қызметтерін ұсынамыз',
  price_monitoring_44: 'Біз бағдарламалық жасақтаманы теңшейміз',
  price_monitoring_45: 'және жаңартамыз',
  price_monitoring_46: 'Дала жұмыстары:',
  price_monitoring_47: 'Дүкенге,',
  price_monitoring_48: 'сауда нүктелеріне бару',
  price_monitoring_49: 'Есеп беру:',
  price_monitoring_50: 'Біздің аналитикалық топ',
  price_monitoring_51:
    'Компанияның жеке кабинеттерінде онлайн есептер әзірлейді',
  price_monitoring_52: 'Біз ',
  price_monitoring_53:
    'толық фоторепортаж, PPT есебін, Excel есебін, елді мекеннің түрін, желінің атауын, сауда нүктесінің мекен-жайын ұсынамыз',
  price_monitoring_54: 'Бұл қалай',
  price_monitoring_55: 'жұмыс істейді',
  price_monitoring_56: 'жеке жеңілдіктер мөлшері',
  price_monitoring_57: 'құнын есептеу',
  price_monitoring_58: 'жеке бонустардың мөлшері',
  price_monitoring_59: 'адалдық бағдарламалары',
  price_monitoring_60: 'және т. б.',
  price_monitoring_61:
    'Біз келесі арнайы бағдарламалық жасақтаманы қолданамыз:',
  price_monitoring_62:
    'PRADATA, Shopmetrics және жан-жақты техникалық қолдауды ұсынамыз',
  price_monitoring_63: 'Жылдам іске қосу',
  price_monitoring_64: 'және масштабтау (бірінші күннен бастап)',
  price_monitoring_65: 'Барлық деректер ',
  price_monitoring_66: 'фотосуреттер мен GPS белгілері бойынша расталды',
  price_monitoring_67: 'Бізде ',
  price_monitoring_68: 'кез келген елдегі далалық агенттердің керек саны бар',
  price_monitoring_69: 'Үлкен деректер санымен',
  price_monitoring_70: 'жұмыс істей аламыз',
  price_monitoring_71: 'Жеке бағалар мониторингі',
  price_monitoring_72:
    'Егер сізде күрделі өнімдер болса-біз Сіздің баға стратегияңызды анықтауға көмектесеміз',
  price_monitoring_73:
    'Біз бәсекелестердің жеке бағаларын бақылай аламыз, мысалы:',
  price_monitoring_74: 'Төмен',
  price_monitoring_75: 'құны',
  price_monitoring_76: 'Жоғары',
  price_monitoring_77: 'тиімділік',
  price_monitoring_78: 'Excel есебі',
  price_monitoring_79: 'PPT есебі',
  price_monitoring_80: 'BI есебі',
  price_monitoring_81:
    'Бәсекелестердің баға деректері сізге оңтайлы баға шешімдерін қабылдауға көмектеседі',
  price_monitoring_82:
    'Толық фотосурет есебін, PPT есебін, орналасқан жері көрсетілген Excel есебін береміз',
  qualitative_research_1: 'Сапалы',
  qualitative_research_2: 'зерттеулер',
  qualitative_research_3:
    'Клиенттердің әрекеттері мен сөздерін бақылау арқылы деректерді жинаңыз, талдаңыз және түсіндіріңіз',
  qualitative_research_4: 'Құндылықтар',
  qualitative_research_5: 'Мінез-құлық',
  qualitative_research_6: 'Фон',
  qualitative_research_7: 'Күту',
  qualitative_research_8: 'Қоршаған орта',
  qualitative_research_9: 'Қорқыныш/Кедергілер',
  qualitative_research_10: 'Клиентті таңдаудың мақсаты қандай?',
  qualitative_research_11: 'Телефоны бар адам',
  qualitative_research_12: 'бренд',
  qualitative_research_13: 'санат',
  qualitative_research_14: 'жарнама',
  qualitative_research_15: 'өнім',
  qualitative_research_16:
    'Сапалы әдістердің бірегейлігі олардың тұтынушылық мінез-құлықтың себептері мен мотивациясын түсінуге мүмкіндік беретіндігі',
  qualitative_research_17:
    'Тұтынушының бір немесе басқа құбылысқа қатынасын талдау',
  qualitative_research_18: 'Жеке көзқарастар мен тәжірибелерде',
  qualitative_research_19:
    'Сауалнамалар арқылы зерттеуге болмайтын тақырыптарда',
  qualitative_research_20: 'Шетін тақырыптарда',
  qualitative_research_21: 'Қиын қолжетімді аудиторияда',
  qualitative_research_22: 'Күрделі географияда',
  qualitative_research_23: 'Терең сұхбат туралы сөз болғанда',
  qualitative_research_24: 'терең сұхбат пайдалы',
  qualitative_research_25:
    'Терең сұхбат - бұл белгілі бір идеяға, бағдарламаға немесе жағдайға көзқарасын зерттеу үшін респонденттермен жеке сұхбат жүргізуді қамтитын сапалы зерттеу әдісі. Терең сұхбат жеке тәжірибені/қабылдауды/тәжірибені егжей-тегжейлі зерттейді.',
  qualitative_research_26: 'Мақсаттарды:',
  qualitative_research_27: 'Әлеуметтік және мәдени нормалардың сипаттамаларын',
  qualitative_research_28: 'Қиын қолжетімді аудиторияда',
  qualitative_research_29:
    'Сауалнамалар арқылы зерттелген ақпарат алмасу және салыстыруда',
  qualitative_research_30: 'сауалнамалар арқылы зерттеуге болмайтын тақырыптар',
  qualitative_research_31:
    'Тереңдетілген фокус-топтар туралы сөз болғанда пайдалы:',
  qualitative_research_32: 'Фокус-топтар',
  qualitative_research_33:
    'Топ модераторы басқаратын жеке кездесулер мен туындаған пікірталастарды терең зерттеу.',
  qualitative_research_34:
    'Топтық талқылау және әңгімелерден алынған мәліметтер арқылы жалпы тәжірибе мен әлеуметтік нормалар туралы ақпарат алу.',
  qualitative_research_36: 'Артықшылықтары:',
  qualitative_research_37:
    'Әртүрлі нақты жағдайларда (үйде, сауда нүктесінде, жұмыста және т. б.) тұтынушының өмір салты мен мінез-құлқын зерттеу',
  qualitative_research_38:
    'Жаңа өнімдерді әзірлеу, орау, техникалық қызмет көрсетуді жақсарту және т. б. үшін идеяларды табу',
  qualitative_research_39: 'Терең этнографиялық зерттеу пайдалы:',
  qualitative_research_40: 'Этнографиялық зерттеу',
  qualitative_research_41:
    'Этнография - бұл белгілі бір қауымдастықтың немесе ұйымның өміріне енуді және олардың мінез-құлқы мен өзара әрекеттесуін жақын қашықтықтан бақылауды қамтитын сапалы зерттеу түрі.',
  qualitative_research_42:
    'Этнография - бұл топтың жалпы мәдениеті, дәстүрлері мен әлеуметтік динамикасы туралы терең түсінік алуға мүмкіндік беретін икемді зерттеу әдісі. Алайда, бұл кейбір практикалық және этикалық мәселелермен де байланысты.',
  qualitative_research_43: 'Әдістер:',
  qualitative_research_44:
    'Этнография - бұл тұтынушының нақты жағдайында және оның тауармен/қызметпен өзара әрекеттесуін зерттеу',
  qualitative_research_45: 'Бізбен жұмыс істеудің артықшылықтары',
  qualitative_research_46:
    'Біз кез-келген мақсатты аудиториядан респонденттерді таба аламыз. Біз рекрутингтің сапасын бақылаймыз',
  qualitative_research_47: 'Кез келген күрделілікті рекрутинг',
  qualitative_research_48:
    'Біздің модераторлар бірнеше тілде сөйлейді және фасилитатор дағдыларына ие',
  qualitative_research_49: 'Сарапшы модераторлар',
  qualitative_research_50: 'Онлайн/офлайн жұмыс',
  qualitative_research_51: 'Біз аудио/бейне жазбаларды ұсынамыз',
  qualitative_research_52: ' ',
  qualitative_research_53: 'Біз кез-келген жерде сапалы зерттеу жүргізе аламыз',
  quantitative_research_1: 'Тұтынушылардың ',
  quantitative_research_2:
    'белгілі бір өніммен немесе қызметпен қанағаттануын зерттеу (SCI, NPS)',
  quantitative_research_3: 'Сегменттеу жүргізу',
  quantitative_research_4: 'әртүрлі нарықтардағы сауалнамалар',
  quantitative_research_5: 'Нарықты зерттеу',
  quantitative_research_6: 'NPS басқару',
  quantitative_research_7: 'Бәсекелестерді талдау',
  quantitative_research_8: 'Сандық',
  quantitative_research_9: 'зерттеулер',
  quantitative_research_10:
    'Объективті, сандық және статистикалық мәліметтер негізінде адамдардың көзқарасы мен мінез-құлқы туралы теорияларды тексеру үшін қолданылатын зерттеу әдістемесі',
  quantitative_research_11: 'жылдар',
  quantitative_research_12: 'бүкіл әлем бойынша АШ тәжірибесі',
  quantitative_research_13: 'панель',
  quantitative_research_14: 'респонденттер',
  quantitative_research_15: 'елдер',
  quantitative_research_16: 'біз бүкіл әлем бойынша жобаларды іске қосамыз',
  quantitative_research_17: 'Біз кімбіз',
  quantitative_research_18:
    '4Service - маркетингтік зерттеулердің жаһандық холдингі және АШ. Біз әртүрлі кәсіпорындар үшін сараптамалық деректерді жинау қызметтерін ұсынамыз',
  quantitative_research_19: 'Сандардағы 4Service',
  quantitative_research_20: 'Компьютерлік көмек',
  quantitative_research_21: 'Веб-сұхбат',
  quantitative_research_22:
    'Интернеттегі сауалнама әдісі. Респондент сұхбат берушінің көмегінсіз электрондық сауалнаманы толтырады. Сауалнаманы электронды түрде жіберуге немесе сайтқа орналастыруға болады.',
  quantitative_research_23: 'Компьютерлік веб-сұхбат',
  quantitative_research_24: 'Көп жағдайда',
  quantitative_research_25:
    'бұл әдіс материалдық және уақыттық шығындар тұрғысынан ең үнемді болып табылады',
  quantitative_research_26: 'Бұл сауалнама',
  quantitative_research_27:
    'қол жеткізу қиын аудиториядан сұхбат алу мүмкіндігін қамтамасыз етеді',
  quantitative_research_28: 'ол бейне және аудио материалдарды',
  quantitative_research_29:
    'сондай-ақ суреттерді көрсету үшін кең мүмкіндіктер береді',
  quantitative_research_30: 'Респонденттер ',
  quantitative_research_31: 'әлемнің кез келген нүктесінде болуы мүмкін',
  quantitative_research_32: 'Бұл интернет аудиториясының нақты әрекетін',
  quantitative_research_33:
    'зерттеуге мүмкіндік береді. Клиент негізгі нәтижелерге нақты уақыт режимінде веб-интерфейс арқылы қол жеткізе алады',
  quantitative_research_34: 'Кез келген құпия ақпарат үшін қолжетімді',
  quantitative_research_35:
    'сезімтал, жеке тақырып немесе сұхбат берушімен сөйлесу кезінде респонденттер жауап бергісі келмейтін сұрақ',
  quantitative_research_36: 'іріктеу, 150 000-нан астам адам',
  quantitative_research_37:
    'Бізде бүкіл әлем бойынша респонденттердің жеке іріктеуі бар',
  quantitative_research_38: 'Біз күрделі сұратулармен жұмыс істейміз',
  quantitative_research_39:
    'Қосымша құралдарды (әлеуметтік медиа, жарнама) пайдалану арқылы біз белгілі бір аудиторияны және респонденттің күрделі профилін таба аламыз',
  quantitative_research_40: 'Біз респонденттерді ынталандырамыз',
  quantitative_research_41:
    'Біз материалдық ынталандыруды қамтамасыз ету арқылы ұзақ сауалнамаларды толтыруды ынталандыру үшін негіз жасадық',
  quantitative_research_42: 'Жеке сұхбат',
  quantitative_research_43: 'планшетпен орындалды',
  quantitative_research_44:
    'Бұл сандық деректерді жинаудың негізгі әдістерінің бірі, оның барысында сұхбат беруші респондентпен қатаң құрылымдалған сауалнама арқылы тікелей байланысады.',
  quantitative_research_45:
    'Жеке сұхбат респонденттің жұмыс орнында немесе тұрғылықты жерінде, көшеде немесе планшетті пайдаланып арнайы белгіленген сату орындарында жүргізілуі мүмкін',
  quantitative_research_46: 'Планшетпен жүргізілген жеке сұхбаттар',
  quantitative_research_47: 'Брендтің деңгейін, ',
  quantitative_research_48: 'танымалдығы мен танылуын анықтау',
  quantitative_research_49: 'Тұтынушыларды',
  quantitative_research_50:
    'олардың сатып алу мінез-құлқы негізінде сегменттеу',
  quantitative_research_51: 'Жарнамалық науқанның',
  quantitative_research_52: 'тиімділігін талдау',
  quantitative_research_53: 'Тұтынушылардың қанағаттануы',
  quantitative_research_54: 'өлшеу',
  quantitative_research_55: 'Ең жақсы бағаны анықтау',
  quantitative_research_56: 'Өнім немесе қызмет үшін',
  quantitative_research_57: 'Тұтынушылардың қалауын',
  quantitative_research_58: 'талдау',
  quantitative_research_59: 'Тұтынушылар қалай сатып алатынын',
  quantitative_research_60: 'зерттеу',
  quantitative_research_61: 'Нарық сыйымдылығын',
  quantitative_research_62: 'бағалау',
  quantitative_research_63: 'Digsee бағдарламалық жасақтамасы',
  quantitative_research_64:
    'Біз арнайы аудио және GPS бағдарламалық жасақтамасын қолданамыз',
  quantitative_research_65: 'Сұхбат берушілер мен супервайзерлер',
  quantitative_research_66:
    'біз кез-келген тілде сұхбат жүргізе аламыз және клиенттің қалаған тіліне аудара аламыз',
  quantitative_research_67: 'Іріктеу',
  quantitative_research_68:
    'Аналитикалық бөлім ең жақсы нәтижеге қол жеткізу үшін респонденттерді жалдау жүйесін әзірлейді',
  quantitative_research_69: 'Компьютерлік көмек',
  quantitative_research_70: 'Телефонмен сұхбат',
  quantitative_research_71:
    'Нақты құрылымдалған сауалнаманы қолдана отырып, телефон арқылы сұхбат арқылы сандық ақпаратты жинау әдістемесі.',
  quantitative_research_72: 'Компьютерлік телефон сұхбаты',
  quantitative_research_73: 'Бізде өз байланыс орталықтарымыз бар',
  quantitative_research_74:
    'Біз арнайы аудио және GPS бағдарламалық жасақтамасын қолданамыз',
  quantitative_research_75: 'Білікті операторлар',
  quantitative_research_76:
    'Біздің операторлар әртүрлі тілдерде сөйлейді, оқыған, білікті және үнемі өз дағдыларын жетілдіреді',
  quantitative_research_77: 'Мәліметтер базасы',
  quantitative_research_78:
    'Біз өз дерекқорларымызбен де, тұтынушыларыңыздың дерекқорларымен де жұмыс істейміз',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    'Біз сапаға кепілдік береміз және SLA-ға қол қоямыз (Қызмет көрсету деңгейі туралы келісім)',
  quantitative_research_81: 'Мақсат қою',
  quantitative_research_82: 'Әдістеме анықтамасы',
  quantitative_research_83: 'Сегменттеу және іріктеу',
  quantitative_research_84: 'Деректерді жинау арналарын анықтау',
  quantitative_research_85: 'Респондент үшін логикалық сауалнама жасау',
  quantitative_research_86: 'Деректерді жинау процесі',
  quantitative_research_87: 'Сапаны қамтамасыз ету',
  quantitative_research_88: 'Талдау әдістері',
  quantitative_research_89: 'Деректерді өңдеу',
  quantitative_research_90: 'Сауалнама дизайны',
  quantitative_research_91:
    'GPS көмегімен сұхбат берушілердің орналасқан жерін бақылау',
  quantitative_research_92: 'Деректерді тексеру',
  quantitative_research_93: 'Сауалнаманы әзірлеу және тестілеу',
  quantitative_research_94: 'Деректерді тексеру',
  quantitative_research_95: 'GDPR талаптарын сақтаумен аудио жазбалар',
  quantitative_research_96: 'Рекрутерлерді дайындау және оқыту',
  quantitative_research_97: 'Сапаны қамтамасыз ету',
  quantitative_research_98: 'Факторлық талдау',
  quantitative_research_99: 'Сегменттеу',
  quantitative_research_100: 'Қабылдау картасы',
  quantitative_research_101: 'Корреляция',
  quantitative_research_102: 'Конверсия моделі',
  quantitative_research_103: 'Жаккард',
  quantitative_research_104: 'Кластерлік талдау',
  quantitative_research_105: 'және т. б.',
  quantitative_research_106: 'Аналитикалық есептер',
  quantitative_research_107:
    'Біз әртүрлі әдістемелерді қолдана отырып, аналитикалық есептер шығару үшін SPSS® және басқа құралдарды қолданамыз',
  quantitative_research_108: 'Қандай бизнес мәселелерін шешуге болады:',
  quantitative_research_109: 'Қандай бизнес мәселелерін шешуге болады:',
  social_responsibility_1: '4Service корпоративтік әлеуметтік жауапкершілігі',
  social_responsibility_2:
    'Біздің команданың әрбір мүшесінің жүрегі мен жанының тереңінен. Біз қызметкерлеріміздің әрқайсысында мейірімділік ұшқынын сақтауға және айналамыздағы әлемді сәл жақсартуға бар күшімізді саламыз',
  social_responsibility_3: 'Білім беру қызметі/Жастарды қолдау',
  social_responsibility_4:
    'Біздің балалар мен студенттерге арналған ақпараттық бастамалар',
  social_responsibility_5: 'Service Mania іскерлік ойыны',
  social_responsibility_6:
    'Біздің оқу іс-шараларымыздың маңызды бөлігі Service mania бизнес ойыны болып табылады',
  Social_responsibility_7:
    'Service Mania ерекше жағдайларды оңай жеңу үшін стратегиялық ойлауды үйретеді.',
  social_responsibility_8: 'Зерттеу презентациясы/Дия.Бизнес',
  social_responsibility_9:
    'Бизнес пен клиенттің қызмет жағдайына көзқарасы: 4Service Украина даму жөніндегі директоры Виктория Скороботаның зерттеу нәтижелерін таныстыру.',
  social_responsibility_10: 'Қызмет дизайны бойынша сессиялар',
  social_responsibility_11:
    'Қызметтерді жобалау әдістемесі 4Service маңызды бөлігі болып табылады. Бірнеше жыл бұрын біз DesignThinkers академиясымен серіктес болдық және өз жұмысымызда ең жақсы тәжірибелерді қолданып қана қоймай, сонымен қатар ең жақсы компанияларды белсенді түрде оқытамыз',
  social_responsibility_12: 'Қайырымдылық/еріктілік',
  social_responsibility_13:
    'Балалар үйлері, қарттар үйлері және Украина армиясындағы еріктілер. Біздің қызметіміздің ең әсерлі бөлігі',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'Біз `Благомай` қайырымдылық қорымен серіктестікте жұмыс істейміз және мереке беруге және оған мұқтаж адамдарға көмектесуге тырысамыз',
  social_responsibility_16: 'Балалар үйлері мен қарттар үйлеріне қаражат жинау',
  social_responsibility_17:
    'Біз 4Service-те қарттар мен балалар үйлеріне қажетті заттарды сатып алу үшін бірнеше қаражат жинауды бастадық',
  social_responsibility_18: '# УкраинаныҚұтқарамыз',
  social_responsibility_19:
    'Соғыс біздің көптеген қызметкерлерімізге және жақын достарымызға әсер етті. Біздің әрқайсымыз қолымыздан келгенше көмектесеміз',
  social_responsibility_20: 'Жануарлардың амандығы',
  social_responsibility_21:
    'Әркім бізге асыранды жануарымен бірге кеңсеге келе алады. Біз баспаналарға көмектесеміз, азық-түлікке қаражат жинаймыз, сонымен қатар кейде қаңғыбас жануарларға баспана іздейміз',
  social_responsibility_22: 'Жануарларға арналған баспаналарды қолдау',
  social_responsibility_23:
    'Үйсіз жануарлар біздің қоғамның барлық осал мүшелері сияқты көмекке мұқтаж.',
  social_responsibility_24:
    'Біздің компания `Сириус` (Киев облысы, Украина) үйсіз жануарларға арналған баспананы өз қамқорлығына алды.',
  social_responsibility_25:
    'Үйсіз жануарларға көмектесетін шығармашылық бастамалар',
  social_responsibility_26:
    'Оның көмегімен біз өз клиенттеріміз бен серіктестерімізге жануарлардың баспана мәселесінің өзектілігі туралы айтамыз',
  social_responsibility_27: 'Үй жануарларына қатысуға рұқсат етілген кеңсе',
  social_responsibility_28:
    'Біздің команданың көптеген мүшелерінде үй жануарлары бар. Біз әркім өз үй жануарымен кеңсеге келіп, өзін жайлы сезінетін салауатты орта жасадық',
  ux_testing_1: 'UX-тестілеу',
  ux_testing_1_1: 'UX-тестілеу',
  ux_testing_2:
    'Веб-сайттар мен қосымшаларды тексеру және жақсарту: адамның көзқарасы және жасанды интеллектті қолдану',
  ux_testing_3: 'UX тестілеу дегеніміз не',
  ux_testing_4:
    'UX тестілеу адамдардың сіздің өніміңізбен, қолданбаңызбен немесе веб-сайтыңызбен қалай әрекеттесетінін түсінуге көмектеседі',
  ux_testing_5: 'Навигация аса түсінікті емес',
  ux_testing_6: 'Мен қалай тапсырыс беру керектігін білмеймін',
  ux_testing_7: 'Каталогта фотосуреттер жеткіліксіз',
  ux_testing_8: 'Сіз:',
  ux_testing_9: 'Жақсарту үшін мүмкіндіктер ашасыздар',
  ux_testing_10:
    'Клиенттің дизайны мен өзара әрекеттесуіндегі мәселелерді анықтаңыз',
  ux_testing_11:
    'Сайтпен өзара әрекеттесу кезінде пайдаланушының қандай қиындықтарға тап болатынын білесіз',
  ux_testing_12: 'Клиенттің саяхатын бақылаңыз',
  ux_testing_13:
    'Мақсатты аудиторияңыз сайттан қашан және не үшін кететінін біліңіз',
  ux_testing_14:
    'Қай бөлімдер ең аз және ең көп қызығушылық пен эмоцияны тудыратынын анықтаңыз',
  ux_testing_15: 'UX-пайдаланушы тестілеуі',
  ux_testing_16:
    '4Service сізге сапалы және сандық әдістерді қолдана отырып, клиентке бағытталған веб-сайттар мен қосымшаларды құруға қажетті нақты адам түсінігін ұсынады',
  ux_testing_17:
    'Мен сайтты қалай пайдалану керектігін түсінбеймін. Мәзір қайда жасырылған?',
  ux_testing_18: 'Әріптер арасында тым көп орын бар сияқты, мәтін оқылмайды',
  ux_testing_19: 'Суреттер бір-бірімен қабаттасады. Солай болуы керек пе?',
  ux_testing_20:
    'UX тестілеу адамдардың сіздің өніміңізбен, қолданбаңызбен немесе веб-сайтыңызбен қалай әрекеттесетінін түсінуге көмектеседі',
  ux_testing_21: 'Пайдаланушы UX тестілеуін зерттеу дизайны:',
  ux_testing_22: 'Жақсырақ болу мүмкіндіктерін ашыңыз',
  ux_testing_23: 'Сынақ түрі мен әдісін анықтау (сапалық/сандық)',
  ux_testing_24: 'Гипотезалар мен пайдаланушы сценарийлерін құрастыру',
  ux_testing_25: 'Тест нәтижелерін талдау және есеп беру',
  ux_testing_26: 'Екі шешім',
  ux_testing_27: 'Біз сәтті UX тестілеудің екі тәсілін ұсынамыз',
  ux_testing_28: 'UX-пайдаланушы тестілеуі',
  ux_testing_29: 'UX-жасанды интеллект және адам сынағы',
  ux_testing_30: 'Біздің күшті жақтарымыз:',
  ux_testing_31: 'Біз бәсекелестік ортаны талдай аламыз',
  ux_testing_32: 'Сұхбатты өткізу және қатысу үшін тар мамандарды тарта аламыз',
  ux_testing_33:
    'Біз әртүрлі тілдерде сұхбат жүргізіп, оларды қажетті тілге аудара аламыз',
  ux_testing_34: 'Қолданыстағы ыңғайлылықпен',
  ux_testing_35: 'көрсеткіштер немесе стандарттар',
  ux_testing_36: 'сіздің өнімділігіңіз',
  ux_testing_37: 'бәсекелеске қарсы',
  ux_testing_38: 'сол өнім',
  ux_testing_39: 'нұсқалары',
  ux_testing_40: 'Қанағаттану рейтингі',
  ux_testing_41: 'NPS',
  ux_testing_42: 'Табыс көрсеткіштері',
  ux_testing_43: 'Қателер жиілігі',
  ux_testing_44: 'Тапсырманы орындау уақыты',
  ux_testing_45: 'UX-пайдаланушы тестілеуі',
  ux_testing_46: 'Сандық әдіс',
  ux_testing_47:
    'Біз осы кезеңде UX тестілеуіне қатысу үшін кем дегенде 100 адамды тартамыз',
  ux_testing_48:
    'Веб-сайтыңызды немесе қолданбаңызды салыстыру қажет болғанда маңызды:',
  ux_testing_49: 'Сандық өлшеу әдісі:',
  ux_testing_50: 'Бақылау',
  ux_testing_51:
    'Пайдаланушымен немесе пайдаланушылар тобымен уақыт өткізу, оны күнделікті өмірде қолданған кезде олардың өніммен өзара әрекеттесуін бақылау',
  ux_testing_52: 'Терең сұхбат',
  ux_testing_53:
    'Сіздің сайтыңызға кіретін пайдаланушылардың көзқарасы, сенімдері, тілектері мен тәжірибесі туралы білуге мүмкіндік береді. Біз 15-20 сұхбат жүргізуді ұсынамыз',
  ux_testing_54: 'Этнографиялық зерттеу',
  ux_testing_55:
    'Респонденттердің олар өнімді пайдаланатын ортасында өткізіледі. Бақылаулар пайдаланушының психологиясын және олар кездесетін эмоционалды мәселелерді жақсы түсінуге мүмкіндік береді.',
  ux_testing_56: 'UX-пайдаланушы тестілеуі',
  ux_testing_57: 'Сапа әдісі',
  ux_testing_58:
    'Бұл әдіс пайдаланушылардың мінез-құлқының мотивтері мен логикасын түсінуге көмектеседі',
  ux_testing_59: 'Біз қолданамыз:',
  ux_testing_60:
    'Біз зерттеу нәтижелерін көрсету үшін клиенттің жол картасын жасаймыз',
  ux_testing_61: '30 қатысушы (ерлер/әйелдер)',
  ux_testing_62:
    'Респонденттер алдын ала тексеріліп, сауалнамаға қатысуға шақырылады',
  ux_testing_63: 'Wantent платформасында қашықтан онлайн сұхбат',
  ux_testing_64: 'ИИ + адам',
  ux_testing_65: 'Адамның қатысуымен ИИ + UX-тестілеу',
  ux_testing_66:
    'Wantent бірегей жасанды интеллект технологиясы мен нақты пайдаланушылардың үйлесімі',
  ux_testing_67: 'Тақырыптағы үлкен қаріп назар аудартты',
  ux_testing_68:
    'Пайдаланушылар қатты сөйлейтін `сандарға қарайды, бірақ олардың жанындағы ақпаратты оқымайды',
  ux_testing_69:
    'UX тестілеу адамдардың сіздің өніміңізбен, қолданбаңызбен немесе веб-сайтыңызбен қалай әрекеттесетінін түсінуге көмектеседі',
  ux_testing_70:
    'Жасанды интеллект + адамның қатысуымен тестілеуді зерттеу дизайны',
  ux_testing_71: 'Ол қалай жұмыс істейді',
  ux_testing_72:
    'Wantent - бұл нарық талаптарына сәйкес келетін жасанды интеллектке негізделген шешім.',
  ux_testing_73:
    'Wantent эмоционалды реакциялар мен аудиторияның қатысуын талдау үшін машиналық оқыту технологияларын қолдану арқылы веб-сайттар мен қосымшалардың тиімділігін бағалайды.',
  ux_testing_74:
    'Нәтижелерді түсіндіру үшін біз өнімділік пен өсуді ынталандыру үшін сторителинг, әртүрлілік және эмпатия әдістерін қолданамыз.',
  ux_testing_75: 'Бөлімдерге өту кезінде пайдаланушының назары мен эмоциясы',
  ux_testing_76:
    'Қатысушылар топтары бойынша статистика (сессия барысында назар аудару және назар аудару)',
  ux_testing_77: 'Беттердің конверсияларын талдау',
  ux_testing_78: 'Тапсырмаларды орындау кезіндегі назар мен эмоциялар',
  ux_testing_79: 'Қабылдау қорытындылары',
  ux_testing_80: 'Қатысушылардың әртүрлі топтары бар сайттар',
  ux_testing_81: 'Жеңілдікті талдау',
  ux_testing_82:
    'Беттерді шарлауда және маңызды элементтерді табудың қарапайымдылығында',
  ux_testing_83: 'Сайтта ұсынылған ақпаратты',
  ux_testing_84: 'қабылдауды талдау',
  ux_testing_85: 'Жеке беттерді жақсарту үшін',
  ux_testing_86:
    'аймақтарды анықтау (навигация, ақпараттық блоктар және т. б.)',
  ux_testing_87: 'Біз егжей-тегжейлі талдаймыз',
  ux_testing_87_about: 'әдіс',
  ux_testing_88: 'Зерттеудің негізгі нәтижелері',
  ux_testing_89: 'Сайт құрылымын және жеке беттерді жақсарту бойынша ұсыныстар',
  ux_testing_90:
    'Біз ыңғайлылықты тексеру үшін мақсатты аудиторияны мұқият таңдаймыз.',
  ux_testing_91:
    'Біз әртүрлі елдерде, әртүрлі тілдерде және әртүрлі пайдаланушылар топтары арасында зерттеулер жүргіземіз',
  ux_testing_92: 'Біз қосымшаларды',
  ux_testing_93:
    'және салыстырмалы талдау жүргізуге арналған бәсекелес сайттарды тексере аламыз',
  ux_testing_94: 'Біз әртүрлі зерттеу әдістерін біріктіреміз.',
  ux_testing_95:
    'Біздің білікті фасилитаторлар тестілеу процесінде қатысушымен бірге жүреді.',
  ux_testing_96: 'Әр түрлі құрылғылар мен БЖ біз',
  ux_testing_97: 'тестілеуді өткіземіз',
  ux_testing_98: 'Неге бізді таңдайды?',
  wantent_1: '4Сервис x',
  wantent_2: 'Wantent',
  wantent_3:
    '4Service және Wantent ұсынған бірегей серіктестік жобасы © жасанды интеллект пен мазмұнды талдауға адамның көзқарасының үйлесімі',
  wantent_4: 'контент эфирге шыққанға дейін сәттілікті өлшеу',
  wantent_5: 'әртүрлілік мәселелерімен байланысты тәуекелдерді азайту',
  wantent_6: 'мазмұнды жақсартуға арналған терең идеялар мен ұсыныстар',
  wantent_7: 'объективті мазмұн және маркетингтік стратегия шешімдері',
  wantent_8:
    'Wantent - бұл нарық талаптарына сәйкес келетін жасанды интеллектке негізделген шешім.',
  wantent_9:
    'Wantent - бұл мазмұнды нарыққа сәйкестендіруге арналған жасанды интеллектке негізделген шешім. Wantent эмоционалды жауап пен аудиторияның қатысуын талдау үшін машиналық оқыту технологияларын қолдану арқылы бейне мазмұнының тиімділігін бағалайды.',
  wantent_10:
    'Wantent мазмұнның нарыққа сәйкестігін анықтауға және мазмұнның тиімділігін арттыруға көмектеседі',
  wantent_11: 'Сценарийді теңшеу және қатысушыларды іріктеу',
  wantent_12: 'Жеке жобаны әзірлеу және бүкіл әлем бойынша аудиторияны тарту',
  wantent_13: 'Пайдаланушы реакциясын жинау',
  wantent_14: 'Аудиториядан егжей-тегжейлі және нақты кері байланыс',
  wantent_15: 'Контентті қабылдауды талдау',
  wantent_16:
    'ИИ көмегімен пайдаланушының мінез-құлқы мен эмоционалды реакцияларын талдау',
  wantent_17: 'Соңғы қорытынды шығару үшін ақпарат беру',
  wantent_18: 'Жақсарту бойынша ұсыныстар',
  wantent_19: 'Wantent сіздің мазмұныңыздың тиімділігін арттырады',
  wantent_20: 'Хабарландыру тұжырымдамасын алдын ала тестілеу',
  wantent_21: 'Шығармашылық тұжырымдаманы тестілеу',
  wantent_22:
    'Болашақ креативтің әзірленген стратегияға сәйкестігін тексеру және креативті тұжырымдамаларды/хабарламаларды ықтимал түзетулер үшін мақсатты аудиторияның реакциясын түсіну',
  wantent_23: 'Бренд элементтерін көрінуге тестілеу (кейінгі өңдеу)',
  wantent_24: 'Жарнамалық/демеушілік инвестициялардың тиімділігін растау',
  wantent_25: 'Жарнаманы тестілеу',
  wantent_26: 'A / B-тестілеу',
  wantent_27:
    'Шығармашылық өнімділікті салыстыру, өндіріс кезеңіндегі белсенділік пен зейінді арттыру',
  wantent_28: 'Жарнаманы тестілеуді бастау',
  wantent_29:
    'Хабарламалардың тиімділігін анықтау және дыбыс пен кескінді жақсарту бойынша ұсыныстар жасау',
  wantent_30: 'ТА үшін шешімдер',
  wantent_31:
    'Ұшқыштар, промо, жаңа форматтар, тележүргізушілерді тестіден өткізу',
  wantent_32:
    'Ең тартымды контентті анықтау және оны күшейту үшін салыстырмалы талдау жүргізу',
  wantent_33: 'Телешоулар мен толықметражды фильмдерді тестілеу',
  wantent_34:
    'Табиғи жағдайда ұзақ мазмұнды қарау кезінде көрермендердің қатысуын, назар аудару деңгейін, эмоционалды ден қоюды талдау. Біз бейнені өңдеуді бағалау және жақсарту үшін аудиторияның шығуының шыңдары мен алаңдаушылық сәттерін автоматты түрде табамыз',
  wantent_35: 'UI / UX-тестілеу',
  wantent_36: 'Сайт прототиптері және мобильді қосымшаларды тестілеу',
  wantent_37:
    'Wantent технологиясы арқылы пайдаланушылардың реакциясы мен эмоциясын талдау:',
  wantent_38: 'назар деңгейі',
  wantent_39: 'эмоционалды реакциялар',
  wantent_40: 'қатысушылардың көзқарасының жылу карталары',
  wantent_41:
    'Қатысушылардың пікірлері негізінде веб-сайт пен қосымшалардың ыңғайлылығын талдау:',
  wantent_42: 'Жүйені пайдаланудың ыңғайлылық шкаласы (SUS)',
  wantent_43:
    'Клиенттің күш-жігерін бағалау (өзара әрекеттесудің қарапайымдылығы)',
  wantent_44: 'Таза жылжыту көрсеткіші (NPS)',
  wantent_45: 'GDPR сәйкестігі және пайдаланушының құпиялылығы',
  wantent_46:
    'Wantent GDPR және CCPA саясатына толық сәйкес келеді және мүшелердің жеке деректерін жинау, сақтау, өңдеу және қорғау принциптеріне сәйкес келеді',
  wantent_47: 'Никита Лобынцев',
  wantent_48: 'SDO, Reface (медиа және ойын-сауық)',
  wantent_49:
    'Күн сайын біз машиналық оқыту технологиялары арқылы көптеген жаңа мазмұн идеяларымен тәжірибе жасаймыз. Wantent бізге тәуекелдер мен артықшылықтарды түсінуге және бағалауға, шешімдеріміздің әртүрлі аспектілерінің себеп-салдарлық байланысын орнату үшін пайдаланушылардың пікірлерін, мінез-құлқын және қабылдауын білуге көмектеседі.',
  wantent_50: 'Александр Смирнов',
  wantent_51: 'TABASCO тең иесі (жарнама)',
  wantent_52:
    'Wantent тұтынушыларға ұнайтын және ұнатпайтын нәрселердің өте ұсақ бөлшектерін білуге көмектесетін шынымен бірегей қызметті ұсынады. Алдаудың жолы жоқ, өтірік айтудың жолы жоқ-Wantent әрқашан шындықты біледі және осылайша біз маркетологтар ретінде баға жетпес (хахаха - біз нақты бағаны білеміз және ол қолжетімді) коммуникацияларымызды жақсарту бойынша ұсыныстар аламыз. ',
  wantent_53: 'Пікірлер',
  terms_1: 'Ережелер мен шарттар',
  terms_2: 'Пайдалану шарттары туралы келісім',
  terms_3:
    'Веб-сайтты қолданар алдында осы пайдалану шарттары туралы Келісімді (`пайдалану шарттары`, `келісім`) мұқият оқып шығыңыз',
  terms_4:
    '("веб-сайт"), оны 4Service Holdings GmbH басқарады ("4Service"," біз"," біз","біздің").',
  terms_5:
    'Пайдалану шарттары. Бұл веб-сайтты қолдана отырып, сіз осы Келісімді оқып, танысқаныңызды және оның шарттарын сақтауға келіскеніңізді растайсыз. Егер сіз осы Келісімнің шарттарын орындағыңыз келмесе, сізге сәйкесінше веб-сайттан кетуге кеңес беріледі. 4Service осы веб-сайтты, оның өнімдері мен қызметтерін оның шарттарын қабылдағандарға ғана пайдалануға және оларға қол жеткізуге мүмкіндік береді.',
  terms_6: 'Құпиялылық саясаты',
  terms_7:
    'Біздің веб-сайтты пайдалануды жалғастырмас бұрын, пайдаланушы деректерін жинауға қатысты құпиялылық саясатымызбен танысуға кеңес береміз. Бұл біздің тәжірибемізді жақсы түсінуге көмектеседі.',
  terms_8: 'Жас шектеуі',
  terms_9:
    'Осы веб-сайтты пайдалану үшін Сіз кем дегенде 16 (Он алты) жаста болуыңыз керек. Осы веб-сайтты пайдалана отырып, сіз 16 (Он алты) жасқа толғаныңызға кепілдік бересіз және осы Келісімді заңды түрде орындай аласыз. 4Service жасын бұрмалауға байланысты міндеттемелер үшін жауап бермейді.',
  terms_10: 'Зияткерлік меншік',
  terms_11:
    'Сіз осы веб-сайтта ұсынылған барлық материалдар, өнімдер мен қызметтер 4Service, оның серіктестері, директорлары, лауазымды тұлғалары, қызметкерлері, агенттері, жеткізушілері немесе лицензиарлары, соның ішінде барлық авторлық құқықтар, коммерциялық құпиялар, сауда белгілері, патенттер және басқа да зияткерлік меншік екеніне келісесіз. Сондай-ақ, сіз 4Service зияткерлік меншігін, соның ішінде электрондық, цифрлық немесе жаңа сауда белгілерін тіркеуді көбейтпейтіндігіңізге немесе таратпайтындығыңызға келісесіз.',
  terms_12: 'Біздің веб-сайтқа кіру',
  terms_13:
    'Біздің сайтқа уақытша кіруге рұқсат етіледі және біз өз сайтымызда ұсынатын қызметтерді ескертусіз қайтарып алу немесе өзгерту құқығын сақтаймыз. Егер қандай да бір себептермен біздің сайт кез-келген уақытта немесе кез-келген мерзімде қолжетімді болмаса, біз жауап бермейміз. Кейде біз өз сайтымыздың кейбір бөліктеріне немесе бізде тіркелген пайдаланушыларға бүкіл сайтқа кіруді шектей аламыз. Сіз біздің сайтқа кіру үшін қажетті барлық шараларды, соның ішінде біздің сайтқа сәйкес келетін жабдықты пайдалануға жауаптысыз. Сіз сондай-ақ біздің веб-сайтқа сіздің интернет қосылымыңыз арқылы кіретін барлық адамдар осы шарттар туралы білетініне және оларды орындайтынына көз жеткізуге жауаптысыз.',
  terms_14: 'Қолданылатын заңнама',
  terms_15:
    'Осы веб-сайтқа кіре отырып, сіз Австрия Республикасының заңдары соқтығысу құқығының принциптерін ескермей, осы шарттарды және сіз бен 4Service арасында туындауы мүмкін кез келген дауларды реттейтініне келісесіз.',
  terms_16: 'Даулар',
  terms_17:
    'Осы веб-сайтқа кіруіңізге байланысты кез келген дау Венаның коммерциялық сотының төрелік қарауына жатады.',
  terms_18: 'Өтеу',
  terms_19:
    'Сіз 4Service және оның серіктестеріне келтірілген зиянды өтеуге және 4Service-ті сіздің веб-сайтыңызды пайдалану немесе дұрыс пайдаланбау нәтижесінде туындауы мүмкін заңды шағымдар мен талаптардан қорғауға келісесіз. Біз өз адвокатымызды таңдау құқығын сақтаймыз.',
  terms_20: 'Сақтау мерзімі',
  terms_21:
    'Өңдеу мақсаттарын ескере отырып, пайдаланушылардың дербес деректерінің сақталу мерзімі (сақтау мерзімі) сізден деректерді өңдеуге келісімді белгіленген тәртіппен алған күннен бастап 24 айды құрайды',
  terms_22: 'Жауапкершілікті шектеу',
  terms_23:
    '4Service біздің веб-сайтты дұрыс пайдаланбау нәтижесінде туындауы мүмкін шығындар үшін жауап бермейді. 4Service осы жазбаны жаңарту арқылы кез келген уақытта осы Келісімді алдын ала ескертусіз өңдеу, өзгерту және өзгерту құқығын өзіне қалдырады. Қазір немесе кез келген өзгертулер немесе өзгертулер жарияланғаннан кейін веб-сайтты одан әрі пайдалану сіздің осындай өзгерістерді немесе өзгертулерді қабылдауыңызды білдіреді. Егер осы Келісімнің кез келген бөлігі заңсыз, жарамсыз немесе заңды күші жоқ деп жарияланса, бұл бөлік бөлінетін болып саналады және кез келген басқа ережелердің жарамдылығы мен қолданылуына әсер етпейді. Сайтты заңсыз мақсатта пайдаланудың ықтимал дәлелдері құқық қорғау органдарына берілетін болады. Осы Келісім 4Service және пайдаланушы арасындағы уағдаластық болып табылады.',
  terms_24:
    'Құпиялылыққа/пайдалануға қатысты барлық сұрақтар мен мәселелерді келесі мекен-жайға жіберу өтініледі:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Тегетхоффштрассе 7',
  terms_27: '1010 Вена',
  terms_28: 'Австрия',
  terms_29: 'Шолу',
  terms_30:
    'Сіз бізге берген жеке деректер дұрыс болмаған кезде, сіз оны шынымен түзетуді сұрауға құқығыңыз бар (GDPR 16-бабы).',
  thank_you_1: 'Рақмет!',
  thank_you_2: 'Біз сізбен 24 сағат ішінде байланысқа шығамыз',
  thank_you_3:
    'PS Біздің менеджерлер сіздің сұратуыңызды ең жақсы ұсыныс жасау үшін қарастырып жатыр',
  thank_you_4: 'Меню',
  thank_you_5: 'Әйел басып жатыр',
  privacy_policy_1:
    'Деректер субъектілері (веб-сайт пайдаланушылары) үшін құпиялылық туралы хабарлама нысаны',
  privacy_policy_2:
    'Құпиялылық туралы хабарламаның бұл нысаны (құпиялылық туралы хабарлама) веб-сайтқа кірудің бір бөлігі ретінде GDPR талаптарына сәйкес 4Service Holdings GMBH жеке деректерін жинайтын жеке тұлғаларға (деректер субъектілеріне) арналған',
  privacy_policy_3:
    '(мұнда және одан кейін веб-сайт және Веб-сайт пайдаланушылары/пайдаланушылар сәйкесінше).',
  privacy_policy_4:
    '4Service Holdings GMBH деректер субъектілері (веб-сайт пайдаланушылары) үшін құпиялылық туралы хабарлама нысаны 4Service Holdings GMBH бақылауында немесе қадағалауында заңды негізде тұрған 4Service тобының барлық компанияларында қолданылады.',
  privacy_policy_5: 'Байланыстар',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(Компания/біз/бізді)',
  privacy_policy_8: 'Мекенжайы:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 Вена, Австрия.',
  privacy_policy_10: 'Электрондық пошта:',
  privacy_policy_12: 'Біз кімбіз?',
  privacy_policy_13:
    'Кез-келген мақсатта Веб-сайтқа кіретін жеке тұлға (Сіз). Осы құжаттың мақсаттары үшін Сіз Пайдаланушы ретінде көрсетілуіңіз керек.',
  privacy_policy_14: 'Біз сізден алатын жеке деректер',
  privacy_policy_15:
    'Біздің сайтқа кірген кезде біз сізге құпиялылық туралы хабарлама жібереміз, онда келесі ақпаратты өңдеуге келісім беруді ұсынамыз:',
  privacy_policy_16:
    'IP мекенжайы, пайдаланушы аты, тегі, мекенжайы, телефон нөмірі (стационарлық немесе мобильді), электрондық пошта мекенжайы, мекенжайы, компания атауы, елі, электрондық пошта мекенжайы, аты, тегі, телефон нөмірі, провинция, штат және пошта индексі, пайдалану деректері, сыртқы байланыс деректері әлеуметтік желілер немесе платформалар, веб-сайтта тіркелу және аутентификация туралы ақпарат',
  privacy_policy_17: 'географиялық орналасуы.',
  privacy_policy_18:
    'Егер сіз өз еркіңізді білдірсеңіз және бізге осындай келісім берсеңіз, біз сізден осындай ақпаратты өңдей бастаймыз.',
  privacy_policy_19: 'Заңдылық (келісім)',
  privacy_policy_20:
    'Біздің сайтқа кірген кезде біз сізге құпиялылық туралы хабарлама жібереміз, онда келесі ақпаратты өңдеуге келісім беруді ұсынамыз:',
  privacy_policy_21:
    'Дербес деректерді өңдеудің құқықтық негізі мынадай сілтеме бойынша келісім нысанын толтыру арқылы Сізден алатын келісім болып табылады:',
  privacy_policy_22:
    'Егер сіз келісім формасын толтырсаңыз, бұл құпиялылық туралы хабарламада көрсетілген барлық шарттарды түсінетіндігіңізді және қабылдайтындығыңызды білдіреді.',
  privacy_policy_23: 'Келісімді қайтарып алу',
  privacy_policy_24:
    'Сіз бізге бұрын берген Келісімді кез келген уақытта қайтарып алуға құқығыңыз бар. Келісімді қайтарып алу оны қайтарып алғанға дейін келісімге негізделген өңдеудің заңдылығына әсер етпейді. Сіз бізге remove@4service-group.com. электрондық пошта мекенжайына тиісті сұрату жіберу арқылы келісіміңізді қайтарып ала аласыз,, бұл ретте сұрату нысаны мынадай сілтеме бойынша қолжетімді:',
  privacy_policy_25: 'Пайдаланушыға қаражат шығару формасы',
  privacy_policy_26: 'Өңдеу мақсаттары',
  privacy_policy_27:
    'Біз сіздің жеке деректеріңізді келесі мақсаттарда өңдейміз:',
  privacy_policy_28:
    '- клиенттік қызметтерді жақсарту (клиенттердің сұраныстарына тиімдірек жауап беруге мүмкіндік береді); - пайдаланушылардың тәжірибесін жекелендіру (қызметтерге кімнің көбірек қызығушылық танытатынын анықтауға мүмкіндік береді); - сайтты жақсарту (тауарлар мен қызметтердің сапасын, оларды пайдалану ыңғайлылығын арттыруға, жаңа қызметтерді әзірлеуге, өнімдеріміз бен қызметтерімізді жақсартуға мүмкіндік береді); - Ақпараттық бюллетеньдердің, маркетингтік немесе жарнамалық материалдардың және біздің жаңалықтарымызды, жаңартуларымызды, келесі электрондық хаттарды алудан қалай бас тарту керектігі туралы нұсқаулығы бар қызметтер туралы ақпаратты қамтитын басқа ақпараттың көмегімен пайдаланушы; - иесіздендірілген деректер негізінде зерттеулер мен талдаулардың статистикалық және өзге де түрлерін жүргізу; - пайдаланушыға дербестендірілген қызметтер көрсету және келісімдер мен шарттар; – пайдаланушының Біз Сайт арқылы жүзеге асыратын әртүрлі жобаларға қатысуы, пайдаланушы Сайт арқылы жіберген сұрауларға жауаптар, зерттеулер, шоттар мен жазбаларды жүргізу және қызметтерді жылжыту.',
  privacy_policy_29: 'Жеке деректер берілуі мүмкін субъектілер',
  privacy_policy_30:
    'Сіздің жеке деректеріңізді өңдеу кезінде біз сіздің жеке деректеріңізді Компанияның деректер өңдеушісі ретінде әрекет ететін субъектілерге береміз. Компанияның өңдеушілері тек компанияның нұсқаулары негізінде жұмыс істейді. Компанияның өңдеушілері жүзеге асыратын іс-әрекеттердің ерекшеліктерімен және осындай өңдеушілердің тізімімен құпиялылық және деректерді қорғау саясатында келесі сілтеме бойынша танысуға болады: құпиялылық және деректерді қорғау саясаты',
  privacy_policy_31: 'Жеке мәліметтер берілуі мүмкін елдер',
  privacy_policy_32:
    'Компания сіздің жеке деректеріңізді GDPR және ЕО комиссиясы қарастырған жеткіліктілік туралы шешім негізінде жібереді. АҚШ-тағы жеке деректерді беру туралы қосымша ақпаратты құпиялылық және деректерді қорғау саясатынан мына сілтеме арқылы табуға болады: Құпиялылық және деректерді қорғау саясаты.',
  privacy_policy_33: 'Сақталу мерзімі',
  privacy_policy_34:
    'Өңдеу мақсаттарын ескере отырып, Пайдаланушылардың дербес деректерінің сақталу мерзімі (сақтау мерзімі) сізден деректерді өңдеуге белгіленген тәртіппен келісім алған күннен бастап 24 айды құрайды.',
  privacy_policy_35: 'Кіру құқығы',
  privacy_policy_36:
    'Сізге қатысты жеке деректердің өңделетінін білуге құқығыңыз бар және 2) егер солай болса, GDPR 15-бабында көрсетілген көптеген қосымша шарттармен осындай деректерге қол жеткізе аласыз',
  privacy_policy_37: 'Түзету құқығы',
  privacy_policy_38:
    'Егер сіз бізге берген жеке деректер дұрыс болмаса, сіз оны шынымен түзетуді сұрауға құқығыңыз бар (GDPR 16-бабы).',
  privacy_policy_39: 'Жою құқығы (ұмыту құқығы)',
  privacy_policy_40:
    'Сіз бізден жеке деректеріңізді негізсіз кідіріссіз жоюды талап етуге құқығыңыз бар және GDPR 17-бабында көрсетілген негіздер қолданылса, біз сіздің жеке деректеріңізді негізсіз кідіріссіз жоюға міндеттіміз.',
  privacy_policy_41: 'Өңдеуді шектеу құқығы',
  privacy_policy_42:
    'Сіз GDPR шеңберіндегі бірнеше ерекшеліктерді қоспағанда, жеке деректеріңізді өңдеуді шектеуге құқығыңыз бар, атап айтқанда GDPR 18-бабында көрсетілген.',
  privacy_policy_43:
    'Біз Сізге қандай деректер жиналатынын, қалай пайдаланылатынын, қанша уақыт сақталатынын және үшінші тұлғаларға берілетінін хабарлауға міндеттіміз. Бұл ақпарат қысқа және қолжетімді болуы керек.',
  privacy_policy_44: 'Деректерді тасымалдау құқығы',
  privacy_policy_45:
    'Сізге жеке деректеріңізді әртүрлі қызметтерде өз мақсаттарыңыз үшін алуға және қайта пайдалануға рұқсат етіледі.',
  privacy_policy_46: 'Қарсылық құқығы',
  privacy_policy_47:
    'Сіз Компания өңдейтін жеке деректерді өңдеуге қарсылық білдіруге құқығыңыз бар. Егер біз адамның мүдделерінен, құқықтарынан және бостандықтарынан басым болатын өңдеудің заңды негіздерін көрсетпесек немесе өңдеу заңды талаптарды белгілеуге немесе қорғауға арналған болса, біз жеке деректерді өңдеуді тоқтатуымыз керек.',
  privacy_policy_48:
    'Тек автоматтандырылған өңдеуге негізделген шешімге ұшырамау құқығы',
  privacy_policy_49:
    'Сіздің келісіміңізсіз болатын кез-келген автоматты профильге қарсылық білдіруге құқығыңыз бар. Бұл ретте Сіз өзіңіздің жеке деректеріңізді адамның қатысуымен өңдеуге құқығыңыз бар.',
  privacy_policy_50: 'Шағымдар',
  privacy_policy_51:
    'Егер сіз өзіңіздің жеке деректеріңізді компания (немесе жоғарыда сипатталған өңдеушілер) қалай өңдейтіні немесе шағымыңыздың қалай өңделгені туралы шағым бергіңіз келсе, сіз шағымды тікелей қадағалау органымен және компаниямен жіберуге құқығыңыз бар.',
  privacy_policy_52: 'Осы байланыстардың әрқайсысы үшін мәліметтер:',
  privacy_policy_53: 'Қадағалау органы:',
  privacy_policy_54: 'Австриялық деректерді қорғау органы',
  privacy_policy_55: 'Австриялық дания қызметі',
  privacy_policy_56: 'Викенбурггассе 8',
  privacy_policy_57: '1080 Вена',
  privacy_policy_58: 'Австрия/Еуропа',
  privacy_policy_59: 'Компания:',
  privacy_policy_60: '4Service Holdings GmbH (Компания/біз/біз)',
  privacy_policy_61: 'Мекенжайы: Tegetthoffstraße 7, 1010 Вена, Австрия.',
  privacy_policy_62: 'Электрондық пошта:',
  privacy_policy_63: 'Құпиялылық және деректерді қорғау саясаты',
  privacy_policy_64:
    'Деректеріңізді қалай және не үшін пайдаланатынымыз туралы толығырақ мына жерден оқыңыздар: құпиялылық және деректерді қорғау саясаты',
  privacy_policy_65: 'Мақұлдау',
  privacy_policy_66:
    'Компания компаниядағы жеке деректерді өңдеуге қатысты қызметкерлердің рөлдерін анықтау үшін барлық ішкі құжаттарды әзірледі, атап айтқанда, бұл құжаттың заңдылығын бекіту және тексеру үшін Басқарушы директор жауап береді.',
  contacts_1: 'Клиенттер үшін',
  contacts_2:
    'Бизнестің барлық түрлеріне, нарықты зерттеу агенттіктеріне және ірі компанияларға, іскери серіктестерге және БАҚ-қа арналған.',
  contacts_3:
    'Адрес: 050008 Казахстан, г.Алматы, Алмалинский район, ул.Торекулова 68, БЦ Сириус, офис 910',
  contacts_4: 'Сатып алушылар үшін',
  contacts_5:
    'Жергілікті тұрғындар мен саяхатшыларға, жүргізушілер мен студенттерге, кәсіби құпия сатып алушылар мен үй иелеріне арналған.',
  contacts_6: 'Өз еліңізден бізге хабарласыңыз:',
  contacts_7: 'Италия',
  contacts_8: 'АҚШ',
  contacts_9: 'Ұлыбритания',
  contacts_10: 'Швейцария',
  contacts_11: 'Нидерланды',
  contacts_12: 'Словакия',
  contacts_13: 'Словения',
  contacts_14: 'Румыния',
  contacts_15: 'Әзірбайжан',
  contacts_16: 'Украина',
  contacts_17: 'Қазақстан',
  contacts_18: 'Басқа елдер',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'ВНТ',
  menu_5: 'UX тестілеу',
  menu_6: 'Кадрлық зерттеулер',
  menu_7: 'Сапалы зерттеу',
  menu_8: 'Сандық зерттеу',
  menu_9: 'Құпия сатып алушы',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: ' Баға мониторингі',
  menu_14: 'Біз туралы',
  menu_15: 'Байланыс',
  menu_16: 'Блог',
  menu_17: 'Әдістер',
  menu_18: 'Тауарлар',
  menu_19: 'Сатып алушылар платформа',
  menu_20: 'КӘЖ',
  menu_21: 'Автокөлік бағасын талдау',
  nps_passives: 'Пассивті',
  nps_detractors: 'Қаскөйлер',
  nps_promoters: 'Промоутерлер',
  nps_a_score: 'бағалау',
  аймақ: 'Орта',
  products_tabs_1:
    'Максималды тиімділікке қол жеткізу үшін біз кешенде де өткіземіз:',
  products_tabs_2: 'Өнімдер',
  products_tabs_3:
    'Сапалы зерттеу дегеніміз - ұғымдарды, пікірлерді немесе тәжірибелерді түсіну үшін сандық емес деректерді жинау және талдау',
  products_tabs_4:
    'Сандық зерттеу әдістері - сауалнамалар, сұрақ-жауаптар арқылы жиналған деректерді объективті өлшеу және сандық талдау',
  our_clients_1: 'Біздің клиенттер',
  preview_cases_section_1: 'Кейстер',
  preview_cases_section_2:
    'Қосымша қызықты бизнес оқиғаларын оқу үшін кейстерге өтіңіз',
  blog_1: 'Қызықты контенті бар блог',
  blog_2: 'Сіздің сұратуыңыз бойынша хабарламалар жоқ',
  туралы: 'О',
  why_us: 'Неге біз',
  about_us: 'Біз туралы',
  key_features: 'Негізгі ерекшеліктер',
  solutions: 'Шешім',
  бақылау: 'Мониторинг',
  how: 'Қалай',
  how_it_works: ' Ол қалай жұмыс істейді',
  when_to_use: 'Пайдаланушы',
  mystery_shopping: 'Құпия сатып алушы',
  voicer: 'Voicer',
  wantent: 'Wantent',
  play4sales: 'Play4Sales',
  price_monitoring: 'Баға мониторингі',
  service_design: 'Қызмет-дизайн',
  qualitative_research: 'Сапалы зерттеу',
  quantitative_research: 'Сандық зерттеу',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '# Автомобильдер',
  hashtag_retayl: '#Бөлшек сауда',
  hashtag_all_posts: '# барлық хабарламалар',
  hashtag_feedback: '# кері байланыс',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#іКейстер',
  hashtag_market_research: '# нарықты зерттеу',
  көбірек: 'Көбірек',
  speak_to_an_expert: 'Сарапшыға хабарласыңыз',
  book_consultancy: 'Кеңес беру тапсырысы',
  read_all: 'Барлығын оқу',
  find_out_more: 'Көбірек біліңіз',
  address: 'Мекенжайы',
  mon_fri: 'Дүйсенбі-Жұма',
  phone_number: 'Телефон нөмірі',
  flag: 'жалауша',
  scroll_to_left: 'солға айналдыру',
  онлайн: 'онлайн',
  тел: 'Тел',
  email: 'E-mail',
  light_it_up: 'Жандырыңыз',
  about_us_60: 'Алина Андреева',
  about_us_61: 'Бизнесті дамыту жөніндегі директор',
  about_us_62: 'Юлия Кравченко',
  about_us_63: 'Аға жоба менеджері',
  about_us_64: 'Ольга Аксонова',
  about_us_65: 'Бизнесті дамыту жөніндегі менеджер',
  about_us_66: 'Желевский Дмитрий',
  about_us_67: 'Операциялық директор',
  about_us_roles_1: 'Басқару',
  about_us_roles_2: 'Глобал командасы',
  about_us_roles_3: 'Өнім иелері',
  ad_testing_1: 'Жарнаманы тестілеу',
  ad_testing_2:
    'Жарнамалық науқан - бұл үлкен инвестиция. Сіздің жарнамаларыңыз тиімді екеніне және инвестицияның максималды қайтарымын қамтамасыз ететініне көз жеткізіңіз',
  ad_testing_3: 'Блоктау',
  ad_testing_4: 'Біз қызмет көрсететін салалар',
  ad_testing_5:
    '4Service - бұл клиенттің тәжірибесін зерттеуге мамандандырылған жаһандық зерттеу холдингі',
  ad_testing_6:
    '4Service - маркетингтік және CX-зерттеулердің жаһандық холдингі. Біз әртүрлі кәсіпорындар үшін сараптамалық деректерді жинау қызметтерін ұсынамыз',
  ad_testing_7: 'Cash & Carry',
  ad_testing_8: 'Бөлшек сауда',
  ad_testing_9: 'Электроника',
  ad_testing_10: 'Люкс/Премиум',
  ad_testing_12: 'Автомобильдер',
  ad_testing_13: 'Саяхат және демалыс',
  ad_testing_14: 'Moдa',
  ad_testing_15: 'Банктер',
  ad_testing_16: 'Сағат және әшекейлер',
  ad_testing_17: 'Тұрмыстық техника',
  ad_testing_18: 'Esomar мүшесі',
  ad_testing_19:
    'Біз әртүрлі салалардағы әртүрлі бизнес үшін ad testing жарнама зерттеуін жүргіздік',
  ad_testing_20: 'Сізге жарнаманы тестілеу қажет, егер сіз',
  ad_testing_21: 'Жаңа өнімді немесе қызметті насихаттасаңыз',
  ad_testing_22: 'Дербес тақырыпты талқылау туралы',
  ad_testing_23:
    'Жаңа мақсатты аудиторияға немесе нарыққа қол жеткізгіңіз келсе',
  ad_testing_24: 'Бірнеше дизайн нұсқаларын талқылау',
  ad_testing_25:
    'Басқару топтары немесе инвесторлар үшін тұжырымдаманы тексеру қажет',
  ad_testing_26: 'Сіз сұрақтарға жауап аласыз',
  ad_testing_27: 'Бұл жарнамалар үшін ең жақсы жарнамалық арналар қандай?',
  ad_testing_28:
    'Хабарламаны жеткізу үшін дұрыс визуалды әсерлерді қолданамыз ба?',
  ad_testing_29:
    'Сіздің жарнамалық мәтіндеріңіз бен хабарламаларыңыз жауап таба ма?',
  ad_testing_30: 'Бұл жарнамалар үшін ең жақсы жарнамалық арналар қандай?',
  ad_testing_31: 'Олардың назарын бірінші кезекте не аудартады?',
  ad_testing_32: 'Жарнаманың орналасуы мен макетін түсіну оңай ма?',
  ad_testing_33: 'Біз бағалаймыз',
  ad_testing_34: 'Брендинг',
  ad_testing_35:
    'Сіздің брендіңіз жарнамамен қалай байланысты және ол қаншалықты есте қалады',
  ad_testing_36: 'Негізгі көрсеткіштер',
  ad_testing_37: 'Интеграция',
  ad_testing_38: 'Танулу',
  ad_testing_39: 'Сәйкес келеді',
  ad_testing_40: 'Креатив',
  ad_testing_41:
    'Сіздің жарнамаңыз ерекшелене ме және ол адамдардың назарын аудара ма',
  ad_testing_42: 'Негізгі көрсеткіштер',
  ad_testing_43: 'ТАНУ',
  ad_testing_44: 'МҮДДЕЛІЛІК',
  ad_testing_45: 'MTO',
  ad_testing_46: 'ЫНТАЛАНДЫРУ',
  ad_testing_47: 'Клиенттердің тәжірибесі, эмоционалды өзара әрекеттесу',
  ad_testing_48:
    'Жасанды интеллект технологиялары мен сарапшы аналитиктердің көмегімен біз адамдардың нақты эмоцияларын талдаймыз және олардың жарнаманы қабылдауы туралы түсінік аламыз',
  ad_testing_49: 'Рейтинг',
  ad_testing_50: 'Ерлер',
  ad_testing_51: 'Әйел',
  ad_testing_52: 'Жоғары қатысу',
  ad_testing_53: 'Назар аударыңыз',
  ad_testing_54: 'Аудиторияға не ұнады және жауап берді?',
  ad_testing_55: 'Актриса',
  ad_testing_56: 'Тепе-теңдік',
  ad_testing_57: 'Музыкалық фон',
  ad_testing_58: 'Жағымды эмоциялар',
  ad_testing_59: 'Әр түрлі нәсілдер мен сыртқы түрдегі адамдар',
  ad_testing_60: 'көшедегі суреттер',
  ad_testing_61: 'Аудиторияға НЕ ұнамады және жауап таппады?',
  ad_testing_62:
    'Диктордың дауысы экранда болып жатқан оқиғаларға сәйкес келмеді',
  ad_testing_63: 'Өнімге төмен назар',
  ad_testing_64: 'Аса динамикалық',
  ad_testing_65: 'Түсіну қиын',
  ad_testing_66: 'TRP',
  ad_testing_67: 'Әсерлер',
  ad_testing_68: 'Көрсетілімдер',
  ad_testing_69: 'Конверсия',
  ad_testing_70: 'Медиа',
  ad_testing_71:
    'Біз әр түрлі арналардағы медиа инвестициялардың бақыланатын нәтижелерге әсерін есептеу арқылы жарнамалық науқанның тиімділігін медиа белсенділігімен өлшейміз.',
  ad_testing_72:
    'Біз кез-келген форматта, кез-келген платформада немесе арнада жарнамалық зерттеулер жүргіземіз',
  ad_testing_73: 'бейне контент',
  ad_testing_74: 'сыртқы жарнама',
  ad_testing_75: 'теледидарлық жарнама',
  ad_testing_76: 'полиграфия',
  ad_testing_77: 'сандық',
  ad_testing_78: 'жарнамалық науқандар',
  ad_testing_79: 'сату нүктелеріндегі жарнамалық материалдардың орналасуы',
  ad_testing_80: 'аниматика',
  ad_testing_81:
    'біздің көмегімен сіз өзіңіздің жарнамаңызды кез-келген кезеңде тексере аласыз',
  ad_testing_82: 'Тұжырымдама',
  ad_testing_83: 'қандай идеялардың мүмкіндіктері көп?',
  ad_testing_84: 'Өндірістің ерте кезеңі',
  ad_testing_85: 'қандай аниматика өндіріске жұмсалады?',
  ad_testing_86: 'Өндіріс',
  ad_testing_87: 'назар аудару үшін бейнені қалай өңдеуге болады?',
  ad_testing_88: 'Пре-медиа',
  ad_testing_89:
    'қандай байланыс арналары жұмыс істейді және қандай нәтиже күтуге болады?',
  ad_testing_90: 'Жарнамадан кейінгі тестілеу',
  ad_testing_91: 'Өндіріс',
  ad_testing_92:
    'менің жарнамам қызықтырады ма? Уақыт өте келе шығармашылықтың тиімділігі төмендей ме?',
  ad_testing_93: 'Басып шығару алдындағы дайындық',
  ad_testing_94:
    'менің жарнамам сандарда қаншалықты тиімді? Ол бәсекелестікпен қалай салыстырылады?',
  ad_testing_95: 'Жарнаманы алдын ала тексеру',
  ad_testing_96: 'Сізге сапалы деректер беру үшін біз қолданамыз',
  ad_testing_97: 'Сандық зерттеу әдіснамасы',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'Сапалы зерттеу әдіснамасы',
  ad_testing_100: 'Фокус-топтар',
  ad_testing_101: 'ИИ',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'Сіз алатын аналитикалық есептер',
  ad_testing_104:
    'Біздің талдаушылар, медиа сарапшылар, маркетологтар тобы сізге егжей-тегжейлі ұсыныстармен жеке есеп дайындайды және ұсынады',
  ad_testing_age: 'Жас',
  ad_testing_ad: 'Хабарландыру',
  automotive_industry_price_analysis_1:
    'Автомобиль өнеркәсібіндегі бағаны талдау',
  automotive_industry_price_analysis_2:
    'Бәсекелестік бағаны талдау жоғалған пайданың алдын алуға, нарық үлесін арттыруға және нарықтағы позицияңызды бақылауға көмектеседі. Сізге сәтті бәсекелестік стратегияны таңдауға көмектесуге рұқсат етіңіз!',
  automotive_industry_price_analysis_3: 'Коммерциялық ұсынысты сұрату',
  automotive_industry_price_analysis_4: 'Біздің әдістеме',
  automotive_industry_price_analysis_5:
    'Стильді және талғампаз адамдарға арналған автокөлік салоны.',
  automotive_industry_price_analysis_6:
    'Mystery Shopping әдісі - бұл клиенттің нақты тәжірибесін дәл көрсететін және сенімді шолуды қамтамасыз ететін жалғыз тәсіл.',
  automotive_industry_price_analysis_7:
    'Біз нақты сандар мен сенімді көпжақты деректерді ұсынамыз',
  automotive_industry_price_analysis_8:
    'Бізде әлемнің әр елін қамтитын жаһандық қамту бар.',
  automotive_industry_price_analysis_9:
    'Біздің ішкі ресурстарымызға құпия сатып алушылар мен аудиторлар кіреді',
  automotive_industry_price_analysis_10:
    'Біз деректеріміздің сапасын тексереміз',
  automotive_industry_price_analysis_11: 'Біздің артықшылықтарымыз:',
  automotive_industry_price_analysis_12:
    'Бәсекелестердің нақты модельдерінің бағасының мониторингісі (B2B және B2C)',
  automotive_industry_price_analysis_13: 'жеңілдік деңгейінің мониторингі',
  automotive_industry_price_analysis_14:
    'Бөлшек саудадағы бренд пен бәсекелестердің сауда қорларын қадағалау',
  automotive_industry_price_analysis_15:
    'Электрондық коммерциядағы автомобиль бағасының монитрингі',
  automotive_industry_price_analysis_16: 'Баға байланысын талдау',
  automotive_industry_price_analysis_17:
    'Бөлшек саудагерлерді жеткізу құнын бақылау',
  automotive_industry_price_analysis_18:
    'Бөлшек сауда дүкендеріндегі акциялар мен сатылымдарды бақылау',
  automotive_industry_price_analysis_19: 'Ай сайынғы төлем сомаларын анықтау',
  automotive_industry_price_analysis_20: 'Лизингтік төлемдерді есептеу',
  automotive_industry_price_analysis_21:
    'Электромобильдерге (ЭМ) баға белгілеудің нақты факторларын талдау',
  automotive_industry_price_analysis_22:
    'Тұтынушыға тікелей сату мен бөлшек сауда дүкендері арқылы сату арасындағы бағаны салыстыру',
  automotive_industry_price_analysis_23:
    'Жазылым бойынша баға белгілеу модельдерін әзірлеу',
  automotive_industry_price_analysis_24:
    '4Service - бұл 20 жылдан астам уақыт бойы клиенттің тәжірибесін (CX) құруға және жақсартуға маманданған халықаралық холдинг',
  automotive_industry_price_analysis_25:
    'Сіз өзіңіздің ұсынысыңызды оңтайландыру және мақсатты аудиторияңыздың маңызды сипаттамаларын анықтау үшін тұтынушылардың әртүрлі мүмкіндіктерге ақы төлеуге дайын деректерін пайдалана аласыз.',
  automotive_industry_price_analysis_26:
    '4Service-тен автомобиль индустриясындағы бағаны талдау:',
  automotive_industry_price_analysis_27:
    'Ең төменгі бағалар әрқашан автомобиль брендтерінің бәсекеге қабілеттілігінің кілті бола бермейді. Сізге ұзақ мерзімді баға стратегиясын құруға көмектесуге рұқсат етіңіз',
  automotive_industry_price_analysis_28:
    'клиенттер бағаның барлық брендтерде өсетінін түсінеді',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'клиенттер бренд оларға алдағы бағаның өсуі туралы хабарласа да, өздеріне ұнайтын көлікті сатып алатынын айтты,',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'адамдар лизинг пен ай сайынғы төлемдерді олар үшін көлік сатып алу кезінде ең қолайлы модель деп санайды',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'дилерлер байланыс/сату процесінде бағаны көтеру мүмкіндігі туралы айтады',
  automotive_industry_price_analysis_35: '47,6',
  automotive_industry_price_analysis_36: 'Негізгі көрсеткіштер',
  automotive_industry_price_analysis_37:
    'Сіз өз өніміңіздің бағасын желідегі басқа көліктерге қатысты анықтайсыз',
  automotive_industry_price_analysis_38:
    'Сіз өзіңіздің ұсынысыңызды оңтайландыру және мақсатты тұтынушыларыңыз үшін ең маңызды мүмкіндіктерді анықтау үшін тұтынушылардың әртүрлі мүмкіндіктерге ақы төлеуге дайын деректерін пайдаланасыз',
  automotive_industry_price_analysis_39:
    'Сіз бәсекелестікке қатысты артықшылықтарыңызды толығырақ түсіне аласыз.',
  automotive_industry_price_analysis_40:
    'Сіз ай сайынғы төлемнің тиісті мөлшерін және жалдау мөлшерлемесін анықтай аласыз.',
  automotive_industry_price_analysis_41:
    'Сіздің брендіңіз немесе дилеріңіз үшін қандай артықшылықтар аласыз:',
  automotive_industry_price_analysis_42: 'Сіз өтініш бересіз',
  automotive_industry_price_analysis_43:
    'Біздің менеджер негізгі мақсаттарды анықтау үшін сізбен байланысады',
  automotive_industry_price_analysis_44:
    'Біз маркетингтік зерттеулер жүргіземіз',
  automotive_industry_price_analysis_45:
    'Біз сізге үнемі онлайн форматта есептер мен ұсыныстар береміз',
  automotive_industry_price_analysis_46: 'Сату белгісі бар көлік',
  automotive_industry_price_analysis_47: 'Біз жобаны 1 күнде бастаймыз!',
  automotive_industry_price_analysis_48:
    'Біз фото есептерді, PPT есептерін және елдімекен түрі бойынша сегменттелген Excel форматындағы есептерін қоса есептердің толық жиынтығын ұсынамыз',
  retail_audit_1: 'Сауда желілерінің аудиті/Бөлшек сауда аудиті',
  retail_audit_2:
    'Дүкеніңіз немесе брендіңіз туралы егжей-тегжейлі мәліметтер жинаңыз, өсу кедергілерін талдаңыз және оларды жеңудің тиімді стратегияларын жасаңыз',
  retail_audit_3: 'Коммерциялық ұсынысты сұрау',
  retail_audit_4:
    '4Service мақсатты нарыққа жету үшін олардың жарнамаларының, орындаушы командаларының және маркетингтік тактикаларының тиімділігін бағалау үшін брендтер атынан жергілікті дүкендерге аудит жүргізеді',
  retail_audit_5:
    'Біз жарнамалық науқандарды мұқият қадағалаймыз және жарнамалық нұсқаулықтарды орындаймыз',
  retail_audit_6: 'Еуропадағы Үздік 10',
  Retail_audit_7: 'CX агенттіктері',
  retail_audit_8: 'тәжірибе жылдары',
  retail_audit_9: 'елдерді қамту',
  retail_audit_10: 'Жылына 1,6 миллион',
  retail_audit_11: 'бағалау',
  retail_audit_12: 'Біз нені қадағалаймыз?',
  retail_audit_13: 'Сату нүктелеріне арналған материалдардың болуы (POS)',
  retail_audit_14:
    'Бренд өкілдерінің қатысуы және белсендірілуі, жоспарланған кестенің сақталуын қамтамасыз ету',
  retail_audit_15: 'Қолдау науқандарына бренд өкілдерінің қатысуын бағалау',
  retail_audit_16:
    'Тұтынушылардың өзара әрекеттесуін бағалау, жарнамалық бағдарламалар мен брендтік хабарламаларды орындау',
  retail_audit_17: 'Алаяқтықтың алдын алу шаралары',
  retail_audit_18:
    'Сіздің бизнесіңіз сауда нүктесінде маркетингтік аудит нәтижелерін пайдалана алады:',
  retail_audit_19: 'Бюджет пен процестердің сәйкестігін бағалау',
  retail_audit_20: 'Нақты нәтижелерді берілген мақсаттармен салыстыру',
  retail_audit_21: 'Маркетингтік науқанның тиімділігін жақсарту',
  retail_audit_22: 'Болашаққа стратегиялық жоспарлау',
  retail_audit_23: 'Шығындарды азайту мүмкіндіктерін анықтау',
  retail_audit_24: 'Сату және конверсия көлемін арттыру',
  retail_audit_25: 'Инвестициялық кірісті оңтайландыру (ROI)',
  retail_audit_26:
    'ОЛАР 4SERVICE-ТІ САУДА-САТТЫҚҚА ИНВЕСТИЦИЯЛАР БОЙЫНША СЕРІКТЕС РЕТІНДЕ ТАҢДАДЫ',
  retail_audit_27:
    'Темекі өнімдерінің жетекші халықаралық өндірушісі 4Service компаниясымен өз брендтерін нығайту және дүкендердің жұмысын жақсарту мақсатында серіктес болды. Біздің командалар сайтта маркетингтік аудит жүргізді және тұтынушылардың тәжірибесі туралы нақты есеп беру жүйесін жүзеге асырды',
  retail_audit_28:
    'маркетинг агенттігінің сауда нүктелерін жоспарлау дәлдігін арттыру',
  retail_audit_29: 'бренд хабарламаларын жеткізуді арттыру',
  retail_audit_30:
    'бренд өкілдерінің қатысуын арттыру (тұтынушыларды белсендіру)',
  retail_audit_31: 'деректерді жинау дәлдігін және GDPR сәйкестігін арттыру',
  retail_audit_32: 'Біз әдетте қандай құнды түсініктер аламыз:',
  retail_audit_33:
    'Клиент үшін айтарлықтай артық шығындарға әкелетін SLA шарттары арасындағы дәйектіліктің болмауы немесе тіпті қақтығыстар',
  retail_audit_34:
    'Қызмет құнын дұрыс есептемеуге әкелетін қызмет түрлерімен түсініспестік',
  retail_audit_35:
    'Дала жұмыстары жүргізілмейді (жоспарланған орынға немесе POS-қа персонал тағайындалмаған жағдайларды қоса)',
  retail_audit_36:
    'Есептеулер нақты көрсеткіштер емес, бағалау негізінде жасалады және келісілмейді',
  retail_audit_37:
    'Промо-нұсқаулық дұрыс емес деректерді бере отырып, дұрыс пайдаланылмайды',
  retail_audit_38: 'Біз қалай жұмыс істейміз?',
  retail_audit_39:
    'Біздің аудитор агенттіктің белсендіру жоспарына сәйкес белгілі бір сату нүктелеріне (POS) барады.',
  retail_audit_40:
    'Ол брифингте көрсетілгендей өнімділіктің негізгі көрсеткіштерін (KPI) бағалайды, мысалы, сату орындарында болу, бренд өкілдерінің қатысуы, жылжыту бойынша ұсыныстарды орындау және алаяқтықтың алдын алу шаралары.',
  retail_audit_41: 'Сенімділікті растау:',
  retail_audit_42: 'Біз алынған деректерді жинаймыз және жүйелейміз',
  retail_audit_43: 'Егжей-тегжейлі есеп дайындаймыз.',
  retail_audit_44:
    'Біздің тексеру тобы барлық сауалнамаларды, соның ішінде жоба брифингіне сәйкестікті және кез келген қосымша түсініктемелерді мұқият тексереді.',
  retail_audit_45: 'Онлайн есеп беру жүйесі:',
  retail_audit_46:
    'Толтырылған және тексерілген сауалнамалар біздің онлайн порталға 36 сағат ішінде жүктеледі.',
  retail_audit_47:
    'Клиенттер порталдағы жеке шотқа қол жеткізе алады, бұл оларға кез-келген уақытта прогресті бақылауға мүмкіндік береді.',
  retail_audit_48: 'Нәтижелер мен ұсыныстарды қамтитын соңғы есеп беріледі.',
  retail_audit_49: 'Сарапшыға хабарласыңыз',
  retail_audit_50: 'Біздің күшті жақтарымыз:',
  facility_check_audit_1: 'Объект',
  facility_check_audit_2: 'Аудиттік тексеру',
  facility_check_audit_3: 'Брендтік өтінім деңгейін детальдармен арттыру',
  facility_check_audit_4: 'Біздің қызметімізді тексеру',
  facility_check_audit_5: 'Біз туралы',
  facility_check_audit_6: 'Біз кімбіз',
  facility_check_audit_7:
    'Клиенттік тәжірибе аймағының еңбегінде әлемдегі лидер болып 4Service брендтерге клиенттеріне шын міндеттемелі тәжірибелер жасау және ұсынуға көмектесетін қылыптық қызметтер жиынтығын ұсынады.',
  facility_check_audit_8: 'Объектті тексеру қызметіміз',
  facility_check_audit_9:
    'сіздің магазиндеріңіздің және ұялардың брендтік стандарттарға қатысуы мен клиенттердің өзгерістерге көшуін тексеру үшін жасалды.',
  facility_check_audit_10: 'Шешімдер 1',
  facility_check_audit_11: 'Объектті тексеру',
  facility_check_audit_12:
    'брендтік стандарттарыңызға сәйкес көрінісін бақылау үшін жасалған толықтырудың ілесін тексеру, сізге тексерудің физикалық құралдарын тексеруден басқа, олардың клиенттеріңізге сіздің брендіңіз туралы көрсеткен ерекшеліктерін қалайтын екенін бағалаймыз.',
  facility_check_audit_13: 'Екі шешімдер',
  facility_check_audit_14: 'Жетімдідіктерді орындау',
  facility_check_audit_15: 'Шешім',
  facility_check_audit_16: 'Объектті аудиторлармен тексеру',
  facility_check_audit_17: 'Объектті тексеруді растау',
  facility_check_audit_18: 'Есептер',
  facility_check_audit_19:
    'Сізге көрсетілетін есептерді, көрінетін дәлдіктермен және статистикамен бірге, 48 сағат ішінде қол жетімді',
  facility_check_audit_20:
    'Объекттің жетекші бағалануы сіздің брендіңізге көптеген мақсаттарға жеткізе алатын көптеген мақсаттар ұсынуы мүмкін, оның арасында:',
  facility_check_audit_21: 'Клиенттердің айырбастауы',
  facility_check_audit_22:
    'Позитивті клиенттік тәжірибе сатылымдарды және қайталымдарды көбейтіп алатын болады. Біздің тексерулеріміз клиенттердің қанағаттануын өзгертуге және болмаған жағаларды анықтауға көмектесе алатын.',
  facility_check_audit_23: 'Брендтік суретті қосу',
  facility_check_audit_24:
    'Сіздің физикалық орныңыз клиенттер үшін негізгі байланыс нүктесі, сондықтан олар сіздің брендіңіздің суретін қалпына келтіруде маңызды рөл атқарады. Біздің тексерулеріміз сіздің орныларыңыздың сіздің брендтік құндылықтарыңызға сәйкес келетіні мен клиенттердің қанағаттануын жасауға көмектесе алатын.',
  facility_check_audit_25: 'Себептеріміз',
  facility_check_audit_26: 'Объектті тексеру неге маңызды?',
  facility_check_audit_27: 'Жетімділіктерді орындау',
  facility_check_audit_28:
    'Сіздің физикалық орныңыз клиенттер үшін негізгі байланыс нүктесі, сондықтан олар сіздің брендіңіздің суретін қалпына келтіруде маңызды рөл атқарады. Біздің тексерулеріміз сіздің орныларыңыздың сіздің брендтік құндылықтарыңызға сәйкес келетіні мен клиенттердің қанағаттануын жасауға көмектесе алатын.',
  facility_check_audit_29: 'Клиенттердің айырбастауы',
  facility_check_audit_30: 'Қолданушылардың конверсиясын жақсарту',
  facility_check_audit_31:
    'Позитивті қолданушы тәжірибесі сатылымдарды көбейту және қайталанатын сатылымдарға себеп болуы мүмкін. Біздің аудиттеріміз келесі кездегі бөлімдерді анықтау және жоюға көмектесе алады, олар қолданушылардың қуанталығын өзгертуге көмектеседі.',
  facility_check_audit_32: 'Кім қажет екен',
  facility_check_audit_33: 'Объектілерді тексеру кімдерге қажет?',
  facility_check_audit_34:
    'Объекттерді тексеру көмегі дайыншылықтары бар барлық брендтерге, физикалық орналасулар мен жаңа жағдайда болатын брендтерге. Оларда артықшылықтар қажет, қызмет көрсетуші',
  facility_check_audit_35: 'Бренд стандарттарына сәйкес келу',
  facility_check_audit_36:
    'Біздің аудиттеріміз сіздің орналасуларыңыздың сіздің бренд стандарттарыңыздан айыруы мүмкін болатын кездерді анықтауға көмектеседі.',
  facility_check_audit_37: 'Қолданушы тәжірибесін жақсарту',
  facility_check_audit_38:
    'Біздің аудиттеріміз сіздің орналасуларыңыздағы қолданушы тәжірибесін жақсарту мүмкіндіктерін анықтауға көмектеседі.',
  facility_check_audit_39: 'Құрметті бренд құру',
  facility_check_audit_40:
    'Біздің аудиттеріміз сіздің физикалық орналасуыңыздың қолданушыларға позитивті талпыныстар қалай жасалуын тексеретініне көмектеседі.',
  acility_check_audit_41:
    'Күйге шыққан алдыңғы тұтынушы анықталған орнында барлық суреттерді жасайды.',
  facility_check_audit_42:
    'Содан кейін күйге шыққан алдыңғы тұтынушы мәліметтер көрсетеді және суреттерді қосады.',
  facility_check_audit_43:
    'Тексеруші суреттерді алып, оларды стандарттарға сәйкестікке тексереді.',
  facility_check_audit_44: 'Эксперт аудиторлар арқылы объектілерді тексеру',
  facility_check_audit_45: 'Дайындау кезеңі',
  facility_check_audit_46: 'Аудит кестесін бекіту кеңеске салу',
  facility_check_audit_47:
    'Дилерлер дайындалады және аудит келіп тұруы туралы хабардар етіледі',
  facility_check_audit_48: 'Аудиторларды дайындау',
  facility_check_audit_49:
    'Бренд басшыларының нұсқауларымен сәйкес 4Service аудиторларын дайындау',
  facility_check_audit_50: 'Объектті тексеру кезеңі',
  facility_check_audit_51:
    'Осылай жазбалармен жеткізілген аудиторлар орынды қарауға бара алатын жерлерге келеді',
  facility_check_audit_52:
    'Құрылымдық ұқсасыздан кейін, ұсыныстарға сәйкес, әр бір нүктені толықтай зерттеу',
  facility_check_audit_53:
    'Басқармасыздықтың жоғары сапалы нысандарымен бірге көрсетілген көркем документтау',
  facility_check_audit_54: 'PPT пішінде аяқталған есептік шот',
  facility_check_audit_55:
    'Нәтижелерді түсіндіруге арналған толықтырушы PowerPoint есебі',
  facility_check_audit_56:
    'Аудит нәтижелерін алдын алу арқылы онлайн/офлайн көрсету',
  facility_check_audit_57: 'Объект аудитін валидациялау',
  facility_check_audit_58: 'Босқыты',
  facility_check_audit_59: 'Объектін тексеру босқыты',
  facility_check_audit_60:
    'Брендтің нысандары үшін 4Service қосымшасын пайдаланып фотосуреттерді орналастыру',
  facility_check_audit_61:
    'Күрделі визуалды және сипаттамалық мәртебелерді сақтау',
  facility_check_audit_62: 'Валидация босқыты',
  facility_check_audit_63:
    'Суреттердің ішкі күрделілігі бойынша күрделі валидаторлар әр бір есепті тексереді',
  facility_check_audit_64: 'Фотосуреттерді бренд стандарттарымен толықтыру',
  facility_check_audit_65:
    'Түсіндірмелер және аналитика есебі арқылы күрделілікке көмектесу',
  facility_check_audit_66:
    'Суреттердің толықтыруы үшін аудиторлармен тікелей байланыс, егер қажет болса',
  facility_check_audit_67: 'Есептілік кезеңі',
  facility_check_audit_68:
    'Суреттермен және статистикалық деректермен бірге берілген есептер, екі күн ішінде қолжетімді',
  facility_check_audit_69: 'Бізбен байланысыңыз',
  cx_solution_1: 'Біз тек дүрт табындылар табуда артықшылық жоқ',
  cx_solution_2:
    'Біз сіздің бизнесті жаңа деңгейлерге жеткізу арқылы жеткіземіз',
  cx_solution_3:
    'Қолданушылармен 20 жылдық тәжірибесі бар эксперттер бұздырма бағдарламаларды жасау және олардың жеткілікті жеткізуіне арналған жасылған іс-шаралар көрсетеді',
  cx_solution_4:
    'Біреуілік талаптарға сай адалдықты бекіту үшін бір жеткілікті бағдарламада ұсынылған құрылымдардың ерекше тізімін ашыңыз',
  cx_solution_5: 'Бір жеткілікті қолжетімділікке арналған барлық жүйелер',
  cx_solution_6: 'Рекламаны тексеру',
  cx_solution_7: 'Искусственный интеллект және нейромаркетинг',
  cx_solution_8: 'Қолданушының денесі',
  cx_solution_9: 'Кабинеттік зерттеу',
  cx_solution_10: 'Қолданушы маршруты картасы',
  cx_solution_11: 'Жасырын сатып алу',
  cx_solution_12: 'CX кеңесі',
  cx_solution_13: 'Әлеуметтік медианың тығыздандыруы',
  cx_solution_14: 'Сандық және сапалы зерттеулер',
  cx_solution_15: 'Қызмет дизайны',
  cx_solution_16: 'Маркетингтік стратегия',
  cx_solution_17: 'UX/UI тестілеу',
  cx_solution_18: 'Аудиторлық мәселелер',
  cx_solution_19: 'Біз сізге сәттілікке жетуге көмектесеміз',
  cx_solution_20:
    'Біз сіздің бизнес нығайтын мақсаттарыңыз мен міндеттеріңіз негізінде құрылымдар мен қызметтерді орнатамыз және білімді бір жеткізу планын береміз',
  cx_solution_21: 'Жедел зерттеулер',
  cx_solution_22:
    'Деректерді негізге алып, сатылымдық қорытындыны тексеру арқылы сіздің рынға байланысты байланысты артықшылық сыйлықты беру',
  cx_solution_23:
    'Сапалы зерттеулер - концепциялар, мәнілер немесе төмендегі деректерді түсіну үшін санарлықты аударуда қолданылады',
  cx_solution_24:
    'Санарлық зерттеулер әділ саналатын және деректерді саналатын және саналатын деректерлерді ұсынатын санарлық методтарды қолдануды айтады',
  cx_solution_25:
    'Біз сіздің кез келген қажеттарыңызға байланысты қолданылатын арнайы құралдар тізімін пайдаланамыз',
  cx_solution_26: 'Құралдар',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'Веб-көмекші арқылы компьютерлік интервью - біздің арсеналдагы мақсатындағы мақсатында өндірілген, онлайн-платформалар арқылы мәліметтерді талдау және топтау үшін пайдаланылатын специалды программалық жабдық, мәліметтерді ұсынудың ыңғайлы және точный қолдауына болады',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'Телефон арқылы компьютерлік интервью - біз пайдаланамыз сұрақты жауап беруді және мәліметтерді сабақтау үшін арнайы программалық жабдықты қолданамыз, биздің ұсыныстарымыздың точнылығын ұсынады, жобаларды аяқтауға қызмет етеді',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'Жүзге жүз келісім - біздің жақындасуымыздың бітімді бөлігі, клиенттермен және тапсырышшылармен директ тіркелу мен жеке әрекеттерге жеткізу арқылы құпия байланыстыру, түзету және бизнес сәттілігіне жеткізу үшін қажетті сенімділік, түсіну және тиісті байланысқан әрекеттерді көрсету',
  cx_solution_33: 'Дайындалу зерттеу',
  cx_solution_34:
    'Дайындалу зерттеу көбірек мәліметтерді жинау мен талдау қамтамасыз ететін және біздің клиенттеріміздің мақсаттарын талдау мәртебесінің құрылымы болып табылады',
  cx_solution_35: 'SWOT-талдау',
  cx_solution_36:
    'SWOT-талдау біздің клиенттерімізге шекара қалуға көмектесетін стратегиялық орнықты құрылымды арналған аналитикалық құралдардың бірі',
  cx_solution_37: 'Этнографиялық зерттеу',
  cx_solution_38:
    'Адамдар мен мәдениеттердің қарауы мен бақылау арқылы тұрғылықта және қаруланған мекен-жайларында байланысу арқылы адамдарды зерттеу, күйін, ой-жүзді және әлеуметтік динамикалардың толық түсінігіне жету',
  cx_solution_39: 'Көлікті сұрақтар',
  cx_solution_40:
    'Көлікті сұрақтар - бұл көптеген жағдайлар мен субъектілердің арасындағы ерекшеліктерімен саралаған және бір-бірімен байланысты көлікте көптеген деректерді көлікте бағалайды, осы себепті клиенттерімізге шешімдер қабылдауға және бизнес стратегияларын жаңартуға көмектеседі',
  cx_solution_41: 'Сандық сессиялар',
  cx_solution_42:
    'Идеялар сессиялары - бұл біздің клиенттеріміздің чалтырылған мұраларын жасауға және олардың күштіктерін және ерекшеліктерін танымалуға көмектесетін коллективті іс-шаралар',
  cx_solution_43: 'Сатып алушы құрылғылары',
  cx_solution_44:
    'Сатып алушы құрылғылары - бұл деректерді жүйелеу және талдаудың нәтижесінде, олардың міндеттерін, көрінісін және әрекеттерін тұңғыш ұсыныстар мен мақсаттар арқылы сараптайтын ерекше түрлі құрылғылар',
  cx_solution_45: 'Жасырын сатып алу',
  cx_solution_46:
    'Жасырын сатып алу - бұл біздің клиенттерге көмектесетін стратегиялық қызмет, кіріспе мен компания арасында көрсетілетін интерфейстерді қолдау, нәтижесінде ұсыныстардың көптеген күшін біріктіретін көптеген инсайттерді береді',
  cx_solution_47: 'Тексеру сағаттары',
  cx_solution_48:
    'Тексеру сағаттары - бұл клиенттеріміздің клиенттік жолы бойынша әр салмақты көруді қамтамасыз ететін арнайы таймырларды ұсынамыз',
  cx_solution_49: 'Пікірлерді тіркеу және талдау',
  cx_solution_50:
    'Пікірлерді тіркеу және талдау - бұл біздің клиенттерімізден келген шешімдерге байланысты және шешімдерге және және бизнес көрсеткіштеріне негізделген деректерді сынап алу және анализдау процесіндегі негізгі адамдардың бірлестігін айқындату құралы',
  cx_solution_51: 'Фокус-топтар',
  cx_solution_52:
    'Фокус-топтар - бұл біздің клиенттердің кейінкі тақырыптар немесе өнімдер туралы күбікті іздеу үшін жасалған динамикалық зерттеу сессиялары',
  cx_solution_53: '20 жыл асқатты клиенттердің төменгі жағдайын жасау',
  cx_solution_54:
    'Сіздің хабарламаңыз аудиторияңызға әкеліп, олармен жазылып түскенде де көркем қалады.',
  cx_solution_55: 'Біз сіздің күлігіңізді алдамайды деген нәтиже аламыз',
  cx_solution_56:
    'Жетіспеніңізді арттыруға жеткізу үшін бүтіндей шешімдер табамыз',
  cx_solution_57:
    'Біздің тәжірибелілік бойынша жетекшілігіңізді жою үшін өздерінің тәжірибесін көтеріңіз',
  cx_solution_58:
    'Сатып алу жолы картасы - мақсатты аудиторияның анықталуы, олардың міндеттері мен асқағандарын анықтау және одан кейін сұралымды клиенттерге ықпал жасауға арналған жоспарламаны жасау',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'Брендтік мәртебенің анықталуы сіздің брендіңіздің ағымдағы деңгейін алдамайды және позициялауын және оның жұмысын бағалауға көмектеседі',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'Мүшелердің құттығысы Индексі - бұл сіздің қызметкерлеріңіздің әрекеттерінің сапасын бағалауға көмектесетін стандартты метрикалар',
  cx_solution_63:
    'Бағаларды бақылау - бұл сыйымдықтардың, қайта түсетіндердің және талдаулардың өңдеу, қалпына келтіру және талдаулардың анализі процесі',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'Клиенттердің құттығы оценкасы - бұл бір сұраққа негізделген ақ метрикалардың түзетілуі',
  cx_solution_66: 'HR зерттеулері',
  cx_solution_67:
    'HR мәнінде зерттеу - кадрлама мен басқару үрдістерінің әдістері мен орындалуын бағалау үшін пайдаланылатын исследованиялар',
  cx_solution_68:
    'Пайдалану жеткілігін тексеру - реалды адамдардың веб-сайт, қолданба немесе басқа өнімге қалай қатынастығын көру, олардың әрекеттерін және реакцияларын көру әдісі',
  cx_solution_69: 'Басқа',
  cx_solution_70:
    'Мамандар сіздің бизнесіңіз үшін ең жақсы әдістемелерді таңдайды',
  cx_solution_71: 'Бастау керек',
  cx_solution_72: '1 - БАСТАУ ЖЫЛЫ',
  cx_solution_73:
    'Бастау кезінде біз негізгі міндеттерді анықтап, оларға қосымшау жасамамыз. Нәтижесі',
  cx_solution_74: '2 - КОНЦЕПЦИЯНЫ ДАМЫТУ',
  cx_solution_75:
    '4Service аналитика бөлімі деректерді ағымдағыдағы тізімдеуді біріктіреді, есептік жобаның үлгісін куәландырады. Сонан соң біз мүшелерге нәтижелерді көрсетеміз, оларды зерттеуді және оларды орындауға арналған мақсаттарды рекомендативтерімен толтырамыз.',
  cx_solution_76: '3 - ТЕРЕЛУ ДАМЫТУ',
  cx_solution_77:
    'Досында мектепке қабылдау үшін қатысушыларды таңдау, интервью жасау және басқа да негізгі зерттеу кезеңдерін орындау үшін. Клиент аудио-бейне интервьюлар мен жалпы қысқаруларды алады.',
  cx_solution_78: '4 - АНАЛИТИКА',
  cx_solution_79:
    '4Service аналитика бөлімі деректерді ағымдағыдағы тізімдеуді біріктіреді, есептік жобаның үлгісін куәландырады. Сонан соң біз мүшелерге нәтижелерді көрсетеміз, оларды зерттеуді және оларды орындауға арналған мақсаттарды рекомендативтерімен толтырамыз.',
  cx_solution_80: '5 - ЖҰМЫСШЫЛЫҚ',
  cx_solution_81: 'Орындау жоспары бойынша клиентпен шығармашылық оқиғалары',
  cx_solution_82:
    'Қажеттілігінше жаңаған біздің ең үздік практикалар туралы ақпарат алыңыз',
  cx_solution_83:
    'Мүшелердің барлық байланыс каналдарын зерттеу, есептік контакттық нүктелерде мүмкіндік қайталамаларды анықтау және жоспарланған курстан азап алған аудандарды толық үйрену мүмкіндігін береді.',
  cx_solution_84: 'Осы не қолданылады?',
  cx_solution_85:
    'Жаңа мәліметтерге негізделген шағын рекламалық қампания құру',
  cx_solution_86:
    'Мақсатты аудитория тобының триггерлерін анықтау және олардың міндеттерін болжау',
  cx_solution_87:
    'Әрбір тобыға төмендегі жұмыстарда көз жеткізу және ең көп конверсияны алу',
  cx_solution_88:
    'Қолдау техникасы мақсаттарыңыздың ең оптималды жолдарын анықтау мүмкіндігін береді.',
  cx_solution_89: 'Жаңа веб-сайт немесе өнімді дайындау алдындағы тексеру',
  cx_solution_90: 'Өзгерістерді енгізу алдында дайындалған процестерді тексеру',
  cx_solution_91:
    'Сатылымды төмендеу шарттарыда веб-сайт немесе өнімді тексеру',
  cx_solution_92: 'Мүшелердің қажеттіліктеріне сай түрлі өнімдерді шығару',
  cx_solution_93:
    'Рынокта басшылықты кепілдейтін қарызды компанияларды зерттеу',
  cx_solution_94:
    'Біз клиентке байланыстырылған біздің 360° модельдік қызмет моделін жасауға жақсы қарастырамыз.',
  cx_solution_95: 'Қызметкерлерді оқыту және дамыту',
  cx_solution_96: 'Қызмет стандарттарын арттыру',
  cx_solution_97: 'Мүшелердің және сатылымдардың салмағын көбейту',
  cx_solution_98: 'Қызметкерлер үшін KPI және мотивация жүйесін орнату',
  cx_solution_99: 'Біздің жетекшілікті тарихтарымызды зерттеңіз',
  cx_solution_100: 'Автомобильдік салу',
  cx_solution_101: 'Тамақтану саласы',
  cx_solution_102: 'Тасмалар сату',
  cx_solution_103: 'Сапалы фаза',
  cx_solution_104: 'Санысы фаза (сегментация)',
  cx_solution_105: 'Фокус-топтаулар',
  cx_solution_106: 'Онлайн режимде аудиторияның көлемі',
  cx_solution_107: 'Інтервьюды орналастыруда қалыпты техниканы қолдану',
  cx_solution_108: 'Тек ашық сұрақтар',
  cx_solution_109: '24/7 ретінде участкенділерді қолдау',
  cx_solution_110:
    'Маңызды мәліметтер мен жолдамалықтарды сақтау және жасау жолын сақтау',
  cx_solution_111: 'Маркетингтік зерттеулер',
  cx_solution_112: 'Компания мен конкуренттерді диагностикалау',
  cx_solution_113:
    'Жаңартылған қызмет көрсету моделі және жаңа бизнес процестер',
  cx_solution_114: 'Мүшелердің бағытталған қызметін алғашқылату',
  cx_solution_115:
    'Өзгерістерді орындау және қызмет стратегияларының дамытуын бақылау',
  usage_attitude_1: 'Қолдану және байланыс (U&A)',
  usage_attitude_2: 'Мақсаттардың және алып тастаулардың сипаттамасын алу',
  usage_attitude_3: 'Экспертпен сөйлесіңіз',
  usage_attitude_4: 'О',
  usage_attitude_5:
    '<b>Тұтынушылардың</b> ой-жаңағаншалықтарын талдап, олардың қалыптасуын және брендіңізбен қандай қатынасыптықтарын көзделіңіз',
  usage_attitude_6:
    '<b>`Не`</b> таңдауы туралы сілтемелі талдау арқылы тұтынушының шешімін түсініңіз',
  usage_attitude_7:
    '<b>Мүшелердің</b> брендіңізбен қандай өзара әрекет ететіндігін түсініңіз',
  usage_attitude_8:
    '<b>Таңдаушылардың</b> ой-жаңағаншалықтарын, әдеттерін және таңдауларын талдап, анықталған шешімдерді қабылдау',
  usage_attitude_9: 'Тәжірибе',
  usage_attitude_10:
    '4Service эксперттері 20 жылдан астам тәжірибелі клиенттермен жұмыс істеу арқылы сіздің бизнесіңізді дамытуға арналған универсалды жауаптарды ұсынады',
  usage_attitude_11: 'Бізбен хабарласыңыз',
  usage_attitude_12: 'Кім үшін',
  usage_attitude_13:
    'Кім көзінен бренд пайда болады және онымен байланыстырған бақылаудан?',
  usage_attitude_14: 'Көптеген салалар және қызмет көрсетушілер:',
  usage_attitude_15: '<b>Мүшелердің</b> міндеттері мен мәселелерін түсіну',
  usage_attitude_16:
    '<b>Таңдаушылардың</b> түкке асыратын мүмкіндіктерді анықтау',
  usage_attitude_17:
    '<b>Жаңа</b> өнім категориялары немесе маркетингтік стратегиялар жасау',
  usage_attitude_18:
    '<b>Серіктестік</b> ауруханасын көбейту үшін қарағандағы толық күйді тану',
  usage_attitude_19:
    'Методология сұрақтарына байланысты индивидуалды таңдалады',
  usage_attitude_20:
    '<b>Сапалы зерттеу</b> концепциялар, мәліметтер немесе тәжірибелердің түсінігі үшін сандарды жинау мен талдау арқылы алынады.',
  usage_attitude_21:
    'Көпшіліктің <b>санысын зерттеу</b> опростар, анкеттер және зерттеуден алынған сандардың саналуы арқылы орындалады.',
  usage_attitude_22:
    '<b>Деректерді топтама</b>дан кейін эксперттер ақпаратты талдау және шешімдерді жасау үшін анықтамалар қамтамасыз етеді.',
  usage_attitude_23: 'Бұл кім үшін керек',
  usage_attitude_24: 'Сіздің жетекшілік тарихыңыз бұл жерде басталады',
  usage_attitude_25:
    '<b>Сізге</b> тұтынушылардың әрекеттеріне арналған жоғары деңгейде көмектесетін көңіл-көтеруді ұсынады, олардың іс-шаралары стратегиялық жүйелерге негізделгендігі кепілдеді.',
  usage_attitude_26:
    '<b>Зерттеу</b> брендтің стратегияларын күрделі және оптимизациялау үшін құатты құрылым салады, олар қосымша тұтынушылардың қолдауы мен ұйымның өзара қатынасыптығымен көбейіп отырады.',
  usage_attitude_27: 'Шешімдер',
  usage_attitude_28: 'Біздің шешімдерімізмен көптеген мүмкіндіктерді зерттеңіз',
  usage_attitude_29: 'Категория ішінде өнімді алу мейірімі',
  usage_attitude_30:
    'Өнім категорияларында таңдаушылардың төп бағыттарын анықтаңыз, оның ішіне ауыз өнімдері, алматы тауарлар, киім және басқа да көбею.',
  usage_attitude_31: 'Таңдаушының қолдануы / қолдану мәселелері',
  usage_attitude_32:
    'Конкретті тауарлардың / қызметтердің қанша уақытта қолдануын немесе пайдалануын анализдау және олардың қолдану мәртебелері мен мезгілдерін анықтаңыз.',
  usage_attitude_33: 'Сатып алу кезіндегі әрекеті',
  usage_attitude_34:
    'Таңдаушылардың сатып алу үшін қолданған каналдарын зерттеңіз және оларға қолдау көрсететін ақпараттың көзін анықтаңыз.',
  usage_attitude_35: 'Таңдаушылардың мотивациясы мен мүмкіндіктері',
  usage_attitude_36:
    'Таңдаушылардың тұтынуын өзгертуге әкелетін мотивацияларды және бақыланушылардың әскерелерін зерттеңіз. Сатып алушылардың шешім қабылдауын өңдеу. Тауар категориясын қалай түсінуге арналған шешімдерін зерттеңіз.',
  usage_attitude_37: 'Біздің жақындық',
  usage_attitude_38: 'Брендті қолдану және онымен байланыс туралы зерттеу',
  usage_attitude_39: 'Мәліметтер',
  usage_attitude_40:
    'Көпшілікке сұраулар қолданылған сауалнамаларды қолдану арқылы жүргізіледі',
  usage_attitude_41: 'Бастау',
  usage_attitude_42:
    'Мақсаттарды белгелеу және сұраушының сұрауларына негізделген әдістерді анықтау',
  usage_attitude_43: 'Анализ',
  usage_attitude_44: 'Біздің эксперттеріміз атқарған ұлттық әрекеттер',
  usage_attitude_45:
    'Біз сіздің қолданылатын талаптарыңызға сәйкес өзіміздің қосымша құралдар жиынтығын пайдаланамыз',
  usage_attitude_46: 'CATI',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'Компьютерлік веб-сауалнама интервью - біздің құралдар жиынындағы маңызды құрал, онлайн платформалар арқылы сауалнамаларды орындау және деректерді топтауға мүмкіндік беретін специализирланған программалық жасақтама арқылы клиенттердің сауда зерттеулеріндегі міндеттері үшін ақпаратты тиімді және точны топтауға кепіл береді.',
  usage_attitude_50: 'САРІ',
  usage_attitude_51:
    'Компьютерлік жеке сауалнама - біз деректерді топтама процесстерін оптимизациялау үшін пайдаланатын әдісті пайдаланамыз, ол сауалнамаларды жақсы алу үшін пайдаланылады, онда біздің бизнес-міндеттеріңізге сапалы және тұрақты нәтижелерді береді.',
  usage_attitude_52: 'Фокус-группалар',
  usage_attitude_53:
    'Фокус-группалар - бұл біз көптеген қатысушыларды бірқатар тақырыптар немесе әзілдер туралы дерін сөйлесуді ұсынып отырамыз, онда сапалы ақпаратты топтамаға, көрініске, міндетке немесе күшіне, сондай-ақ клиенттердің шешім алу процестері мен стратегияларды жасау туралы мәліметтерді ұсынамыз.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'Жекеленген байланыс біздің қарастырудағы ерекше бөлігі, келесірек кездестіру мен сатып алушылармен таптамалы ақпарат алу үшін өзара қатынасу, доверие, түсінік және жарнама іс-шара арқылы ұйымдық құрылымдар мен бизнес қоғамдарын дамытуға және үйретуді шешу арқылы қолдау көрсететін жақындық.',
  usage_attitude_56: 'Этнографиялық зерттеу',
  usage_attitude_57:
    'Тұрғын мекенжайындағы адамдар мен мәдениеттерді зерттеу мен танымал жүргізу арқылы, көріністі, сенімділікті және әлеуметтік динамикалардың дерін ақпаратына жетуге жол беретін әдістер.',
  parthership: 'Серіктестік',
  subscribe: 'Басу арқылы жазылыңыз',
  minimum_number_characters: 'ең аз саны 2 таңба',
  request_details: 'Мәліметтерді сұрау',
  footer_7: 'Нарықты зерттеу',
  main_66:
    'Дүкеніңіз немесе брендіңіз туралы егжей-тегжейлі деректерді жинаңыз, өсу кедергілерін талдаңыз және оларды еңсерудің тиімді стратегияларын жасаңыз',
  methods_hr_1: 'Адам ресурстарын зерттеу',
  methods_hr_2:
    'Командаңыз туралы объективті түсінік алыңыз және HR жұмысын жақсарту жолын табыңыз',
  methods_hr_3: 'Сізге HR зерттеуі қажет болуы мүмкін кейбір себептер',
  methods_hr_4: 'сұхбат алған қызметкерлердің саны',
  methods_hr_5: 'сағат жобалары жүзеге асырылды',
  methods_hr_6: 'қызметкерлерді оқыту сабақтары өткізілді',
  methods_hr_7:
    'Тұтынушы тәжірибесі мен қызметкерлерді зерттеу бойынша жетекші еуропалық холдинг',
  methods_hr_8: '4сервис HR зерттеулері сандармен',
  methods_hr_9:
    'Сіздің компанияңыздың қызметкерлерінің өмірінің әр кезеңіндегі проблемалар мен әлсіз жақтарды анықтау үшін: іздеу/жұмысқа алу/онboarding/мансапты дамыту/қайта сертификаттау',
  methods_hr_10: 'Қандай жағдайлар көтерілу мен бонустарға лайық екенін білу',
  methods_hr_11:
    'Қызметкерлердің қанағаттанбауын болжау немесе шешу жолдарын ұсыну қажет',
  methods_hr_12:
    'HR зерттеулері арқылы HR саясаттарын, бағдарламаларын және тәжірибелерін бағалаудың жаңа және қазіргі әдістері мүмкін',
  methods_hr_13: 'Компания қызметкерлерінің психикалық денсаулығын жақсарту',
  methods_hr_14:
    'Егер сіз мақсатқа бағытталған тәсіл арқылы өнімділікті арттырғыңыз келсе',
  methods_hr_15:
    'Егер сізде халықаралық және/немесе қашықтағы команда болса және оны басқару қажет болса',
  methods_hr_16:
    'Сіздің жұмыс беруші брендіңіз әлеуетті қызметкерлер үшін қаншалықты тартымды екенін түсіну үшін',
  methods_hr_17: 'Қызметкерлердің қанағаттануы',
  methods_hr_18: 'HR Branding Research',
  methods_hr_19: 'Мәдени әртүрлілік',
  methods_hr_20: 'Өтемақы және жалақы жоспарлары',
  methods_hr_21: 'Топқа қатысу және адалдық',
  methods_hr_22: 'Қорғалған сынып қызметкерлері',
  methods_hr_23: 'Зерттеу салалары',
  methods_hr_24: 'Шешім 1',
  methods_hr_25: 'eNPS, қызметкерлердің қанағаттануы, қызметкерлердің адалдығы',
  methods_hr_26: 'Біз нені өлшейміз:',
  methods_hr_27: 'Адалдық:',
  methods_hr_28:
    'қызметкерлердің адалдығы, болашақ мінез-құлқын болжау, адалдыққа әсер ететін факторлардың салмағын анықтау',
  methods_hr_29: 'Қатысу:',
  methods_hr_30:
    'қызметкерлерді жұмысқа тарту, нәтижелер мен жетістіктерге қызығушылық',
  methods_hr_31: 'Қатысу:',
  methods_hr_32:
    'қызметкерлердің құндылықтарын және компания құндылықтарын анықтау',
  methods_hr_33: 'Trust 360:',
  methods_hr_34:
    'басшылыққа, әріптестерге, бағыныштыларға сенім, жұмыс берушінің стратегиялары мен саясаттарына сенім',
  methods_hr_35: 'Қанағаттану:',
  methods_hr_36:
    'әрбір компания үшін бірегей факторларды анықтау, адалдыққа әсер ететін әрбір негізгі фактор бойынша қанағаттануды бағалау',
  methods_hr_37: 'Шешім 2',
  methods_hr_38: 'Жұмыс берушінің бренді',
  methods_hr_39: 'Ішкі жұмыс беруші',
  methods_hr_40:
    'бренд талдауы (қызметкерлер, мүдделі тараптар, ішкі рекрутерлер және HR мамандарының сауалнамасы)',
  methods_hr_41: 'Сыртқы жұмыс берушіні талдау',
  methods_hr_42:
    '(бәсекелестердің EVP талдауы, сыртқы рекрутер сауалнамасы, жұмыс іздеушілер сауалнамасы)',
  methods_hr_43: 'Брендтің хабардарлығы және беделі',
  methods_hr_44: 'талдау',
  methods_hr_45: 'Жұмыс берушінің қатысуы',
  methods_hr_47: 'Жұмыс берушінің анықтамасы',
  methods_hr_48: 'жинақ',
  methods_hr_49: 'Бәсекелестік салыстыру',
  methods_hr_50: 'сияқты негізгі факторларға қатысты',
  methods_hr_51: 'Salary,',
  methods_hr_52: 'жұмыс ортасы, атмосферасы, жұмыс сипаты',
  methods_hr_53: 'Қажеттіліктер мен күтулерді талдау',
  methods_hr_54: 'жұмыс іздеушілер',
  methods_hr_55: 'Тереңдетілген сұхбаттар,',
  methods_hr_56: 'үстелдік зерттеу және сандық зерттеулер қолданылады',
  methods_hr_57: 'Шешім 3',
  methods_hr_58: 'Қызметкердің саяхат картасы/жұмбақ қызметкер',
  methods_hr_59: 'жұмыс іздеуші саяхатын анықтау',
  methods_hr_60:
    'іздеудің негізгі кезеңдері, байланыс арналары, іріктеу критерийлері және жұмыс іздеушілерді бағалау',
  methods_hr_61: 'барлық кезеңдерін бақылау',
  methods_hr_62:
    'және жұмбақ жұмыс іздеушілермен байланыс арналары (жай ғана сұхбатқа жазылу, сұхбаттасу, компанияда тағылымдамадан өту)',
  methods_hr_63: 'Сәйкестендіру',
  methods_hr_64: 'жалдау және жұмысқа қабылдау процестеріндегі әлсіздіктер',
  methods_hr_65: 'Жақсарту бойынша ұсыныстар,',
  methods_hr_66: 'сала жетекшілерімен салыстыру',
  social_responsibility_7:
    'Service Mania сізді әдеттен тыс жағдайларды қалай шешуге болатыны туралы стратегиялық ойлауға шақырады.',
  menu_22: 'Объектілерді тексеру аудиті',
  menu_23: 'Сервис дизайны',
  menu_24: 'CX',
  area: 'Аудан',
  about: 'туралы',
  monitoring: 'Бақылау',
  more: 'Көбірек',
  online: 'онлайн',
  tel: 'Тел',
  ad_testing_11: 'Асхана және қонақжайлылық',
  retail_audit_7: 'Еуропадағы CX агенттіктері',
  facility_check_audit_41:
    'Сіздің қызметкеріңіз немесе құпия сатып алушы орналасқан жерді суретке түсіреді.',
  usage_attitude_47:
    'Компьютер көмегімен телефон арқылы сұхбат алу – бұл процесті оңтайландыру және нарықты зерттеу жұмыстарының дәлдігін қамтамасыз ету үшін арнайы бағдарламалық жасақтаманы пайдалана отырып, сауалнамалар жүргізу және телефон арқылы құнды деректерді жинау үшін қолданатын әдіс.',
  thank_you_page:
    'Уақыт бөлгеніңізге рахмет! Біздің менеджер сізбен жақын арада хабарласады.',
  back_main: 'Негізгіге оралу',
  opportunities_1: 'Біздің істеріміз туралы көбірек біліңіз',
  opportunities_2: 'Ашу',
  opportunities_3: 'өзіңіз үшін',
  opportunities_4: 'мүмкіндіктер',
  opportunities_5:
    'халықаралық бизнестің 4Service ғылыми-зерттеу холдингімен бірлесіп',
  opportunities_6:
    'Бизнесіңізді қандай <span>өнімдер</span> арқылы нығайта аламыз?',
  opportunities_7: 'CX',
  opportunities_8: 'Бизнеске арналған жан-жақты теңшелген шешімдер',
  opportunities_9: 'Жұмбақ сауданың барлық түрлері',
  opportunities_10:
    'Біз жұмбақ қызметкерді, жұмбақ қоңырау шалушыны, сәнді құпиялы сатып алушыны, автокөлік құпиясын сатып алушыны және басқа түрлерін жүзеге асырамыз',
  opportunities_11: 'Бизнеске арналған IT шешімдері',
  opportunities_12:
    'AI бар жеке АТ шешімдері, кері байланыс аналитикасы және қоңырау транскрипциясы үшін платформалар',
  opportunities_13: 'Нарықты зерттеу',
  opportunities_14:
    'Кез келген іскерлік сұраулар үшін (бренд денсаулығын бақылау, сегменттеу, NPS, eNPS, CJM, өнім мен жарнама сынағы, т.б.)',
  opportunities_15: 'Аудиттер',
  opportunities_16:
    'Біз әртүрлі қызмет аудиттерін, сондай-ақ баға мониторингін (офлайн, белгілі бір тауашалар үшін және т.б.) жүргіземіз',
  opportunities_17: 'Сервис дизайны',
  opportunities_18:
    '4Service – командалар үшін корпоративтік тренингтер ұсынатын және бизнес үшін тұрақты семинарлар өткізетін DesignThinkers академиясының сертификатталған серіктестері',
  opportunities_19:
    'Біз тәжірибемізбен бөлісеміз, бірақ бизнес үдерісіңізді <span>құрметтейміз</span> және бұзбаймыз.',
  opportunities_20:
    'Біз бизнестің даму жолында кездесетін қиындықтарды білеміз және халықаралық табысты тәжірибенің арқасында бұл кедергілерді қалай еңсеруге болатынын білеміз. Сіз тәжірибені ғана емес, сонымен қатар ресурстарды да аласыз.',
  opportunities_21: 'Сіздерді ынтымақтастыққа шақырамыз!',
  opportunities_22:
    'Біз сіздің бизнесіңіз үшін <span>әріптестік бағдарламасын</span> ұсынамыз',
  opportunities_23:
    'Халықаралық мойындалған 4Service бренді арқылы сіз жаңа тұтынушыларды тартуға оң әсер ете аласыз.',
  opportunities_24:
    'Біздің серіктестеріміз оқытуды, маркетингтік материалдарды және операциялық көмекті қоса алғанда, жан-жақты қолдау алады.',
  opportunities_25:
    'Бізбен серіктестік сіздің жоспарларыңызды ағымдағы бизнес-процессіңізді бұзбай жүзеге асырады.',
  opportunities_26: 'Біздің <span>кеңселер</span>',
  opportunities_27: 'Біздің клиенттер',
  opportunities_28: 'Біздің CX-те 20 жылдан астам тәжірибеміз бар',
  opportunities_29: 'Қамтылған елдер',
  opportunities_30: 'мың',
  opportunities_31: 'Бірегей жобалар',
  opportunities_32: 'миллион',
  opportunities_33: 'Жұмбақ сатып алушылардың келулері',
  opportunities_34: 'Еуропаның ТОП 10 CX агенттіктеріне кіреді',
  opportunities_35: '4Service көмегімен сіздің мүмкіндіктеріңіз',
  opportunities_36: 'Пайданың артуы',
  opportunities_37: 'Сіз халықаралық тапсырыстарға қол жеткізе аласыз',
  opportunities_38: 'Бірегей CX тәсілі',
  opportunities_39: '20 жылдық тәжірибесі бар мамандардың қолдауы',
  opportunities_40: 'Қолдау',
  opportunities_41: 'Біздің команда сізге нәтижеге жету үшін қолдау көрсетеді',
  opportunities_42: 'Сатылымдар',
  opportunities_43: 'Біз сізге сату жүйесін орнатуға көмектесеміз',
  opportunities_44: 'Бағдарламалық құралға қол жеткізу',
  opportunities_45:
    'Сіз барлық сертификатталған АТ құралдарына қол жеткізе аласыз',
  opportunities_46: 'Тренинг',
  opportunities_47:
    'Біз сіздің қызметкерлеріңізді оқытып қана қоймай, кеңес беру қызметтерін көрсетуді жалғастырамыз',
  opportunities_48: 'Серіктестікке кім қолайлы?',
  opportunities_49:
    'Сіздің бизнесіңіз маркетингтік зерттеулермен байланысты ма?',
  opportunities_50:
    'Немесе сіз өзіңізді жаңа салада сынап көруді жоспарлап отырсыз ба',
  opportunities_51: 'жоспарлап отырсыз ба:',
  opportunities_52: 'Инновацияларды енгізу',
  opportunities_53: 'Халықаралық брендтермен жұмыс жасаңыз',
  opportunities_54: 'Өнім портфолиоңызды кеңейтіңіз',
  opportunities_55: 'Нарықтағы позицияңызды нығайтыңыз?',
  opportunities_56: 'Қызметкерлеріңізді оқытыңыз',
  opportunities_57: 'Бизнесіңізді масштабтаңыз',
  opportunities_58: 'Біздің ресурстар = Сіздің ресурстарыңыз',
  opportunities_59:
    'Біздің үлкен тәжірибемізді ескере отырып, біз оны ынтымақтастықтың бірінші кезеңінде сіздермен бөлісуге дайынбыз',
  opportunities_60: 'Деректерді талдау:',
  opportunities_61: 'Халықаралық аналитикалық топ',
  opportunities_62: 'Мәліметтерді өңдеу әдістері – SPSS, Power BI',
  opportunities_63: 'Инновациялық әдістемелер және әдістемелердің кең ауқымы',
  opportunities_64: 'Кез келген форматта есеп беру',
  opportunities_65: 'Бағдарламалық қамтамасыз ету:',
  opportunities_66: 'Жеке IT әзірлемелері',
  opportunities_67: 'CAPI үшін DigSee Sure',
  opportunities_68: 'CAWI үшін SurveyMonkey',
  opportunities_69: 'Шопметрика',
  opportunities_70: 'VoIPTime (байланыс орталығы)',
  opportunities_71: 'Маркетингтік қолдау:',
  opportunities_72: 'PR қолдау',
  opportunities_73: 'Жарнамалық және мазмұнды құруға қолдау көрсету',
  opportunities_74: 'Қорғасын өндіру процестерін орнату',
  opportunities_75: 'АТ қолдауы:',
  opportunities_76:
    'Біздің бағдарламалық құралды орнату, конфигурациялау және пайдалану бойынша техникалық қолдау.',
  opportunities_77: 'Қашықтан көмек',
  opportunities_78: 'Қауіпсіздікті бақылау',
  opportunities_79: 'Операциялық қолдау:',
  opportunities_80: 'Өріс процестерін орнатуға қолдау көрсету',
  opportunities_81: 'Алаяқтыққа қарсы жүйе',
  opportunities_82: 'Кез келген күрделіліктегі жұмысқа қабылдау',
  opportunities_83: 'Жобалық және далалық бөлімдер командасын жедел басқару',
  opportunities_84: 'Жұмысқа қабылдау сапасын бақылау',
  opportunities_85: 'UpWork',
  opportunities_86: 'Қандай бонустар аласыз?',
  opportunities_87: 'Тұтынушы базасын ұлғайту',
  opportunities_88: 'Нарық имиджін нығайту',
  opportunities_89: 'Клиенттерді жоғалту тәуекелдерін әртараптандыру',
  opportunities_90: 'Технологиялық процестерді оңтайландыру',
  opportunities_91: 'Халықаралық тәжірибе',
  opportunities_92: 'Ағымдағы тұтынушыларға көбірек сату',
  main_67:
    'Бәсекеге қабілетті бағаларды талдау ұсыныстарды оңтайландырады, кірісті арттырады және негізгі мүмкіндіктерді анықтау үшін тұтынушылардың төлеуге дайындығы туралы деректерді пайдалану арқылы нарық үлесін арттырады',
  main_68:
    'Физикалық атрибуттарды және олардың тұтынушылардың қабылдауына әсерін бағалай отырып, бөлшек сауда нүктелерінің бренд стандарттарына сәйкес келуін қамтамасыз етеді',
  main_69: 'CX шешімі',
  main_70:
    'Біздің бірегей 360 градустық CX шешімімізді ашыңыз: біз сіздің бизнесіңізді алға жылжыту мақсаттарыңызға негізделген құралдар мен қызметтерді реттейміз',
  main_71: 'Сөйлеуді талдау',
  main_72:
    'Біздің жетілдірілген сөйлеуді талдау құралы ауызша тілді мәтінге көшіреді, бұл тұтынушылар тәжірибесін жақсарту, өнімділікті бақылау, сәйкестікті қамтамасыз ету және өсуді ынталандыру үшін бизнеске баға жетпес түсінік береді',
  banner_1: 'СX консалтинг және қызметтері сіздің бизнесіңіздің 360° көрінісі',
  banner_2: 'Stay up to date with the latest research!',
  banner_3:
    'Мен құпиялылық саясатына сәйкес жеке деректерді өңдеуге келісім беремін',
  banner_4: '*Нарықты таңдаңыз',
  banner_5: 'Жазылғаныңыз үшін рахмет!',
  banner_6: 'Біз сізбен тек ең қызықты мазмұнды бөлісеміз!',
  banner_7: 'Жіберу',
  banner_8: 'Украин',
  banner_9: 'Қазақстан',
  brand_awareness_1: 'Бренд хабардарлығы',
  brand_awareness_2: 'және пайдалану',
  brand_awareness_3:
    'Бренд туралы хабардар болу әлеуетін ашыңыз және бизнестегі табысқа жету үшін пайдаланыңыз',
  brand_awareness_4: 'Сарапшымен сөйлесіңіз',
  brand_awareness_5: 'туралы',
  brand_awareness_6:
    '<b>Сіздің брендіңізді</b> тану және танысу дәрежесін бағалаңыз',
  brand_awareness_7:
    '<b>Мақсатты нарықтағы бренд</b> танымдық деңгейін анықтаңыз',
  brand_awareness_8:
    '<b>Ұстау және<b> адалдық мөлшерлемелерін мұқият қадағалаңыз',
  brand_awareness_9:
    '<b>Қажетті көрсеткіштерді жақсарту</b> үшін оңтайлы стратегияны таңдаңыз',
  brand_awareness_10:
    'Біздің шешімдерімізбен көптеген мүмкіндіктерді зерттеңіз',
  brand_awareness_11: 'Бренд хабардарлығы',
  brand_awareness_12: 'Брендті пайдалану',
  brand_awareness_13: '<b>Ашыңыз</b>тұтынушы сегменттері арасында брендті тану',
  brand_awareness_14: '<b>Бақылаңыз</b>аудиторияңыздың хабардарлық деңгейін',
  brand_awareness_15:
    '<b>Сатып</b> алу туралы тұтынушылардың стихиялық ойларын зерттеңіз',
  brand_awareness_16:
    '<b>Түсіну</b>бренд туралы хабардар болуға ықпал ететін негізгі көздер',
  brand_awareness_17:
    '<b>Брендіңіздің</b> өнімдерін немесе қызметтерін көрген тұтынушылардың санын қарастырыңыз',
  brand_awareness_18:
    '<b>Анықтаңыз</b>бастапқыда сынап көргеннен кейін сіздің брендке жабысып қалған тұтынушыларды',
  brand_awareness_19: '<b>Құлыпты ашыңыз</b> брендіңіздің ұсынылу ықтималдығы',
  brand_awareness_20:
    '<b>Сіздің брендіңізді</b>  болашақта пайдалану үшін қарастыратын тұтынушылардың пайызын ашыңыз',
  brand_awareness_21: 'Бренд туралы хабардар болу және пайдалану кімге тиімді?',
  brand_awareness_22: 'Жаңа өнімді шығаратын кәсіпорындар',
  brand_awareness_23: 'Белгіленген брендті жандандыратын кәсіпорындар',
  brand_awareness_24:
    'Өз брендін тұтынушылар қалай танитынын және пайдаланатынын түсінуге және жақсартуға ұмтылатын кез келген бизнес',
  brand_awareness_25:
    'Біздің әдістемелер бренд туралы хабардар болу мен пайдалануды оңтайландыру үшін құнды түсініктер береді',
  brand_awareness_26: 'Әдістеме клиенттің сұранысы негізінде жеке таңдалады',
  brand_awareness_27: 'Брендті пайдалану шұңқырының әдістемесі',
  brand_awareness_28:
    'Сынақ бағасы бренд туралы білетін және оның өнімдерін немесе қызметтерін қолданып көрген аудиторияның үлесін көрсетеді.',
  brand_awareness_29:
    'Қайталау көрсеткіші соңғы 12 айда сатып алуды жалғастырған немесе ұсыныстарды пайдаланған брендпен таныс және оның өнімдерін немесе қызметтерін қолданып көрген аудиторияның пайызын көрсетеді.',
  brand_awareness_30:
    'Сақтау көрсеткіші соңғы 6 айда осы ұсыныстармен айналысқан пайызды көрсете отырып, брендтің өнімдерін немесе қызметтерін үнемі пайдаланған тұлғалардың үлесін көрсетеді.',
  brand_awareness_31:
    'Ұстау деңгейі соңғы 6 айда брендтің өнімдерін/қызметтерін пайдаланған, таңдауды жалғастырған және уақыт өте брендке адалдығын көрсететін тұтынушылардың пайызын көрсетеді.',
  brand_awareness_32: 'Брендті білу әдістемесі',
  brand_awareness_33:
    'Top of mind (TOM) респондент өздігінен айтқан бірінші брендті білдіреді.',
  brand_awareness_34:
    'Толық спонтанды хабардарлық стихиялы ескертулердің, соның ішінде ТОМ-ды білдіреді.',
  brand_awareness_35:
    'Aided Awareness сұралған кезде сіздің брендіңізді пайдаланушылар қаншалықты жақсы танитынын көрсетеді.',
  brand_awareness_36: 'Бренд атрибутының өнімділік картасы',
  brand_awareness_37:
    'Бұл құрал әртүрлі бренд атрибуттарының маңыздылығын бағалайды және көрнекі түрде көрсетеді, олардың әрқайсысы сіздің брендіңіздің жалпы өнімділігіне және тұтынушылардың қабылдауына қалай ықпал ететіні туралы түсінік береді.',
  brand_awareness_38:
    'Біздің жан-жақты талдауымызбен брендіңіздің әсерін арттырудың кілттерін ашыңыз.',
  brand_awareness_39: 'Брендтердің перцептивті картасы',
  brand_awareness_40:
    'Бұл құрал бәсекелес нарықтық пейзажда тұтынушылардың қабылдауының көрнекі көрінісін ұсынады. Бұл тәсіл брендтер арасындағы айырмашылықтарды нақты анықтау, нарықтың негізгі атрибуттарын баса көрсету үшін өте маңызды.',
  brand_awareness_41:
    'Ол брендтер мен осы анықтаушы сипаттамалар арасындағы қарым-қатынастарды бақылау мен түсіндіруді жеңілдетеді.',
  brand_awareness_42:
    'Белгілі бір брендтің белгілі бір атрибуттарға жақындығы оның осы сипаттамалармен берік байланысын білдіреді. Сол сияқты, екі бренд арасындағы жақындық олардың ұқсастықтарын көрсетеді, ортақ суреттерді көрсетеді және, демек, бір нарық сегментіндегі үлестестігін көрсетеді.',
  consumer_journey_map_1: 'Тұтынушылардың саяхат картасы',
  consumer_journey_map_2:
    'Біздің тұтынушыларға саяхат картасы арқылы бизнесіңіздегі кедергілерді ашыңыз және жеңіңіз',
  consumer_journey_map_3: 'СЕНІМДІ',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'Тұтынушылар мен бренд арасындағы өзара әрекеттесуді оңтайландыру үшін CJM әлеуетін ашыңыз',
  consumer_journey_map_6:
    'Тұтынушы өнімді сатып алмас бұрын қандай қадамдар жасайтынын анықтаңыз',
  consumer_journey_map_7: 'Қиялдан емес, нақты тұтынушылардан түсінік алыңыз',
  consumer_journey_map_8:
    'Тұтынушылардың тәжірибесі туралы жан-жақты түсінік алыңыз',
  consumer_journey_map_9:
    'Жіберілген мүмкіндіктерді анықтаңыз және бәсекелестеріңізбен салыстырыңыз',
  consumer_journey_map_10: 'Біздің CJM әдісімізді ашыңыз',
  consumer_journey_map_11:
    'Біз әр түрлі арналар арқылы және белгілі бір уақыт аралығында тұтынушының өніммен, қызметпен, компаниямен немесе брендпен өзара әрекеттесу жолын жасаймыз.',
  consumer_journey_map_12:
    'Біз сіздің тұтынушыларыңыз сатып алуды аяқтамас бұрын шарлайтын кезеңдерді, әр кезеңдегі тұтынушының күтулерін, эмоцияларын және мотивацияларын сипаттаймыз.',
  consumer_journey_map_13: 'Бізбен бірге пайда алыңыз',
  consumer_journey_map_14:
    'Біз жаһандық бизнес табысының қыр-сырын түсінетін тәжірибелі мамандар командасын ұсынамыз',
  consumer_journey_map_15:
    'Біз сіздің күткеніңізден асатын нәтижелерге қол жеткізуге тырысамыз',
  consumer_journey_map_16:
    'Біз сіздің өсуіңізге ықпал ететін күрделі шешімдерді табамыз',
  consumer_journey_map_17: 'Біз теңшелген CJM шешімдерін ұсынуға маманданамыз',
  consumer_journey_map_18: 'Консультацияға тапсырыс беріңіз',
  consumer_journey_map_19: 'Деректерге негізделген шешімдер',
  consumer_journey_map_20:
    'Шешімдерді болжамдарға емес, нақты деректерге негіздеңіз',
  consumer_journey_map_21: 'CJM-ді оңтайландырыңыз',
  consumer_journey_map_22:
    'Саяхаттың әр кезеңінде олардың қажеттіліктері мен үміттерін қанағаттандыру арқылы тұтынушылармен берік қарым-қатынас орнатыңыз',
  consumer_journey_map_23: 'Жол көрсетіңіз',
  consumer_journey_map_24:
    'Өзіңізді бәсекелестеріңізбен салыстырыңыз және нарықтан алда болыңыз',
  consumer_journey_map_25: 'Ұсыныстар',
  consumer_journey_map_26:
    'Табысты ашу, тұтынушылардың адалдығын арттыру, сатуды арттыру және бизнес әлеуетіңізді арттыру үшін CJM ұсыныстарымызды орындаңыз',
  consumer_journey_map_27:
    'Тұтынушылардың саяхат картасы арқылы нақты тұтынушы саяхатын ашыңыз',
  consumer_journey_map_28:
    '20 жылдан астам тәжірибесі бар сарапшылар жан-жақты зерттеулер жүргізеді',
  consumer_journey_map_29:
    'Сапалық зерттеу тұжырымдамаларды, пікірлерді немесе тәжірибелерді түсіну үшін сандық емес деректерді жинауды және талдауды қамтиды.',
  consumer_journey_map_30:
    'Сандық зерттеу әдістері сауалнамалар, сауалнамалар және сауалнамалар арқылы алынған деректерді объективті түрде өлшеуді және сандық талдауды талап етеді.',
  consumer_journey_map_31:
    'Деректерді жинағаннан кейін сарапшылар ақпаратты талдайды және сізге ең жақсы ұсыныстарды беру үшін қорытынды жасайды.',
  boarding_1: 'Тұтынушының саяхат картасы',
  boarding_2:
    'Клиенттердің саяхат картасы (CJM) - мақсатты аудиторияны анықтау, олардың қажеттіліктері мен ортасын түсіну, содан кейін тартымды тәжірибені жеткізу жоспарын құру',
  boarding_3: 'Жарнаманың таза ұпайы',
  boarding_4:
    'Net Promoter Score (NPS) - бұл бір сұраққа негізделген тұтынушы тәжірибесі көрсеткіштерінің алтын стандарты: Ұйымды/Өнімді/Қызметті ұсыну ықтималдығы қаншалықты жоғары?',
  boarding_5: 'Бренд денсаулығын қадағалау',
  boarding_6:
    'Бренд денсаулығын бақылау (BHT) зерттеуі сіздің брендтің хабардарлық пен пайдалану, брендтің орналасуы және бренд өнімділігі бойынша қалай жұмыс істейтінін өлшей алады',
  boarding_7: 'Адам ресурстарын зерттеу',
  boarding_8:
    'Адам ресурстарын зерттеу HR тәжірибесі мен өнімділігін бағалау үшін пайдаланылады және ағымдағы даму мен басқаруға егжей-тегжейлі талдауды ұсынады',
  boarding_9: 'UX сынағы',
  boarding_10:
    'Usability (UX) сынағы - бұл нақты адамдардың веб-сайтпен, қолданбамен немесе басқа өніммен өзара әрекеттесуі және олардың мінез-құлқы мен оған реакциясын бақылайды',
  boarding_11: 'Тұтынушының қанағаттану индексі',
  boarding_12:
    'Тұтынушының қанағаттану деңгейі сіздің компания ұсынатын өнімді немесе қызметті сатып алуға қатысты тұтынушының күтулерінің қаншалықты қанағаттандырылғанын өлшейді',
  boarding_13: 'Жарнама сынағы',
  boarding_14:
    'Жарнамалық науқан - бұл үлкен инвестиция. Жарнамаларыңыз қуатты және максималды ROI беретініне көз жеткізіңіз',
  boarding_15: 'Далалық аудит/Бөлшек аудит',
  boarding_16:
    'Дүкеніңіз немесе брендіңіз туралы егжей-тегжейлі деректерді жинаңыз, өсу кедергілерін талдаңыз және оларды еңсерудің тиімді стратегияларын жасаңыз',
  boarding_17: 'Play4Sales',
  boarding_18:
    'Өнімділікті басқару бағдарламалық құралы. Сатуды ұлғайту үшін геймификацияланған қолданба',
  boarding_19: 'Voicer',
  boarding_20:
    'Кері байланысты басқару жүйесі. Тұтынушының дауысы бір жүйеде. Тұтынушының кері байланысын басқару жүйесі',
  boarding_21: 'Сапалық зерттеу',
  boarding_22:
    'Сапалық зерттеу - бұл ұғымдарды, пікірлерді немесе тәжірибені түсіну үшін сандық емес деректерді жинау және талдау',
  boarding_23: 'Сандық зерттеу',
  boarding_24:
    'Сандық зерттеу әдістері - бұл сауалнамалар, сауалнамалар және сауалнамалар арқылы жиналған мәліметтерді объективті өлшеу және сандық талдау',
  boarding_25: 'Mystery Shopping',
  boarding_26:
    'Жұмбақ сатып алу - бұл алдын ала анықталған сценарий кезінде тұтынушы мен компания немесе ұйым арасындағы өзара әрекеттесуді өлшеуге және бақылауға арналған нарықты зерттеу әдісі',
  boarding_27: 'Wantent',
  boarding_28:
    'Аудиториядан түсінік беретін AI-мен жұмыс істейтін мазмұнды талдау платформасы',
  boarding_29: 'Баға мониторингі ',
  boarding_30:
    'Баға мониторингі – бәсекелестердің бағасын жинау, өңдеу және талдау процесі',
  boarding_31: 'Сервис дизайны',
  boarding_32:
    'Сервис дизайны - бұл өнімді немесе қызметті пайдаланатын адамдардың қажеттіліктері мен тілектерін олармен уақыт өткізу арқылы түсіну жолы',
  boarding_33: 'Автокөлік өнеркәсібінің бағасын талдау',
  boarding_34:
    'Бәсекеге қабілетті бағаларды талдау ұсыныстарды оңтайландырады, кірісті арттырады және негізгі мүмкіндіктерді анықтау үшін тұтынушылардың төлеуге дайындығы туралы деректерді пайдалану арқылы нарық үлесін арттырады',
  boarding_35: 'Объектілерді тексеру аудиті',
  boarding_36:
    'Физикалық атрибуттарды және олардың тұтынушылардың қабылдауына әсерін бағалай отырып, сауда нүктелерінің бренд стандарттарына сәйкес келуін қамтамасыз етеді',
  boarding_37: 'CX шешімі',
  boarding_38:
    'Біздің бірегей 360 градустық CX шешімімізді ашыңыз: біз сіздің бизнесіңізді алға жылжыту мақсаттарыңызға негізделген құралдар мен қызметтерді реттейміз',
  boarding_39: 'Сөйлеуді талдау',
  boarding_40:
    'Біздің жетілдірілген сөйлеуді талдау құралы ауызша тілді мәтінге көшіреді, бұл тұтынушылар тәжірибесін жақсарту, өнімділікті бақылау, сәйкестікті қамтамасыз ету және өсуді ынталандыру үшін бизнеске баға жетпес түсінік береді',
  boarding_41: 'Қолдану және көзқарас',
  boarding_42:
    'Қолдану және қарым-қатынас – маркетинг пен өнім стратегияларының бейімделуіне мүмкіндік беретін практикалық пайдалану үлгілері мен психологиялық көзқарастарды талдау арқылы аудитория сіздің брендпен қалай әрекет ететінін түсінуге деген көзқарасымыз',
  boarding_43: 'Бренд туралы хабардар болу және пайдалану',
  boarding_44:
    'Брендті білу және пайдалану брендтің көрінуі мен қатысуын арттыру үшін мақсатты нарықта тануды, танысуды, өзара әрекеттесу жиілігін және ұстап тұруды бағалауды қамтиды',
  boarding_45: 'Бренд идентификациясы және позициялау',
  boarding_46:
    'Бренд идентификациясы және позициялау - бұл тұтынушылардың қабылдауын, әртүрлі аудитория көзқарастарын және брендіңіздің қалай қабылданатыны туралы түсініктерді ашатын жан-жақты талдау',
  boarding_47: 'Тұтынушы профилін жасау және сегменттеу',
  boarding_48:
    'Тұтынушы профилін жасау және сегменттеу мақсатты нарықты ортақ сипаттамаларға негізделген әртүрлі топтарға бөлуді қамтиды, бұл аудиторияның белгілі сегменттерімен резонанс жасайтын жекелендірілген стратегияларды жасауға мүмкіндік береді',
  boarding_49: 'Тұтынушылардың саяхат картасы',
  boarding_50:
    'Тұтынушы саяхатының картасы – тұтынушы сіздің өніміңізбен немесе брендіңізбен өзара әрекеттесу барысындағы кезеңдер, байланыс нүктелері, эмоциялар мен мотивациялардың көрнекі көрінісі',
  boarding_51:
    'Іске асырылатын түсініктер беруге және бизнесіңіз үшін әсерлі нәтижелерге қол жеткізуге міндеттемемізді негіздейтін инновациялық әдістер туралы біліңіз',
  boarding_52:
    'Сіздің салаңызға бейімделген деректерге негізделген интеллект байлығы бар өнімдер жиынтығын зерттеңіз, бұл сізге негізделген шешімдер қабылдауға және қисық сызықтан алда тұруға мүмкіндік береді',
  boarding_53:
    'Нарық тенденцияларына, тұтынушылардың мінез-құлқына және бәсекеге қабілетті ландшафттарға біздің нарықты зерттеудің жан-жақты шешімдерімен терең үңіліңіз',
  boarding_54: 'Арнайы зерттеу',
  boarding_55:
    'Ad Hoc Research - арнайы шешімді жасау үшін бар әдістемелердің араласуын немесе жаңа тәсілді пайдалана отырып, белгілі бір мәселені шешуге арналған теңшелген тәсіл.',
  boarding_56: 'Социологиялық зерттеулер',
  boarding_57:
    'Әлеуметтанулық зерттеулер адамның мінез-құлқы мен әлеуметтік өзара әрекеттесу үлгілерін ашады, инновациялық стратегияларды жүргізу және мақсатты аудиториямен мағыналы байланыстар құру үшін құнды түсініктер береді.',
  not_found_1: 'Ой! Біз бұл бетті таба алмаймыз.',
  not_found_2: 'Неге біздің өнімдерімізді тексермеске?',
  not_found_3: 'Кітап бойынша кеңес беру',
  customer_profiling_segmentation_1: 'Тұтынушы профилін жасау және сегменттеу',
  customer_profiling_segmentation_2:
    'Біз сізге мақсатты аудиторияңызды анықтауға көмектесіп, стратегияңызды тиімдірек етеміз',
  customer_profiling_segmentation_3:
    'Хабарламаларыңыз әрқашан мақсатты тұтынушылар топтарына тиімді жетуін қамтамасыз ету үшін нарықты сегменттеу мүмкіндігін пайдаланыңыз',
  customer_profiling_segmentation_4: 'Тұтынушыларды тереңірек түсіну',
  customer_profiling_segmentation_5:
    'Өніміңіз үшін ең жақсы мақсатты аудиторияны табыңыз',
  customer_profiling_segmentation_6: 'Тарту үшін жаңа сегменттерді зерттеңіз',
  customer_profiling_segmentation_7: 'Сатып алудағы кедергілерді табыңыз',
  customer_profiling_segmentation_8:
    'Біз арнайы сегменттеу шешімдерін жеткізуге маманданамыз',
  customer_profiling_segmentation_9: 'Бірегей тәсіл',
  customer_profiling_segmentation_10:
    'Сіздің қажеттіліктеріңізге арнайы жасалған бірегей, теңшелген сегменттеу шешімін көріңіз',
  customer_profiling_segmentation_11: 'Адамдарды мақсат ету',
  customer_profiling_segmentation_12:
    'Нарықты терең талдауға және жан-жақты зерттеулерге негізделген мақсатты тұлғалар',
  customer_profiling_segmentation_13: 'Жаңа сегменттер',
  customer_profiling_segmentation_14:
    'Ең құнды аудитория сегменттерін анықтаңыз және арнайы мақсатты бағыттаудың артықшылықтарын ашыңыз',
  customer_profiling_segmentation_15: 'Ұсыныстар',
  customer_profiling_segmentation_16:
    'Ұсыныстарымызды орындаңыз және табысқа жетіңіз, тұтынушылардың адалдығын арттырыңыз, сатылымдарды арттырыңыз және бизнес әлеуетіңізді арттырыңыз',
  customer_profiling_segmentation_17:
    '20 жылдан астам тәжірибесі бар сарапшылар жан-жақты зерттеулер жүргізеді',
  customer_profiling_segmentation_18:
    'Сапалық зерттеу тұжырымдамаларды, пікірлерді немесе тәжірибелерді түсіну үшін сандық емес деректерді жинауды және талдауды қамтиды.',
  customer_profiling_segmentation_19:
    'Сандық зерттеу әдістері сауалнамалар, сауалнамалар және сауалнамалар арқылы алынған деректерді объективті түрде өлшеуді және сандық талдауды талап етеді.',
  customer_profiling_segmentation_20:
    'Деректерді жинағаннан кейін сарапшылар ақпаратты талдайды және сізге ең жақсы ұсыныстарды беру үшін қорытынды жасайды.',
  customer_profiling_segmentation_21:
    'Біз тек өлшемдерді алып қана қоймаймыз, сонымен қатар нақты қадамдық әрекеттері бар әрекет жоспарын береміз',
  customer_profiling_segmentation_22: 'Біздің әдістеме',
  customer_profiling_segmentation_23: 'Жаккард индексі',
  customer_profiling_segmentation_24:
    'Респонденттерге тікелей сұрақ қойылғанда, олардың компания қалауы туралы жауаптары олардың нақты мінез-құлқына сәйкес келмеуі мүмкін. Тікелей сұрақ қоюдың орнына біз компания атрибуттары мен тұтынушы таңдауы арасындағы байланысты түсіну үшін статистикалық Jaccard талдауын қолданамыз.',
  customer_profiling_segmentation_25: 'Drivers',
  customer_profiling_segmentation_26:
    'Біз драйверлерді (белгілі бір нәтижеге әсер ететін факторлар) анықтаймыз және оларды маңыздылығына қарай негізгі, орташа және маңызды емес драйверлерге бөлеміз.',
  customer_profiling_segmentation_27: 'Сегменттеу',
  customer_profiling_segmentation_28:
    'Тұтынушы таңдауының айқын сипаттамалары бар сегментацияны аласыз.',
  customer_profiling_segmentation_29: 'Сегменттеуге біздің көзқарасымыз',
  customer_profiling_segmentation_30: 'Демографиялық',
  customer_profiling_segmentation_31: 'жасы',
  customer_profiling_segmentation_32: 'жыныс',
  customer_profiling_segmentation_33: 'табыс',
  customer_profiling_segmentation_34:
    'Ол өнімдерді, қызметтерді және маркетингті белгілі бір топтарға бейімдеуге, өзектілігі мен тиімділігін арттыруға көмектеседі',
  customer_profiling_segmentation_35: 'Психографиялық',
  customer_profiling_segmentation_36: 'өмір салты',
  customer_profiling_segmentation_37: 'құндылықтар',
  customer_profiling_segmentation_38: 'мінез-құлық',
  customer_profiling_segmentation_39:
    'Бұл жеке маркетингке, тұтынушылармен тереңірек байланыс орнатуға және компанияның адалдығы мен сатылымын арттыруға мүмкіндік береді',
  customer_profiling_segmentation_40: 'Мінез-құлық',
  customer_profiling_segmentation_41: 'әрекеттер',
  customer_profiling_segmentation_42: 'мотивация',
  customer_profiling_segmentation_43: 'сатып алу жиілігі',
  customer_profiling_segmentation_44:
    'Бұл мақсатты маркетингке, тұтынушылардың қанағаттануын арттыруға, компанияны ұстап тұруды арттыруға және компанияның кірістілігін арттыруға мүмкіндік береді',
  customer_profiling_segmentation_45: 'Географиялық',
  customer_profiling_segmentation_46: 'орналасуы',
  customer_profiling_segmentation_47:
    ' Ол мақсатты маркетингке, бейімделген өнімдерге, тиімді таратуға және компанияның нарыққа енуін арттыруға мүмкіндік береді.',
  brands_identity_1: 'Бренд сәйкестендіру және позициялау',
  brands_identity_2:
    'Біздің терең талдауымыз арқылы брендіңізді өзгертіңіз, тұтынушылардың қабылдауына түсініктеме беріңіз және табысқа жету стратегияңызды нақтылаңыз',
  brands_identity_3: 'Маманмен сөйлесіңіз',
  brands_identity_4: '<b>Толық</b> бренд сәйкестігін талдау',
  brands_identity_5:
    '<b>Тұтынушылардың қабылдауы</b> бойынша жинақталған түсініктерді зерттеңіз',
  brands_identity_6:
    '<b>Әртүрлі</b> мақсатты аудиторияның көзқарастарын түсіну',
  brands_identity_7:
    '<b>Тұтынушының</b> мінез-құлқы, әдеттер және негізделген шешімдерге бейімділігі туралы түсінік алыңыз',
  brands_identity_8:
    '20 жылдан астам тұтынушы тәжірибесі бар 4Service мамандары бизнесіңізді дамытуға көмектесетін бірегей шешімдер жасайды',
  brands_identity_9:
    '<b>Сіз барлық маңызды деректермен жабдықталған зерттеу пакетіне қол жеткізе аласыз.</b> Ол күш салалары мен назар аударуды қажет ететін аймақтарды бөліп көрсететін диагностикалық құрал ретінде қызмет етеді',
  brands_identity_10:
    '<b>Біздің қызметтеріміз бизнеске негізделген</b> шешімдер қабылдау, стратегияларды нақтылау және тиісті салаларда табысқа жету үшін қажетті құралдар мен қамтамасыз етеді.',
  brands_identity_11: 'Бәсекелестік нарықтағы брендтің орнын арттыру',
  brands_identity_12:
    'Кәсіпорындар өздерінің нарықтағы қатысуын арттыруға тырысады',
  brands_identity_13: 'Өз стратегиясын көтеруге ұмтылатын кәсіпорындар',
  brands_identity_14: 'Бренд идентификациясы',
  brands_identity_15: 'Брендті позициялау',
  brands_identity_16:
    '<b>Тұтынушы сегменттері бойынша брендтің</b> қабылдануын ашыңыз.',
  brands_identity_17:
    '<b>Сіздің брендіңізге және бәсекелестеріңізге</b> жататын қасиеттерді анықтаңыз.',
  brands_identity_18:
    '<b>Стратегиялық жақсарту үшін күшті</b> және әлсіз жақтарды бағалаңыз.',
  brands_identity_19:
    '<b>Бренд имиджінің</b> алға қойылған құндылықтармен теңестірілуін бағалаңыз.',
  brands_identity_20: '<b>Брендіңіздің қабылданған</b> сенімділігін бағалаңыз.',
  brands_identity_21:
    '<b>Брендіңіздің архетиптік</b> және символдық қабылдауын зерттеңіз.',
  brands_identity_22:
    '<b>Бәсекелестермен салыстырғанда брендіңіздің</b> бірегей сату нүктелерін және дифференциаторларын анықтаңыз.',
  brands_identity_23:
    '<b>Сіздің өнімдеріңізді/қызметтерді тұтынушылардың сатып алу ықтималдығына</b> әсер ететін негізгі атрибуттарды анықтаңыз.',
  brands_identity_24:
    '<b>Сіздің брендіңіздің қазіргі уақытта қалай орналасқанын анықтаңыз</b> тұтынушылардың санасында және қажетті нарық сегменттерін тарту үшін байланыс аспектілерін анықтаңыз.',
  brands_identity_25: 'Әдістеме клиенттің сұранысы негізінде жеке таңдалады',
  brands_identity_26: 'Брендті білу және пайдалану',
  brands_identity_27:
    'Бренд деңгейін бағалау бағалаудың негізгі құрамдас бөлігі ретінде қызмет ететін хабардарлық пен тұтыну деңгейлерін өлшеуді қамтиды.',
  brands_identity_28: 'Бренд жеткізу және сенім',
  brands_identity_29:
    'Бұл көрсеткіш клиенттерді қорғауды (ұсынымдарды) және брендтің уәделерді орындау, тұтынушылардың оң тәжірибесін жасау және сенім орнатудағы дәйекті қабілетін өлшейді.',
  brands_identity_30: 'Бренд кескінінің өнімділігі',
  brands_identity_31:
    'Брендтің өнімділігін бағалау оның алты маңызды құндылықпен (3 ұтымды және 3 эмоционалдық), оның санаттағы ерекшелігімен және тұтынушылар арасында мақтаныш сезімін тудыру қабілетімен байланысын бағалауды қамтиды.',
  brands_identity_32: 'Бренд денсаулық көрсеткіші',
  brands_identity_33:
    'Бренд денсаулық көрсеткіші сіздің брендіңіздің бәсекеге қабілетті ландшафтта қалай жұмыс істейтіні туралы жан-жақты түсінікті көрсетеді.',
  sociological_research_1: 'Социологиялық зерттеулер',
  sociological_research_2:
    'Біз әлеуметтік құбылыстар мен процестерге терең талдау жасаймыз, бұл бірегей аналитикалық қорытындылар мен ұсыныстардың көмегімен негізделген шешімдер қабылдауға көмектеседі',
  sociological_research_3: 'Бізбен хабарласыңы',
  sociological_research_4: 'Біздің клиенттер',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI - телефон арқылы сауалнама жүргізу үшін компьютерді пайдаланатын мәліметтерді жинау әдісі болып табылады. CATI бағдарламалық құралы деректерді жинау, жауаптарды енгізу және сауалнаманы басқару процестерін автоматтандыруға мүмкіндік береді. CATI пайдалану сауалнаманы бақылауды жеңілдетеді, алынған мәліметтерді жылдам талдауға және өңдеуге мүмкіндік береді, сонымен қатар сауалнаманың стандарттауының жоғары деңгейін қамтамасыз етеді.',
  sociological_research_7: 'СATI',
  sociological_research_8:
    'CAWI - респонденттер сауалнаманы толтыратын немесе веб-интерфейс арқылы сұрақтарға жауап беретін деректерді жинау әдісі және деректер мамандандырылған бағдарламалық қамтамасыз ету арқылы автоматты түрде жиналып, өңделеді. CAWI әдісі ауқымды сауалнамалар жүргізуге, деректерді жылдам жинауға және талдауға мүмкіндік береді.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI - бетпе-бет сауалнама деректерін жинау әдісі, онда зерттеуші респонденттердің сұрақтарға жауаптарын енгізу үшін планшетті немесе ұялы телефонды пайдаланады, бұл деректерді жинауды автоматтандыруға, енгізу қателерін азайтуға және нәтижелерді талдауды жеңілдетуге мүмкіндік береді.',
  sociological_research_11: 'Біздің мамандар әртүрлі құралдарды пайдаланады',
  sociological_research_12: 'Үлгі',
  sociological_research_13:
    'Біз кез келген күрделілік үлгілерін есептеп, қолданамыз',
  sociological_research_14:
    'Біз өз жұмысымызда қарапайым, жүйелі, стратификацияланған және кластерлік үлгілерді қолданамыз',
  sociological_research_15:
    'Ұлттық өкілдік бетпе-бет сауалнамалар үшін біз стратификацияланған көп сатылы іріктеу процедураларын қолданамыз',
  sociological_research_16:
    'Елді мекендерді аймақтар бойынша іріктеу елді мекеннің көлемі мен түріне қарай жүзеге асырылады, олардың саны әрбір аймақтағы көлеміне пропорционалды түрде анықталады',
  sociological_research_17: 'жұмсаймыз',
  sociological_research_18: 'Қоғамдық пікірді зерттеу',
  sociological_research_19: 'Әлеуметтік-экономикалық зерттеулер',
  sociological_research_20: 'Офистік оқу',
  sociological_research_21: 'Әлеуметтік қызмет көрсету сапасын бағалау',
  sociological_research_22: 'Кейс зерттеу',
  sociological_research_23: 'Персоналды зерттеу',
  sociological_research_24:
    'Белгілі бір аудиторияны зерттеу (әлсіз топтар, соның ішінде МЖҚ, әскерилер, жастар және т.б.)',
  sociological_research_25: 'Біз әр клиентпен жеке жұмыс жасаймыз',
  sociological_research_26: 'Біздің клиенттер:',
  sociological_research_27: 'Қайырымдылық қорлары',
  sociological_research_28: 'Қоғамдық ұйымдар мен кәсіподақтар',
  sociological_research_29: 'Мемлекеттік құрылымдар',
  sociological_research_30: 'Жұмысқа деген көзқарасымыз',
  sociological_research_31:
    'Біз жұмысқа ғылыми көзқарас пен қазіргі шындықты терең түсінуді, сондай-ақ деректерді жинау үшін әртүрлі зерттеу әдістерін қолданамыз.',
  sociological_research_32:
    'Біз белгілі бір сұранысты шешу үшін қажетті тәжірибесі бар тар профильді сарапшыларды тартамыз және әртүрлі салалардағы сарапшылар пулын аламыз.',
  sociological_research_33:
    'Біздің ішкі талдау бөлімі тапсырманың ерекшелігіне байланысты бірегей құралдар жиынтығын пайдаланып жиналған деректерді талдайды.',
  sociological_research_34:
    'Біз сіздің мақсатты аудиторияңыздың қажеттіліктері мен күтулерін ескере отырып, егжей-тегжейлі қорытындылар мен ұсыныстар бар есептерді жасаймыз.',
  sociological_research_35:
    'Ұсыныстарды жүзеге асыру барысында біз сізге оң өзгерістер жасауға көмектесетін кеңес пен қолдау көрсетеміз.',
  sociological_research_36: 'Теледидардағы зерттеуіміз',
  sociological_research_37: 'Біздің есептерімізді тексеріңіз',
  sociological_research_38:
    'Жұмысқа деген ғылыми көзқарасымыз біздің тұтынушыларымызға Украина мен Еуропадағы ең аз қателермен нақты және сенімді социологиялық деректерге кепілдік береді',
  sociological_research_39:
    'Біз әлеуметтанулық зерттеулер жүргізудің барлық принциптері мен этика стандарттарын және ережелерін сақтай отырып жұмыс істейміз.',
  sociological_research_40:
    'Біз Украина әлеуметтану қауымдастығының әлеуметтанушысының кәсіби этика кодексін және зерттеу жүргізудің этикалық принциптерінің Хельсинки декларациясын ұстанамыз. ESOMAR мүшелері, Украина маркетинг қауымдастығы, Украинаның Бүкіл украиналық байланыс орталықтары қауымдастығы.',
  sociological_research_41: 'Өріс',
  sociological_research_42: 'онлайн панелі',
  sociological_research_43: 'тұрақты интервьюерлер',
  sociological_research_44: 'бақылаушылар',
  sociological_research_45: 'Далалық сапаны бақылау',
  sociological_research_46: 'GPS координаттарын 100% бекіту (CAPI)',
  sociological_research_47: 'Сауалнамаларды тексеру (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: '100% сұхбат жазу (CAPI, CATI)',
  sociological_research_49:
    'Біз лицензияланған бағдарламалық құралды қолданамыз:',
  sociological_research_50:
    'Статистикалық деректерді талдауға, деректер массивін өңдеуге арналған SPSS',
  sociological_research_51:
    'CAPI үшін DigSee Sure: сауалнама логикасы, геолокация, сұхбаттардың аудио жазбасы, бейне материалдардың көрсетілімі',
  sociological_research_52:
    'SurveyMonkey for CAWI: сауалнама логикасы, ыңғайлы пішім, визуализация',
  sociological_research_53:
    'VoIPTime (байланыс орталығы): кез келген күрделіліктегі сауалнамаларды бағдарламалау, аудио жазбаларды тұтынушыға жіберу',
  sociological_research_54: 'Үлгі',
  sociological_research_55:
    'Біз кез келген күрделілік үлгілерін есептеп, қолданамыз',
  sociological_research_56:
    'Біз өз жұмысымызда қарапайым, жүйелі, стратификацияланған және кластерлік үлгілерді қолданамыз',
  sociological_research_57:
    'Ұлттық өкілдік бетпе-бет сауалнамалар үшін біз стратификацияланған көп сатылы іріктеу процедураларын қолданамыз',
  sociological_research_58:
    'Елді мекендерді аймақтар бойынша іріктеу елді мекеннің көлемі мен түріне қарай жүзеге асырылады, олардың саны әрбір аймақтағы көлеміне пропорционалды түрде анықталады',
  sociological_research_59: 'Команда',
  sociological_research_60:
    'Біздің әлеуметтанушылар Украина әлеуметтанушылар қауымдастығының мүшелері болып табылады',
  sociological_research_61:
    'Бізде әртүрлі салалардағы сандық және сапалық жобаларда тәжірибесі бар 12 толық уақытты талдаушы бар.',
  sociological_research_62:
    'Біздің 10 жылдан астам зерттеу тәжірибесі бар мамандардың қуатты аналитикалық тобы. Біздің ұжымда ғалымдар, ғылым кандидаттары, МБИ бар.',
  sociological_research_63: 'Ирина Максымюк',
  sociological_research_64:
    'Ғылыми-зерттеу бөлімінің меңгерушісі. Маркетингтік зерттеулерде 15 жылдан астам тәжірибе, барлық кезеңдердегі зерттеулерді басқару, аналитикалық есептерді дайындау, презентациялар өткізу',
  sociological_research_65: 'Андрей Билоскурский',
  sociological_research_66:
    'Бағдарламалау және мәліметтерді өңдеу бөлімінің бастығы. Маркетингтік, социологиялық және маркетингтік зерттеулердегі 20 жылдық тәжірибе',
  sociological_research_67: 'Олена Сомова',
  sociological_research_68:
    'Бағдарламалау маманы, ДонМУ-дың әлеуметтану мамандығы бойынша аспиранты. Маркетингтік зерттеулерде 5 жыл жұмыс. Әйелдердің демократиялық альянсы басқарма мүшесі, қаражат жинау бөлімінің басшысы.',
  sociological_research_69: 'Анна Падалка',
  sociological_research_70:
    'Ғылыми-зерттеу бөлімінің Әлеуметтанулық зерттеулер бөлімінің меңгерушісі, халықаралық және ұлттық деңгейде социологиялық және әлеуметтік жобалармен жұмыс істеуде 13 жылдық тәжірибесі бар.  Әлеуметтану ғылымдарының кандидаты, Украина байланыс орталықтарының Бүкіл украиндық қауымдастығының зерттеу комитетінің жетекшісі.',
  ad_hoc_1: 'Бұған',
  ad_hoc_2: 'Бірегей жағдайларға арналған балама зерттеулерімізді табыңыз',
  ad_hoc_3: 'Бізбен хабарласыңы',
  ad_hoc_4: 'Біздің көзқарасымыз',
  ad_hoc_5:
    'Біздің сарапшылар тобы жиналған деректерді мұқият талдап, өсуіңізге ықпал ететін күрделі шешімдерді ұсынады.',
  ad_hoc_6:
    'Біз сауалнамалар, сұхбаттар, фокус-топтар, деректерді талдау және т.б. қоса алғанда, әртүрлі әдіснамалардың негізінде сіздің нақты талаптарыңызға бейімделген бірегей зерттеуді әзірлейміз.',
  ad_hoc_7: 'Неліктен арнайы зерттеуді таңдау керек?',
  ad_hoc_8: 'Икемділік',
  ad_hoc_9:
    'Екі бірдей ғылыми жоба жоқ. Ad Hoc Research көмегімен бізде бірегей тәсілді қажет болған жағдайда бейімдеу және дамыту икемділігі бар, бұл сіздің түсініктеріңіздің өзекті және әрекетке жарамды болып қалуын қамтамасыз етеді.',
  ad_hoc_10: 'Дәлдік',
  ad_hoc_11:
    'Әдістемелерімізді сіздің бірегей талаптарыңызға бейімдеу арқылы біз құнды түсініктер беретін нақты және мақсатты нәтижелерді береміз.',
  ad_hoc_12: 'Инновация',
  ad_hoc_13:
    'Біз зерттеу үдерісінде инновациялар мен шығармашылықты қабылдаймыз, жасырын мүмкіндіктер мен қиындықтарды ашудың жаңа әдістері мен тәсілдерін зерттейміз.',
  ad_hoc_14: 'Уақыттылығы',
  ad_hoc_15:
    'Ad Hoc Research жылдам енгізуге мүмкіндік береді, бұл сізге маңызды түсініктерге уақтылы қол жеткізуге мүмкіндік береді және сізді салаңыздағы қисық сызықтан алда ұстайды.',
  ad_hoc_16: 'Біздің сараптама',
  ad_hoc_17:
    '20 жылдан астам нарықты зерттеу және тұтынушылар тәжірибесі бар 4Service сарапшылары бизнесіңізді дамытуға көмектесетін бірегей шешімдерді жасайды',
  ad_hoc_18:
    'Біз сіздің нақты талаптарыңызға негізделген құралдардың нақты жинағын қолданамыз',
  ad_hoc_19: 'Ешбір әдістеме сіз үшін жұмыс істемейді?',
  ad_hoc_20: 'Арнайы зерттеуді сұраңыз',
  ad_hoc_21: 'Нақты мәселеге арналған',
  ad_hoc_22:
    'Біз әдістемелердің әртүрлі бөліктерінің қоспасын, сондай-ақ мүлдем жаңа тәсілді қолданамыз',
  ad_hoc_23: 'Жеке көзқарас',
  ad_hoc_24: 'Біз шешімді тікелей мәселеңізге мұқият бейімдейміз',
  ad_hoc_25: 'Жоғары және одан жоғары өтіңіз',
  ad_hoc_26:
    'Біз сіздің бизнесіңіздің мақсаттарына жетуге көмектесетін ұсыныстары бар әрекеттік жоспарды ұсынамыз',
  ad_hoc_27: 'Сізде стандартты емес мәселе бар',
  ad_hoc_28: 'Мәселеңіз үшін әдістемелердің ешқайсысы жұмыс істемейді',
  ad_hoc_29:
    'Сіз бірден әртүрлі әдістемелерді немесе олардың бөліктерін сұрағыңыз келеді',
  ad_hoc_30: 'Арнайы зерттеулерден кім пайда көреді?',
  career: 'Мансап',
  four_opinion_1: '4Service сауалнамасы',
  four_opinion_2: 'Онлайн сауалнамалардан өтіп, үйден шықпай-ақ ақша табыңыз',
  four_opinion_3: 'Бастау',
  four_opinion_4: 'Біздің артықшылықтарымыз',
  four_opinion_5: 'Бізге сенім артады',
  four_opinion_6:
    'Біздің қауымдастық Украинада 90 мыңнан астам, ал Қазақстанда 100 мыңнан астам тұтынушыны қамтиды',
  four_opinion_7: 'Біз сіздің уақытыңызды лайықты бағалаймыз',
  four_opinion_8:
    'Біз сіздің уақытыңызды бағалаймыз, сондықтан сауалнамаларға қатысқаныңыз үшін сіз сыйлық немесе ақшалай сыйақы ала аласыз',
  four_opinion_9: 'Сіздің пікіріңіз маңызды әсер етеді',
  four_opinion_10:
    'Сіздің әрбір пікіріңіз брендтердің өз клиенттерінің қажеттіліктерін жақсырақ түсінуіне көмектеседі',
  four_opinion_11:
    '4Service-тің 4Opinion платформасында сауалнамалардан өтіп, онлайн табыс табыңыз немесе жүлде ұтып алыңыз',
  four_opinion_12: '4Opinion-ға қосылу',
  four_opinion_13: 'Біздің арнамызда одан да қызықты оқиғалар бар',
  four_opinion_14: 'Украина үшін толығырақ',
  four_opinion_15: 'Қазақстан үшін толығырақ',
  four_opinion_16: 'Неліктен бізді таңдайды?',
  four_opinion_17:
    '4Service — клиенттер тәжірибесін басқару саласындағы халықаралық зерттеу холдингі',
  four_opinion_18:
    'Біз клиенттік тәжірибені басқару бойынша Еуропадағы үздік 10 агенттіктің қатарына кіреміз',
  four_opinion_19:
    'Біздің миссиямыз – бүкіл әлем бойынша қызмет көрсетуді жақсарту!',
  four_opinion_20: 'Онлайн сауалнамалар арқылы қалай табыс табуға болады?',
  four_opinion_21: 'Сайтқа тіркеліңіз',
  four_opinion_22: 'Актуалды сауалнамалар туралы хабарлама алыңыз',
  four_opinion_23: 'Сауалнамалардан соңына дейін өтіп, ақша табыңыз',
  four_opinion_24: 'Біздің респонденттерден шынайы пікірлер',
  four_opinion_25: 'Віталя Кохан',
  four_opinion_26:
    '“Сауалнамаға қатыстым да, оны ұмытып кеттім. Біраз уақыттан кейін Наталья ханым қоңырау шалып, мен жүлде ұтып алғанымды хабарлады. Міне, менің жүлдем – Samsung Galaxy M52 5G. Үлкен рақмет😁”',
  four_opinion_27: 'Вікторія Поповська',
  four_opinion_28:
    '“Мен колонканы алдым, адал, әділ және қызықты ұтыс ойыны үшін үлкен рақмет.”',
  four_opinion_29: 'Юлія Олександрівна',
  four_opinion_30:
    '“Соңғы уақытта менімен болған ең керемет нәрсе💕 Жеңіп қана қоймай, нағыз керемет нәрсе алдым. Көп нәрсені күткен жоқпын, бірақ осындай керемет болатынын тіпті ойламадым. Тағы да үлкен рақмет”',
  four_opinion_31:
    'Тек бізбен бірге нақты ақша табуға немесе жүлде ұтып алуға мүмкіндік бар',
  four_opinion_32: 'Актуалды сауалнамаларды біздің арнадан бақылаңыз',
  four_opinion_33: 'Арнаға өту',
  cati_1: 'CATI',
  cati_2: 'Тиімді компьютерлік телефондық сауалнамалар',
  cati_3: 'Бізбен байланысу',
  cati_4: 'Бізге сенім артады',
  cati_5:
    '<b>CATI (Computer Assisted Telephone Interviewing)</b> – бұл деректерді телефон арқылы жинау әдісі, онда операторлар арнайы бағдарламалық қамтамасыз етуді пайдаланып жауаптарды тіркейді, сұрақтардың логикасын қамтамасыз етеді және нәтижелерді талдайды.',
  cati_6: '4Service ұсынған CATI-дің негізгі артықшылықтары:',
  cati_7: '<b>Жеделдік</b> – сауалнамаларды жүргізу жылдамдығы',
  cati_8: '<b>Жоғары деректер сапасы</b>',
  cati_9: '<b>Икемділік</b> – сауалнама баптауларының өзгергіштігі',
  cati_10: '<b>Процесті автоматтандыру</b>',
  cati_11:
    'Жұмыстың сапасын бақылауға арналған <b>кең ауқымды құралдар жиынтығы</b>',
  cati_12:
    '<b>Қиын қолжетімді респонденттер</b> арасында сауалнама жүргізу мүмкіндігі',
  cati_13:
    '<b>Барлық сөйлесулерді</b> <b>жазу</b> және кейін тыңдау мүмкіндігі',
  cati_14: 'Үлкен <b>мақсатты аудиторияны жылдам қамту</b> мүмкіндігі',
  cati_15:
    'Әдіс басқа ақпарат жинау тәсілдеріне қарағанда <b>экономикалық тиімді</b>',
  cati_16: 'Solves',
  cati_17: 'Телефон сауалнамасы көмегімен қандай міндеттер шешіледі:',
  cati_18:
    '<span>Нарықты сегменттеу зерттеулері.</span> Нақты маркетингтік стратегиялар мен мақсатты аудиторияны анықтау',
  cati_19:
    '<span>Клиенттердің қанағаттану деңгейін бағалау.</span> SCI, NPS индекстері арқылы тұтынушылардың адалдығын өлшеу',
  cati_20:
    '<span>NPS-менеджмент және action-жоспарды енгізу.</span> Байланыс орталығы арқылы клиенттік тәжірибені жетілдіру',
  cati_21:
    '<span>Сұраныс пен нарықтық трендтерді талдау.</span> Өнімдер мен қызметтердің танымалдылығын зерттеу, перспективті аймақтарды анықтау',
  cati_22:
    '<span>Бәсекелестік ортаны талдау.</span> Брендтің нарықтағы орнын бағалау, бәсекелестермен салыстыру және даму нүктелерін анықтау',
  cati_23: 'For whom',
  cati_24: 'CATI келесі мақсаттар үшін тамаша шешім:',
  cati_25: 'Өнім шығарғысы келетін компаниялар',
  cati_26:
    'Нарық туралы өзекті деректер жинау, бәсекелестік ортаны талдау және тұтынушылық қалауларды зерттеу',
  cati_27: 'Клиенттермен жұмыс істейтін брендтер мен компаниялар',
  cati_28:
    'Клиенттердің қанағаттану деңгейін бағалау (Customer Satisfaction, NPS), тұтынушылар қажеттіліктерін талдау және кері байланыс жинау',
  cati_29: 'Бөлшек сауда және e-commerce',
  cati_30:
    'Сатып алушылардың мінез-құлқын түсіну, жаңа өнімдерді тестілеу және сатып алу шешімдеріне әсер ететін факторларды анықтау',
  cati_31: 'Банктер мен қаржы ұйымдары',
  cati_32:
    'Көрсетілетін қызметтерге кері байланыс жинау, компанияға деген сенім деңгейін тексеру',
  cati_33: 'Әлеуметтік ұйымдар',
  cati_34: 'Қоғамдық пікірді зерттеу және әлеуметтік зерттеулер жүргізу',
  cati_35: 'Мемлекеттік мекемелер және ҮЕҰ',
  cati_36:
    'Статистикалық деректер жинау, әлеуметтік мәселелерді зерттеу және зерттеу бағдарламаларын жүзеге асыру',
  cati_37: 'Quality',
  cati_38: 'Қоңырау сапасын бағалау критерийлері',
  cati_39: 'Негізгі коммуникациялық дағдылар',
  cati_40:
    'Сәлемдесу мен әңгімені аяқтау стандарттарын сақтау, респондент үшін ыңғайлы тілге ауысу',
  cati_41: 'Қарым-қатынас стилі',
  cati_42:
    'Сөз сапасы, сыпайылық, жылы шырайлы үн және респондентпен сенімді қарым-қатынас орнату қабілеті',
  cati_43: 'Әңгіме жүргізу шеберлігі',
  cati_44:
    'Белсенді тыңдау әдістерін қолдану, респонденттің назарын сақтау және диалогты тиімді жүргізу',
  cati_45: 'Салалық білім',
  cati_46:
    'Сауалнама тақырыбын терең түсіну және респонденттің қосымша сұрақтарына дұрыс жауап беру қабілеті',
  cati_47: 'Сауалнаманы дұрыс толтыру',
  cati_48:
    'Жауаптарды дәл енгізу, нұсқауларды орындау және ақпараттың бұрмалануын болдырмау',
  cati_49: 'Why 4Service',
  cati_50: 'Неліктен 4Service-тің CATI-ін таңдайды?',
  cati_51:
    'CATI телефондық сауалнамалар арқылы нақты және құрылымдалған деректер алғысы келетін компанияларға арналған',
  cati_52: 'Өзіміздің байланыс орталығымыз бар',
  cati_53:
    'Біз 100% клиенттік сұранысты орындаумен 70 000-нан астам тиімді қоңыраулар жасадық',
  cati_54: 'Сапа кепілдігі',
  cati_55: 'Әр қоңырау 100% тексеріледі – деректердің сенімділігіне кепілдік',
  cati_56: 'Жеке тәсіл',
  cati_57: 'Жеке сұраныстарға сәйкес бірегей сауалнамалар әзірлейміз',
  cati_58: 'Қазіргі заманғы бағдарламалық қамтамасыз ету',
  cati_59:
    'Кез келген күрделіліктегі CATI сауалнамаларын өткізуге арналған VolPtime',
  cati_60: 'B2B тәжірибесі',
  cati_61:
    'Заңды тұлғалармен жұмыс істейміз, бизнестің және өнеркәсіптің әртүрлі салаларындағы жетекші мамандарды сұхбат аламыз',
  cati_62: 'Өтініш қалдырыңыз, біз сіз үшін ең жақсы шешімді таңдаймыз!',
  cati_63: 'Technology',
  cati_64:
    'Нәтижелерді талдау және бизнесіңізді жетілдіру үшін заманауи технологияларды қолданамыз',
  cati_65: 'Мүмкіндіктер:',
  cati_66: '<span>VolPtime</span> - кәсіби бағдарламалық қамтамасыз ету',
  cati_67: 'Кіріс (ыстық)/шығыс автоматтандырылған желілерді ұйымдастыру',
  cati_68:
    'Операторлар, әрбір сұраныс түрі және кеңес беру ұзақтығы бойынша статистика',
  cati_69: 'Байланыс орталығының жұмысын онлайн-мониторингтеу',
  cati_70: 'Телефон арқылы жүргізілген барлық аудиокеңестерді жазу',
  cati_71: 'Бағдарламаны қашықтан және оңай баптау',
  cati_72:
    '<span>Survey Monkey</span> - сауалнамаларды бағдарламалауға арналған кәсіби сервис',
  cati_73: 'кез келген күрделіліктегі сауалнамаларды бағдарламалау',
  cati_74: 'зерттеудің барлық қажеттіліктерін ескеру',
  cati_75: 'респонденттер үшін қарапайымдылық, түсініктілік және ыңғайлылық',
  cati_76: 'Quality',
  cati_77: 'Клиенттермен диалог сапасын бағалау',
  cati_78: 'Чек-лист бойынша бағалау жүйесі',
  cati_79:
    'Қызмет көрсету сапасы арнайы чек-лист көмегімен өлшенеді, онда сапаны бағалау мамандары есептік кезең ішінде орташа ұпай қояды',
  cati_80: 'Стандарттарды сақтау бойынша мақсатты көрсеткіштер',
  cati_81:
    'Стандарттардың орындалуы белгіленген деңгейлер бойынша бағаланады, олар 90%-дан төмен болмауы керек. Бұл көрсеткіштер қызметкердің жұмыс өтіліне байланысты түзетілуі мүмкін',
  cati_82: 'Қоңырауларды жазбада және нақты уақытта бақылау',
  cati_83:
    'Қоңыраулардың шамамен 40%-ы жазбада, ал 20%-ы нақты уақытта тыңдалады, бұл стандарттардың ықтимал бұзылуына жедел әрекет етуге мүмкіндік береді',
  cati_84: 'Experts',
  cati_85: 'Өзіміздің Байланыс Орталығымыз бар',
  cati_86: 'Байланыс орталығының жетекшісі',
  cati_87: 'Қызметкерлерді іріктеу менеджерлері',
  cati_88: 'Украинадағы қашықтан жұмыс істейтін платформа',
  cati_89: 'Қазақстандағы қашықтан жұмыс істейтін платформа',
  cati_90: 'Техникалық үйлестіруші',
  cati_91: 'Жоба менеджерлері',
  cati_92: 'Жоба менеджерлері',
  cati_93: 'Оқу және сапаны бақылау бөлімі',
  cati_94: 'Операторлар 60 адам (20%-ы ағылшын тілін меңгерген)',
  cati_95: 'Операторлар 20 адам',
  cati_96: 'Сапаны бақылау бөлімінің жетекшісі',
  cati_97: 'Қоңыраулар сапасын бақылау мамандары',
  cati_98: 'Оқыту тренерлері',
};
